export const work = {
  offlineMove: {
    saved: "تم الحفظ، وسيُرسل عند الاتصال بالإنترنت.",
  },
  whoWhen: {
    who: "من",
    when: "متى",
    whenPlaceholder: "اختر يومًا",
    change: "تغيير",
    applyToAll: "تطبيق على الكل",
    done: "تم",
    pickContractorTitle: "اختر مقاولًا",
    pickContractorsTitle: "اختر المقاولين لطلب عروض الأسعار",
    summary: {
      person: "يتولاه {{name}}",
      teamQueue: "فريقك، لم يُختر أحد بعد",
      contractor: "يتولاه {{name}}",
      pickContractor: "اختر مقاولًا",
      pickContractors: "اختر المقاولين لطلب عروض الأسعار",
      quotes_one: "اطلب عرض سعر من مقاول واحد",
      quotes_other: "اطلب عروض أسعار من {{count}} مقاولين",
      quotes_zero: "لا مقاولين",
      quotes_two: "اطلب عروض أسعار من مقاولَين",
      quotes_few: "اطلب عروض أسعار من {{count}} مقاولين",
      quotes_many: "اطلب عروض أسعار من {{count}} مقاولًا",
    },
    sheetTitle: "إنشاء عمل",
    title: "العنوان",
    brief: "الوصف",
    moreDetails: "مزيد من التفاصيل",
    create: "إنشاء",
    created: "تم إنشاء العمل وتسليمه",
    quotesSent_one: "تم إنشاء العمل. أُرسل طلب عرض سعر إلى مقاول واحد",
    quotesSent_other: "تم إنشاء العمل. أُرسلت طلبات عروض الأسعار إلى {{count}} مقاولين",
    quotesSent_zero: "تم إنشاء العمل.",
    quotesSent_two: "تم إنشاء العمل. أُرسلت طلبات عروض الأسعار إلى مقاولَين",
    quotesSent_few: "تم إنشاء العمل. أُرسلت طلبات عروض الأسعار إلى {{count}} مقاولين",
    quotesSent_many: "تم إنشاء العمل. أُرسلت طلبات عروض الأسعار إلى {{count}} مقاولًا",
    notToldTitle: "تم التعيين دون إبلاغ",
    notToldBody: "لدى {{name}} العمل لكن ليس لديه بريد إلكتروني أو حساب، لذا لم يُبلغه أحد. أبلغه بنفسك.",
    failedTitle: "تعذّر إنشاء العمل",
    failedBody: "يُرجى المحاولة مرة أخرى.",
  },
  scope: { contractorWork: "أعمال المقاول" },
  reportsTab: { all: "كل التقارير", versionsTitle: "إصدارات {{kind}}", openReport: "فتح {{kind}}", noVersions: "لا توجد إصدارات محفوظة بعد.", more: "{{n}} إضافية في {{kind}}", withSubJobs: "مهام لها مهام فرعية" },
queueRow: {
secondaryDefault: "البدء",
you: "أنت",
raisedBy: "مرفوع بواسطة {{name}}",
planned: "مخطط {{when}}",
unassigned: "غير مُكلَّف",
showFewerStatusLabels: "إظهار تسميات حالة أقل",
showMoreStatusLabels_one: "إظهار تسمية حالة إضافية واحدة: {{labels}}",
showMoreStatusLabels_other: "إظهار {{count}} تسمية حالة إضافية: {{labels}}",
moreActionsForA11y: "المزيد من الإجراءات لـ {{title}}",
secondaryActionA11y: "{{action}} {{title}}",
openItemA11y: "افتح {{title}}",
open: "فتح",
showMoreStatusLabels_zero: "لا تسميات حالة إضافية: {{labels}}",
showMoreStatusLabels_two: "إظهار تسميتي حالة إضافيتين: {{labels}}",
showMoreStatusLabels_few: "إظهار {{count}} تسميات حالة إضافية: {{labels}}",
showMoreStatusLabels_many: "إظهار {{count}} تسمية حالة إضافية: {{labels}}",
},
jobChecks: {
  inline: {
    hide: "إخفاء الإجابات",
    loading: "جارٍ تحميل الإجابات…",
    loadFailed: "تعذّر تحميل الإجابات. افتح أمر العمل مرة أخرى لإعادة المحاولة.",
    failed: "لم يجتز",
    skipped: "تم التخطي",
    photos_zero: "لا صور",
    photos_one: "صورة واحدة",
    photos_two: "صورتان",
    photos_few: "{{count}} صور",
    photos_many: "{{count}} صورة",
    photos_other: "{{count}} صورة",
  },
stageLabel: {
pre: "الفحص المسبق",
post: "الفحص اللاحق",
standalone: "فحص",
},
stageLabelLower: {
pre: "الفحص المسبق",
post: "الفحص اللاحق",
standalone: "الفحص",
},
round: "الجولة {{n}}",
noneYet: "لا شيء بعد",
removeStageA11y: "إزالة {{stage}}",
attachFailedTitle: "تم إنشاء المهمة، لكن تعذّر إرفاق {{stage}}",
attachFailedBody: "أضفه من المهمة.",
attach: {
addAs: "إضافة كـ{{stage}}",
chooseChecklist: "اختر قائمة تحقق",
attachTemplateAsA11y: "إرفاق {{name}} كـ{{stage}}",
chooseFirstA11y: "اختر قائمة تحقق أولاً",
attachAsA11y: "إرفاق كـ{{stage}}",
loadingTitle: "جارٍ تحميل قوائم التحقق…",
loadingBody: "لحظة — جارٍ جلب المكتبة.",
noMatchTitle: "لا توجد قوائم تحقق مطابقة",
noMatchBody: "جرّب بحثًا أقصر، أو امسحه لعرض كل شيء.",
emptyTitle: "لا توجد قوائم تحقق لإرفاقها بعد",
emptyBody: "يمكن استخدام أي قائمة تحقق كفحص. أنشئ واحدة وستظهر هنا.",
},
resultLabel: {
pass: "اجتاز",
flag: "تنبيه",
fail: "فشل",
},
stepCount_one: "{{completed}} من {{count}} خطوة",
stepCount_other: "{{completed}} من {{count}} خطوة",
gateReasonSingle: "يجب إكمال {{stage}} \"{{name}}\" {{verb}}.",
gateReasonMultiple: "يجب إكمال {{count}} {{noun}} {{verb}}.",
checksNoun: "فحوصات",
beforeSubmitted: "قبل تقديم أمر العمل هذا",
beforeStarted: "قبل بدء أمر العمل هذا",
gateDefaultReason: "يجب إكمال فحص أولاً.",
templateStepCount_one: "{{count}} خطوة",
templateStepCount_other: "{{count}} خطوة",
historyOneFailure: "حالة فشل واحدة خلال {{span}}.",
historyFailures_zero: "{{count}} إخفاق عبر {{span}}.",
historyFailures_one: "إخفاق واحد عبر {{span}}.",
historyFailures_two: "إخفاقان عبر {{span}}.",
historyFailures_few: "{{count}} إخفاقات عبر {{span}}.",
historyFailures_many: "{{count}} إخفاقًا عبر {{span}}.",
historyFailures_other: "{{count}} إخفاق عبر {{span}}.",
historyOneFlag: "عنصر واحد عليه تنبيه خلال {{span}}.",
historyFlags_zero: "{{count}} عنصر مُعلَّم عبر {{span}}.",
historyFlags_one: "عنصر واحد مُعلَّم عبر {{span}}.",
historyFlags_two: "عنصران مُعلَّمان عبر {{span}}.",
historyFlags_few: "{{count}} عناصر مُعلَّمة عبر {{span}}.",
historyFlags_many: "{{count}} عنصرًا مُعلَّمًا عبر {{span}}.",
historyFlags_other: "{{count}} عنصر مُعلَّم عبر {{span}}.",
historyNoFailures: "لا توجد حالات فشل عبر {{span}}.",
spanLastCheck: "آخر فحص",
spanLastChecks_zero: "آخر {{count}} فحص",
spanLastChecks_one: "آخر فحص",
spanLastChecks_two: "آخر فحصين",
spanLastChecks_few: "آخر {{count}} فحوصات",
spanLastChecks_many: "آخر {{count}} فحصًا",
spanLastChecks_other: "آخر {{count}} فحص",
completedStatus: "اكتمل {{progress}}",
notFinishedStatus: "{{progress}} - لم ينته بعد",
reworkRequested: "طُلبت إعادة العمل",
section: {
heading: "ما يحتاجه هذا العمل",
addCheckA11y: "أضف فحصاً إلى أمر العمل هذا",
addCheck: "إضافة فحص",
tryAgainA11y: "حاول تحميل الفحوصات مرة أخرى",
tryAgain: "إعادة المحاولة",
noChecksTitle: "لا توجد فحوصات على أمر العمل هذا",
headingPlan: "ما يحتاجه كل أمر عمل",
noChecksTitlePlan: "لا توجد فحوصات بعد",
noChecksBody: "قم بإرفاق قائمة مرجعية لتشغيلها قبل بدء العمل أو بعد انتهائه، وتصبح إجاباتها دليلاً على إنجاز أمر العمل هذا.",
required: "مطلوب",
round: "الجولة {{number}}",
stop: "المحطة {{number}}: {{name}}",
checkFallback: "فحص",
openCheckA11y: "{{verb}} {{stage}} {{name}}. {{progress}}.",
review: "المراجعة",
continueVerb: "متابعة",
start: "البدء",
reviewCheck: "مراجعة الفحص",
continueCheck: "مواصلة التحقق",
startCheck: "ابدأ بالفحص",
removeCheckA11y: "إزالة {{stage}} {{name}}",
remove: "إزالة",
},
stepCount_zero: "{{completed}}/{{count}}",
stepCount_two: "{{completed}}/{{count}}",
stepCount_few: "{{completed}}/{{count}}",
stepCount_many: "{{completed}}/{{count}}",
templateStepCount_zero: "لا خطوات",
templateStepCount_two: "خطوتان",
templateStepCount_few: "{{count}} خطوات",
templateStepCount_many: "{{count}} خطوة",
},
requestActivityStream: {
  tidyFailedBody: "حاول بعد قليل أو أرسلها كما هي.",
  tidyFailedTitle: "تعذر تحسين الرسالة",
  tidiedReview: "راجعها قبل الإرسال.",
  tidiedTitle: "رسالة محسّنة",
  tidyUp: "تحسين بالذكاء الاصطناعي",
  stop: "إيقاف",
  noAccountHint: "ليس لدى {{name}} حساب، لذا لن يرى الرسائل هنا. استخدم اطرح سؤالًا لمراسلته بالبريد.",
  notSent: "لم يُرسل. تحقق من اتصالك واضغط إرسال مرة أخرى.",
theRequesterDefault: "مقدّم الطلب",
theTeamDefault: "الفريق",
raisedThis: "{{who}} أثار هذا · {{time}}",
you: "أنت",
noMessagesYetOperator: "لا توجد رسائل حتى الآن — قم بالرد أدناه لبدء المحادثة.",
noMessagesYetRequester: "لا توجد رسائل حتى الآن - أرسل رسالة أدناه وسيقوم الفريق بالرد هنا.",
removePhotoA11y: "إزالة الصورة",
replyOrLogNoteA11y: "راسل مقدّم الطلب",
messageTeamA11y: "أرسل رسالة للفريق",
replyOrLogNotePlaceholder: "رسالة إلى مقدّم الطلب (يراها)…",
messageTeamPlaceholder: "رسالة للفريق…",
sending: "جارٍ الإرسال…",
send: "إرسال",
sendReplyA11y: "إرسال الرد",
signInRequiredTitle: "تسجيل الدخول مطلوب",
signInToAttachPhotos: "تسجيل الدخول لإرفاق الصور.",
uploadFailedTitle: "فشل الرفع",
couldNotAttachPhoto: "لا يمكن إرفاق الصورة.",
},
requestDetailHeader: {
noPriority: "بدون أولوية",
assetNotSet: "لم يُحدَّد الأصل",
notSet: "غير محدد",
tileLabel: {
asset: "أصل",
requester: "مُقدّم الطلب",
priority: "الأولوية",
scheduled: "مُجدوَل",
respondBy: "الرد قبل",
},
openTileA11y: "افتح {{label}}: {{value}}",
escalated: "مُصعَّد · 48 ساعة+",
nextPrefix: "التالي: ",
},
repairDecisionPanel: {
yourDecisions: "قراراتك",
progress: "قرر {{decided}} من {{total}}",
approveRecommendationTitle: "موافق على كل البنود؟",
approveRecommendationHint: "يعلّم كل البنود بالموافقة. يمكنك رفض أي منها قبل التوقيع.",
applying: "جارٍ التطبيق...",
approveRecommended: "الموافقة على الكل",
urgent: "عاجل",
highPriority: "أولوية عالية",
noEvidence: "لا يوجد دليل",
possibleDuplicate: "مكررة محتملة",
approved: "تمت الموافقة",
declined: "مرفوض",
awaitingDecision: "في انتظار القرار",
approve: "موافقة",
decline: "رفض",
approveItemA11y: "الموافقة على {{label}}",
declineItemA11y: "رفض {{label}}",
seeEvidenceA11y: "انظر الدليل على {{label}}",
openAllEvidenceA11y: "افتح جميع الأدلة على {{label}}",
evidenceThumbA11y: "{{label}} الأدلة {{number}}",
declineNoteA11y: "ملاحظة الرفض لـ {{label}}",
declineNotePlaceholder: "لماذا ترفض؟ (اختياري — تتم مشاركته مع الفريق)",
photoCount_one: "صورة واحدة",
photoCount_other: "{{count}} صورة",
videoCountClause_one: " · مقطع فيديو واحد",
videoCountClause_other: " · {{count}} مقطع فيديو",
viewDetailsClause: " · عرض التفاصيل",
approvedTotal: "الإجمالي المعتمد: {{amount}}",
nothingApprovedYet: "لا شيء تمت الموافقة عليه حتى الآن",
photoCount_zero: "لا صور",
photoCount_two: "صورتان",
photoCount_few: "{{count}} صور",
photoCount_many: "{{count}} صورة",
videoCountClause_zero: " · لا مقاطع فيديو",
videoCountClause_two: " · مقطعا فيديو",
videoCountClause_few: " · {{count}} مقاطع فيديو",
videoCountClause_many: " · {{count}} مقطع فيديو",
},
workIntelligenceActions: {
analyzeEvidence: "قراءة الصور",
useComment: "استخدم التعليق",
draftComment: "صياغة تعليق",
suggestAction: "اقتراح إجراء",
useSuggestion: "استخدم الاقتراح",
createJobFromSuggestion: "إنشاء أمر عمل من الاقتراح",
createJob: "إنشاء مهمة",
assessEvidence: "تقييم الأدلة",
useNote: "استخدم الملاحظة",
couldNotCompleteRequest: "تعذر إكمال الطلب.",
unexpectedError: "خطأ غير متوقع",
aiSuggestionWithConfidence: "اقتراح الذكاء الاصطناعي · ثقة {{percent}}٪",
aiSuggestion: "اقتراح الذكاء الاصطناعي",
priorityLabel: "الأولوية: {{priority}}",
riskLabel: "المخاطر: {{band}} ({{score}}/100)",
dismissSuggestionA11y: "تجاهل الاقتراح",
dismiss: "تجاهل",
},
reportAccessRequests: {
roleLabel: {
owner: "المالك",
tenant: "المستأجر/الشاغل",
landlord: "مالك عقار",
manager: "الوكيل الإداري",
client: "عميل",
contractor: "متعهد",
other: "أخرى",
},
headerCount_one: "طلب وصول إلى التقرير · {{count}}",
headerCount_other: "طلبات الوصول إلى التقرير · {{count}}",
someoneFallback: "شخص ما",
assetFallback: "أصل",
approve: "الموافقة",
decline: "رفض",
couldNotCompleteTitle: "تعذّر الإكمال",
tryAgainMoment: "يرجى المحاولة مرة أخرى بعد قليل.",
alreadyDecidedTitle: "تم البتّ فيه بالفعل",
alreadyDecidedMessage: "لقد قام شخص آخر بالإجابة على هذا الطلب بالفعل.",
notPermittedTitle: "غير مسموح به",
notPermittedMessage: "ليس لديك الإذن بالبت في هذا الطلب.",
accessApproved: "تمت الموافقة على الوصول إلى التقرير",
requestDeclined: "تم رفض الطلب",
headerCount_zero: "طلبات الوصول إلى التقرير · {{count}}",
headerCount_two: "طلبا وصول إلى التقرير · {{count}}",
headerCount_few: "طلبات الوصول إلى التقرير · {{count}}",
headerCount_many: "طلبات الوصول إلى التقرير · {{count}}",
},
assetRequestDetailScreen: {
actions: {
openJob: "فتح المهمة",
openInspection: "فتح الفحص",
approve: "الموافقة",
replyFirstTitle: "وضع علامة \"تم الرد\" والمتابعة؟",
replyFirstBody: "هذه الحالة بانتظار العميل. المتابعة تسجّل أنه ردّ ثم تكمل.",
replyFirstCancel: "ليس الآن",
replyFirstConfirm: "وضع علامة \"تم الرد\"",
decline: "رفض",
replied: "سجّل ردهم",
ask: "اطرح سؤالًا",
inspect: "فحص",
createWork: "إنشاء العمل",
close: "إغلاق الطلب",
},
assistant: {
title: "المساعد",
turnIntoWork: "تحويل إلى عمل",
suggestNextSteps: "اقترح الخطوات التالية",
requestAssistantTitle: "مساعد الطلب",
promptWithTitle: "ساعدني في مراجعة هذا الطلب (\"{{title}}\") وتحديد ما إذا كنت سأستفسر أو أفحص أو أنشئ عملاً أو أغلقه.",
promptDefault: "ساعدني في مراجعة هذا الطلب وتحديد ما إذا كنت سأستفسر أو أفحص أو أنشئ عملاً أو أغلقه.",
},
capture: {
notSavedTitle: "لم يُحفظ الالتقاط",
notFoundMessage: "تعذر العثور على هذا الالتقاط. يرجى التقاطها مرة أخرى.",
mismatchMessage: "هذا الالتقاط لا يطابق الطلب الحالي.",
notSupportedTitle: "الالتقاط غير مدعوم",
scanNotSupportedMessage: "يُعالَج مسح QR من الماسح الضوئي، ولا يُحفظ في الطلبات.",
tryAgain: "تحقق من اتصالك وحاول مرة أخرى.",
noPhotoCaptured: "لم يتم التقاط أي صورة.",
signInToAttachPhotos: "تسجيل الدخول لإرفاق الصور.",
couldNotUploadPhoto: "تعذر تحميل الصورة.",
noCommentTextCaptured: "لم يتم التقاط نص التعليق.",
modeNotSupported: "وضع الالتقاط هذا غير مدعوم للطلبات.",
photoAdded: "تمت إضافة الصورة إلى الطلب",
commentAdded: "تمت إضافة تعليق إلى الطلب",
measurementAdded: "تمت إضافة القياس إلى تعليقات الطلب",
measurementCommentTemplate: "القياس: {{reading}}",
},
toast: {
approved: "تمت الموافقة على الطلب وإبلاغ مقدّمه. بعد ذلك اضغط إنشاء العمل أو فحص لتخطيطه.",
declined: "تم رفض الطلب. تم إبلاغ مقدّمه.",
caseClosed: "تم إغلاق الطلب. تم إبلاغ مقدّمه.",
replyRecorded: "تم تسجيل الرد. عاد الطلب إليك لمتابعته.",
messageSent: "تم إرسال السؤال. ينتظر الطلب ردهم، وسيتم إبلاغك عند الرد.",
caseReopened: "أُعيد فتح الطلب. عاد إلى العمل ضمن يحتاج إليك.",
},
screenTitle: "الطلب",
loadingMessage: "جارٍ تحميل الطلب...",
notFoundMessage: "لم يتم العثور على الطلب",
notFoundHint: "ربما تمت إزالة هذا الطلب أو ربما لا يمكنك الوصول إليه.",
requestFallbackTitle: "طلب",
reopenFailedTitle: "تعذرت إعادة فتح الطلب",
},
requestCaseLinkedWork: {
statusLabel: {
scheduled: "مُجدوَل",
toSchedule: "للجدولة",
due: "مستحق",
overdue: "متأخر",
inProgress: "قيد التنفيذ",
paused: "متوقف مؤقتًا",
submitted: "مُرسَل",
completedAwaitingSignoff: "مكتمل — في انتظار الاعتماد",
done: "تم",
reworkInProgress: "جاري العمل على إعادة العمل",
cancelled: "ملغى",
pending: "قيد الانتظار",
},
reportStatus: {
sharedReadyForReview: "تمت المشاركة — جاهز للمراجعة",
approved: "تمت الموافقة",
changesRequested: "طُلب إجراء تغييرات",
reviewed: "تمت المراجعة",
},
provenance: {
youApproved: "لقد وافقت على هذا العمل",
approvedByRequester: "تمت الموافقة عليه من قِبل مقدّم الطلب",
youDeclined: "لقد رفضت هذا — اذكر ذلك في المحادثة",
declinedByRequester: "رفضه مقدّم الطلب",
followUpProposed: "متابعة مقترحة من قبل الفريق",
followUpJob: "مهمة متابعة",
addedByTeamNotFromReview: "تمت الإضافة بواسطة الفريق — وليس من مراجعتك",
addedByTeam: "أضافه الفريق",
},
repair: {
fallbackLabel: "الإصلاح {{number}}",
approved: "تمت الموافقة",
declined: "مرفوض",
awaitingDecision: "في انتظار القرار",
jobState: "أمر العمل: {{status}}",
noJobYet: "لا يوجد أمر عمل حتى الآن",
},
heading: "العمل المرتبط",
inspectionTitle: "تفتيش",
completed: "مكتمل",
jobFallbackTitle: "مهمة",
reportTitle: "تقرير الفحص",
youAcceptedAwaitingTeam: "لقد قبلت — في انتظار تأكيد الفريق",
acceptedByRequesterVerify: "قبله مقدّم الطلب — تحقّق منه لإغلاقه",
visitConfirmed: "تم تأكيد الزيارة",
visitConfirmedByRequester: "أكّد مقدّم الطلب الزيارة",
confirmVisitBelow: "قم بتأكيد الزيارة أدناه",
awaitingRequesterVisitConfirmation: "بانتظار تأكيد زيارة مقدم الطلب",
photoCount_one: "صورة واحدة",
photoCount_other: "{{count}} صورة",
approvedRepairsAwaitingJobs_one: "إصلاح معتمد واحد بانتظار أوامر عمل",
approvedRepairsAwaitingJobs_other: "{{count}} إصلاح معتمد بانتظار أوامر عمل",
createApprovedJobs_one: "إنشاء أمر عمل معتمد واحد",
createApprovedJobs_other: "إنشاء {{count}} أمر عمل معتمد",
confirmVisit: "تأكيد الزيارة",
confirmVisitA11y: "أكّد أن أحدًا سيكون موجودًا للزيارة",
requestDifferentTime: "اطلب وقتًا مختلفًا",
requestDifferentTimeA11y: "اطلب وقت زيارة مختلف",
reviewCompletionReport: "مراجعة تقرير الإكمال",
reviewAndSignOff: "مراجعة واعتماد",
viewCompletionReport: "عرض تقرير الإكمال",
openCompletionReportA11y: "افتح تقرير إكمال أمر العمل",
acceptCompletion: "قبول العمل",
acceptCompletionA11y: "قبول العمل المكتمل",
requestRework: "إعادة للتعديل",
requestReworkA11y: "إعادة المهمة لإصلاحها",
createJobsFromRepairsA11y: "إنشاء أوامر العمل من الإصلاحات المعتمدة",
viewReportResponse: "عرض استجابة التقرير",
reviewSharedReport: "مراجعة التقرير المشترك",
viewYourReportResponseA11y: "عرض استجابة التقرير الخاص بك",
reviewSharedReportA11y: "قم بمراجعة التقرير المشترك",
photoCount_zero: "لا صور",
photoCount_two: "صورتان",
photoCount_few: "{{count}} صور",
photoCount_many: "{{count}} صورة",
approvedRepairsAwaitingJobs_zero: "لا إصلاحات معتمدة بانتظار أوامر عمل",
approvedRepairsAwaitingJobs_two: "إصلاحان معتمدان بانتظار أوامر عمل",
approvedRepairsAwaitingJobs_few: "{{count}} إصلاحات معتمدة بانتظار أوامر عمل",
approvedRepairsAwaitingJobs_many: "{{count}} إصلاحًا معتمدًا بانتظار أوامر عمل",
createApprovedJobs_zero: "لا أوامر عمل معتمدة لإنشائها",
createApprovedJobs_two: "إنشاء أمري عمل معتمدين",
createApprovedJobs_few: "إنشاء {{count}} أوامر عمل معتمدة",
createApprovedJobs_many: "إنشاء {{count}} أمر عمل معتمدًا",
},
detailRoute: {
notFoundTitle: "تفاصيل العمل",
notFoundMessage: "لم يتم العثور على عنصر العمل",
notFoundHint: "افتح أمر العمل أو الفحص هذا من العمل أو الأصول أو رابط مشترك صالح.",
},
kanbanSwimlanes: {
emptyDefault: "لا توجد عناصر في طريقة العرض هذه.",
unassigned: "غير مُكلَّف",
assetColumnHeader: "أصل",
},
queueCardGrid: {
emptyDefault: "لا توجد عناصر في قائمة الانتظار",
open: "فتح",
start: "البدء",
openItemA11y: "افتح {{title}}",
startItemA11y: "بدء {{title}}",
},
statusTransitionBar: {
currentA11y: "الحالة: {{label}}",
moveToA11y: "انتقل إلى {{label}}",
changeStatusA11y: 'الحالة: {{label}}. تغيير الحالة',
sheetTitle: 'تغيير الحالة',
},
stall: {
days_zero: "أقل من يوم",
days_one: "يوم واحد",
days_two: "يومين",
days_few: "{{count}} أيام",
days_many: "{{count}} يومًا",
days_other: "{{count}} يوم",
waitingOnYourApproval: "بانتظار موافقتك منذ {{span}}.",
waitingOnYourValidation: "بانتظار تصديقك منذ {{span}}.",
noResponseFrom: "لا رد من {{name}} منذ {{span}}.",
notValidated: "لم يصدّق {{name}} على هذا منذ {{span}}.",
notApproved: "لم يوافق {{name}} على هذا منذ {{span}}.",
theRecipient: "المستلم",
theRequester: "مقدّم الطلب",
theApprover: "المعتمِد",
theValidator: "مسؤول التصديق",
approveOnTheirBehalf: "الموافقة نيابةً عنهم",
validateInTheirPlace: "التصديق نيابةً عنهم",
hintDecide: "بصفتك فريق الأصل يمكنك اتخاذ القرار نيابةً عنهم. يُسجَّل أيٌّ من الخيارين على أنه تم نيابةً عنهم.",
hintValidate: "بصفتك فريق الأصل يمكنك التصديق على هذا نيابةً عنهم.",
hintSignOff: "بصفتك فريق الأصل يمكنك اعتماد هذا نيابةً عنهم.",
saving: "جارٍ الحفظ…",
},
triageInbox: {
titleDefault: "جديد",
emptyLabelDefault: "لا توجد طلبات جديدة.",
cleared: "تم البت في جميع الطلبات",
approve: "الموافقة",
reject: "رفض",
},
nameTypeFilter: {
typeDefault: "النوع",
pickerTitleDefault: "تصفية حسب النوع",
any: "أي",
typeA11y: "{{label}}: {{value}}",
},
sortMenu: {
triggerA11y: "الترتيب: {{label}}",
sortBy: "الترتيب حسب",
},
viewToggle: {
cards: "بطاقات",
table: "جدول",
kanban: "كانبان",
calendar: "التقويم",
},
attentionReasons: {
OVERDUE: "متأخر",
AWAITING_YOU: "في انتظارك",
AWAITING_OTHER: "في انتظار شخص آخر",
UNSCHEDULED: "لم يُجدول بعد",
DUE_SOON: "يحل قريبًا",
URGENT_PRIORITY: "معلَّم كعاجل",
APPROVAL_REQUIRED: "في انتظار موافقتك",
REVIEW_REQUIRED: "في انتظار مراجعتك",
REPAIR_JOBS_REQUIRED: "الإصلاحات المعتمدة تحتاج إلى مهام",
STALLED: "لا يوجد رد — يمكنك التدخل",
},
list: {
  board: {
    moveItemA11y: "نقل {{title}}",
    moveSelectedA11y: "نقل {{n}} إلى {{column}}",
    bulkSummaryBlocked: "نقل {{n}} إلى {{column}}. لا يمكن نقل {{blocked}} من حالتها الحالية.",
    bulkSummary: "نقل {{n}} إلى {{column}}.",
    requestMoveReason: "تتقدم الطلبات بالموافقة عليها أو رفضها أو تحويلها، افتح الطلب لتقرر.",
    inspectionMoveReason: "تتقدم الفحوصات بتنفيذها، افتح الفحص للمتابعة.",
    moveNotAllowedTitle: "النقل غير مسموح",
    moveNotAllowed: "هذا النقل غير مسموح.",
    cannotMoveStraight: "لا يمكن نقل العمل من «{{from}}» إلى «{{to}}» مباشرة.",
  },
  selectedA11y: "محدد",
  emptyState: {
    showMeHow: "أرني كيف",
    scheduleInspection: "جدولة فحص",
    none: "لا يوجد عمل هنا بعد. جدوِل فحصًا للبدء.",
    showAll: "عرض كل العمل",
    review: "لا شيء ينتظر المراجعة.",
    due_soon: "لا شيء مستحق قريبًا.",
    mine: "لا شيء مُسند إليك الآن.",
    needs_attention: "لا شيء يحتاجك الآن.",
    clearFilters: "مسح عوامل التصفية",
    filtered: "لا شيء يطابق اختياراتك في «تصفية».",
  },
simpleStatus: {
  todo: "للتنفيذ",
  in_progress: "قيد التنفيذ",
  waiting: "في الانتظار",
  done: "منجز",
  waitingFor: "في انتظار {{name}}",
  waitingOn: "في الانتظار · {{who}}",
  waitingForAssignee: "في انتظار المكلّف",
  waitingForRequester: "في انتظار مقدّم الطلب",
  waitingForReview: "في انتظار المراجعة",
  waitingForQuotes: "في انتظار عروض الأسعار",
  waitingForApproval: "في انتظار الموافقة",
},
quickView: {
needs_attention: "يحتاج إليك",
mine: "عملي",
due_soon: "يحل قريبًا",
review: "مراجعة",
all: "الكل",
},
reviewScope: {
  yours: "الخاصة بك",
  everyone: "الجميع",
},
view: {
  calendarShort: "التقويم",
  listShort: "قائمة",
  title: "العرض",
cards: "عرض القائمة",
calendar: "عرض التقويم",
},
type: {
request: "الطلبات",
inspection: "الفحوصات",
job: "المهام",
},
sort: {
urgency: "الاستعجال",
due: "تاريخ الاستحقاق",
updated: "آخر تحديث",
priority: "الأولوية",
created: "الأحدث",
},
group: {
asset: "الأصل",
site: "الموقع",
assignee: "المكلَّف",
status: "الحالة",
type: "النوع",
none: "بلا",
},
groupUrgent_zero: "{{count}} عاجل",
groupUrgent_one: "{{count}} عاجل",
groupUrgent_two: "{{count}} عاجل",
groupUrgent_few: "{{count}} عاجل",
groupUrgent_many: "{{count}} عاجل",
groupUrgent_other: "{{count}} عاجل",
groupByLabel: "التجميع: {{axis}}",
groupByTitle: "تجميع العمل حسب",
collapseAll: "طي الكل",
expandAll: "توسيع الكل",
collapseGroup: "طي {{name}} ({{count}})",
expandGroup: "توسيع {{name}} ({{count}})",
groupOverdue: "متأخر: {{count}}",
groupNeedsYou: "بانتظارك: {{count}}",
groupDueSoon: "مستحق قريبًا: {{count}}",
groupNew: "جديد: {{count}}",
groupTypeDocument: "المستندات",
groupNone: { asset: "بدون أصل", site: "بدون موقع", assignee: "غير مُسند" },
newLane: { title: "جديد منذ آخر زيارة", more: "عرض {{count}} أخرى", fewer: "عرض أقل" },
openAsset: "فتح {{name}}",
report: {
all: "أي",
has_report: "يحتوي على تقرير",
awaiting_review: "في انتظار المراجعة",
signed_off: "موقَّع عليه",
},
refine: {
button: "تصفية",
output: "النتيجة",
type: "النوع",
asset: "الأصل",
site: "الموقع",
assignee: "المكلَّف",
unassigned: "غير مُكلَّف",
urgency: "الاستعجال",
status: "الحالة",
review: "المراجعة",
reviewToggle: "يتطلب مراجعتي",
time: "الوقت",
renewals: "التجديدات",
renewalsToggle: "إظهار التجديدات",
sortBy: "ترتيب حسب",
anyAsset: "أي أصل",
unnamedSite: "موقع بلا اسم",
unnamedAssignee: "شخص بلا اسم",
anySite: "أي موقع",
anyone: "أي شخص",
assigneeFacetTeam: "الفريق",
assigneeFacetExternal: "خارجي",
selectedCount_zero: "تم تحديد {{count}}",
selectedCount_one: "تم تحديد {{count}}",
selectedCount_two: "تم تحديد {{count}}",
selectedCount_few: "تم تحديد {{count}}",
selectedCount_many: "تم تحديد {{count}}",
selectedCount_other: "تم تحديد {{count}}",
searchPlaceholder: "بحث…",
searchAssetPlaceholder: "البحث عن الأصول…",
removeAsset: "إزالة {{name}}",
searchSitePlaceholder: "البحث عن المواقع…",
searchAssigneePlaceholder: "البحث عن الأشخاص…",
noMatches: "لا توجد نتائج مطابقة.",
clear: "مسح",
clearSelection: "مسح التحديد",
done: "تم",
},
timePreset: {
overdue: "متأخر",
today: "اليوم",
next_7: "الأيام السبعة القادمة",
},
urgencyBand: {
critical: "حرج",
high: "مرتفع",
medium: "متوسط",
low: "منخفض",
},
status: {
triage: "جديد",
scheduled: "مُجدوَل",
in_progress: "قيد التنفيذ",
awaiting_review: "في انتظار المراجعة",
done: "تم",
cancelled: "ملغى",
},
kanbanEmpty: {
triage: "لا توجد طلبات جديدة.",
scheduled: "لا يوجد شيء مُجدوَل.",
in_progress: "لا يوجد شيء قيد التنفيذ.",
awaiting_review: "لا يوجد شيء في انتظار المراجعة.",
done: "لم يتم إنجاز شيء بعد.",
cancelled: "لا يوجد شيء ملغى.",
board: "لا عمل جارٍ في هذا العرض.",
},
due: {
  inDays: "يحل خلال {{n}} ي",
  overdueDays: "متأخر {{n}} ي",
overdue: "متأخر",
today: "يحل اليوم",
tomorrow: "يحل غدًا",
onDate: "يحل في {{date}}",
},
badge: {
urgency: {
critical: "عاجل",
high: "مرتفع",
},
rework: "أُعيد",
quotesDeclined: "رُفضت جميعها",
quotesWaiting: "في انتظار عروض الأسعار",
awaitingRequester: "في انتظار مُقدّم الطلب",
subJobsDone: "أُنجزت {{done}} من {{total}} مهام فرعية",
subJobNeedsYou: "مهمة فرعية تحتاجك",
partOf: "جزء من {{title}}",
partOfAJob: "جزء من مهمة أكبر",
confirmVisit: "تأكيد الزيارة",
visitUnconfirmed: "الزيارة غير مؤكدة",
acceptancePending: "قبول أو رفض",
awaitingAcceptance: "في انتظار القبول",
awaitingVerification: "في انتظار التحقق",
quoteInvited: "دعوة لتقديم عرض سعر",
attention: {
overdue: "متأخر",
awaiting_you: "في انتظارك",
stalled: "متوقف",
unscheduled: "غير مُجدوَل",
expiring_soon: "يحل قريبًا",
},
column: {
triage: "مفتوح",
scheduled: "مُجدوَل",
in_progress: "قيد التنفيذ",
awaiting_review: "في انتظار المراجعة",
},
review: {
awaiting_your_approval: "الموافقة",
you_must_review: "مراجعة",
awaiting_recipient: "في انتظار الرد",
changes_requested: "طُلب إجراء تغييرات",
},
report: {
awaiting_repairs_conversion: "إصلاحات معتمدة",
pending_signoff: "التقرير جاهز",
signed_off: "موقَّع عليه",
},
done: {
completed: "مُغلق",
verified: "موقَّع عليه",
rejected: "مرفوض",
cancelled: "ملغى",
superseded: "استُبدل",
skipped: "تم تخطيه",
},
},
empty: "لا يوجد شيء هنا حاليًا.",
emptyReports: "لا توجد تقارير هنا بعد. يظهر التقرير بمجرد أن يكون لفحص أو مهمة تقرير.",
previewEmpty: "حدد مهمة أو طلبًا لإدارته هنا.",
loadError: "تعذّر تحميل بعض عناصر العمل ({{sources}}).",
retry: "إعادة المحاولة",
loadingA11y: "جارٍ تحميل العمل",
preview: {
kind: {
job: "مهمة",
request: "طلب",
inspection: "فحص",
schedule: "فحص",
document: "مستند",
},
asset: "الأصل",
status: "الحالة",
due: "تاريخ الاستحقاق",
noDue: "بلا تاريخ استحقاق",
assigned: "مُكلَّف",
unassigned: "غير مُكلَّف",
site: "الموقع",
report: "التقرير",
reportAvailable: "متاح",
reportNone: "غير متاح",
openFull: "فتح السجل الكامل",
openFullKind: "فتح {{kind}}",
pin: "تثبيت اللوحة",
unpin: "إلغاء تثبيت اللوحة",
collapse: "طي اللوحة",
},
},
aiNextSteps: {
summaryReady: "{{ready}} من {{total}} جاهزة للتنفيذ",
createdMore: "+{{count}} إضافية",
openCreatedA11y: "فتح {{label}}",
recordKind: {
job: "عرض المهمة",
inspection_schedule: "عرض التفتيش المجدول",
request: "عرض الطلب",
template: "عرض قائمة التحقق",
},
title: "الخطوات التالية المقترحة",
planning: "جارٍ تحديد أفضل الخطوات التالية…",
running: "جارٍ تنفيذ الخطوات المؤكدة…",
empty: "لا يوجد ما يلزم فعله هنا حاليًا.",
doAll: "تنفيذ الكل ({{total}})",
doStep: "تنفيذ",
doStepA11y: "تنفيذ هذه الخطوة: {{step}}",
retry: "إعادة المحاولة",
dismiss: "إخفاء",
errorFallback: "تعذّر اقتراح خطوات تالية.",
blocked: {
advisory: "إرشاد فقط — لا يوجد ما يُنفَّذ تلقائيًا.",
missingDetails: "تنقص بعض التفاصيل قبل إمكانية التنفيذ.",
},
outcome: {
executed: "تم",
failed: "لم تكتمل هذه الخطوة.",
},
results: {
allDone: "اكتملت جميع الخطوات المؤكدة ({{total}}).",
partial: "{{executed}} اكتملت، {{failed}} فشلت.",
},
confirm: {
title: "تأكيد ما سيحدث",
intro: "سيتم تنفيذ ما يلي الآن وسيغيّر سجلاتك ({{total}}):",
noDetail: "لا توجد تفاصيل إضافية.",
run: "تنفيذ الآن",
cancel: "إلغاء",
},
},
workflow: {
actions: {
requestedReview: "طُلبت المراجعة",
approvedRepairs: "إصلاحات معتمدة",
assignedWork: "تم تكليف العمل",
scheduleProposed: "اقتُرح جدول",
workStarted: "بدأ العمل",
workPaused: "أُوقف العمل مؤقتًا",
workResumed: "استُؤنف العمل",
completionSubmitted: "أُرسل الإنجاز",
reworkRequested: "طُلبت إعادة العمل",
workApproved: "تمت الموافقة على العمل",
jobAccepted: "تم قبول المهمة",
jobDeclined: "تم رفض المهمة",
quoteRequestSent: "أُرسل طلب عرض السعر",
quoteSubmitted: "أُرسل عرض السعر",
quoteAccepted: "تم قبول عرض السعر",
quoteRejected: "تم رفض عرض السعر",
contractorAwarded: "تم ترسية العمل على المتعهد",
},
},
search: {
title: "البحث في العمل",
placeholder: "البحث في الفحوصات، المهام، الطلبات، أو الأصول",
triggerA11y: "البحث في العمل",
triggerHint: "البحث في الفحوصات، المهام، الطلبات، أو الأصول",
inputA11y: "البحث في الفحوصات، المهام، الطلبات، أو الأصول",
closeA11y: "إغلاق البحث في العمل",
clearA11y: "مسح البحث في العمل",
scope: {
all: "الكل",
inspections: "الفحوصات",
jobs: "المهام",
requests: "الطلبات",
},
scopeActive: "{{type}} فقط ✕",
groups: {
inspection: "الفحوصات",
job: "المهام",
request: "الطلبات",
asset: "الأصول",
contact: "جهات الاتصال",
},
refine: "تصفية",
refineCount: "تصفية {{count}}",
refineA11y_zero: "تصفية البحث في العمل، لا توجد فئات تصفية نشطة",
refineA11y_one: "تصفية البحث في العمل، فئة تصفية نشطة واحدة",
refineA11y_two: "تصفية البحث في العمل، فئتا تصفية نشطتان",
refineA11y_few: "تصفية البحث في العمل، {{count}} فئات تصفية نشطة",
refineA11y_many: "تصفية البحث في العمل، {{count}} فئةَ تصفية نشطة",
refineA11y_other: "تصفية البحث في العمل، {{count}} فئة تصفية نشطة",
clearFilters: "مسح الكل",
filters: {
state: "الحالة",
scope: "النطاق",
all: "الكل",
open: "مفتوح",
completed: "مكتمل",
mine: "مُسنَد إليّ",
team: "فريقي",
needsAttention: "يحتاج إلى اهتمام",
},
minimumTitle: "البحث في كل العمل",
recentsTitle: "الأخيرة",
recentsClear: "مسح",
pinA11y: "تثبيت للحفاظ عليه في الأعلى",
unpinA11y: "إلغاء التثبيت",
minimumBody: "أدخل حرفين على الأقل للبحث في الفحوصات والمهام والطلبات والأصول المصرَّح بها.",
loading: "جارٍ البحث في العمل…",
errorTitle: "البحث غير متاح",
errorBody: "تعذّر البحث في العمل. تحقق من اتصالك وحاول مرة أخرى.",
noResultsTitle: "لا يوجد عمل مطابق",
noResultsBody: "جرّب عنوانًا أو مرجعًا أو أصلًا أو موقعًا أو مكلَّفًا مختلفًا.",
viewAll: "عرض الكل",
viewAllA11y: "عرض جميع نتائج {{type}}",
result: {
type: {
inspection: "فحص",
job: "مهمة",
request: "طلب",
asset: "الأصل",
contact: "جهة اتصال",
},
statusA11y: "الحالة {{status}}",
dateA11y: "التاريخ {{date}}",
assigneeA11y: "مُسنَد إلى {{name}}",
},
},
hub: {
title: "العمل",
impactTitle: "بعض الأصول فقط",
impactBody_one: "تعرض هذه القائمة عمل أصل واحد فقط.",
impactBody_other: "تعرض هذه القائمة عمل {{count}} أصل فقط.",
impactClear: "عرض الكل",
impactClearA11y: "عرض العمل لكل الأصول",
tablistLabel: "تصفية العمل حسب النوع: التفتيشات أو المهام أو الطلبات",
emptyViewAll: "عرض الكل",
segments: {
queue: "قائمتي",
inspections: "التفتيشات",
jobs: "المهام",
approvals: "الموافقات",
requests: "الطلبات",
templates: "قوائم تحقق الفحص",
},
hints: {
queue: "عرض العمل ذي الأولوية (تفتيشات ومهام وعناصر بانتظار قرارك)",
inspections: "عرض التفتيشات والمراجعات والجداول",
jobs: "عرض المهام وقائمة انتظار العمل",
approvals: "مراجعة الطلبات الواردة والعمل المكتمل الذي ينتظر قرارًا",
requests: "فرز الطلبات الواردة؛ الموافقة عليها أو جدولتها أو تحويلها إلى فحوصات أو مهام",
templates: "قوائم تحقق للفحص قابلة لإعادة الاستخدام",
inspectionsFilter: "تصفية العمل إلى التفتيشات والمراجعات والجداول. اختر مرة أخرى لعرض كل ما يحتاج إليك.",
jobsFilter: "تصفية العمل إلى المهام. اختر مرة أخرى لعرض كل ما يحتاج إليك.",
requestsFilter: "تصفية العمل إلى الطلبات الواردة. اختر مرة أخرى لعرض كل ما يحتاج إليك.",
},
secondaryLabel: "ثانوي",
workflowLibrary: "قوائم التحقق",
workflowLibraryShort: "قوائم التحقق",
workflowLibraryHint: "قوائم تحقق للفحص قابلة لإعادة الاستخدام",
workflowLibraryA11y: "فتح قوائم التحقق",
workflowLibraryBack: "العودة إلى العمل",
workflowLibraryBackHint: "مغادرة قوائم التحقق",
workflowLibraryBackA11y: "العودة إلى قائمة انتظار العمل",
secondaryToolsTitle: "التقارير التشغيلية",
secondaryToolsSummary: "التقارير والتحليلات.",
secondaryToolsMeta: "أداة ثانوية واحدة",
status: {
attention: "يحتاج إلى اهتمام",
inspections: "الفحوصات المفتوحة",
jobs: "المهام المفتوحة",
approvals: "الموافقات",
requests: "الطلبات",
},
nextAction: {
eyebrow: "التالي المُوصى به",
reviewApprovals: "مراجعة الموافقات",
reviewApprovalsMeta: "حدد الطلبات الواردة والعمل المكتمل الذي يجب المضي به.",
openQueue: "إظهار كل ما يحتاج إليك",
openQueueMeta: "المتأخر، المستحق اليوم، والمعطَّل.",
continueInspections: "الاستمرار في الفحوصات",
continueInspectionsMeta: "المخطط له، النشط، والمكتمل.",
continueJobs: "الاستمرار في المهام",
continueJobsMeta: "المسؤولون، المعوقات، التواريخ، الحالة.",
backToQueue: "رجوع إلى العمل",
backToQueueMeta: "رجوع إلى كل ما يحتاج إليك.",
openWorkflows: "فتح قوائم التحقق",
openWorkflowsMeta: "إنشاء أو إعادة استخدام قوائم فحص.",
},
impactBody_zero: "لا تعرض هذه القائمة عملًا لأي أصل.",
impactBody_two: "تعرض هذه القائمة عمل أصلين فقط.",
impactBody_few: "تعرض هذه القائمة عمل {{count}} أصول فقط.",
impactBody_many: "تعرض هذه القائمة عمل {{count}} أصلًا فقط.",
},
queue: {
mobileFilter: {
all: "الكل",
overdue: "متأخر",
today: "اليوم",
approvals: "الموافقات",
a11y: "تصفية القائمة: {{label}}",
},
focus: {
showing: "عرض {{label}} · {{count}}",
inProgress: "عمل قيد التنفيذ",
attention: "يحتاج إليك",
clear: "مسح",
clearA11y: "مسح عامل التصفية وعرض القائمة كاملة",
showAll: "عرض الكل",
},
emptyFocused: "لا شيء هنا: {{label}}.",
refineGroupBy: "التجميع حسب",
groupBy: {
asset: "حسب الأصل",
status: "حسب الحالة",
},
table: {
type: "النوع",
},
calendar: {
today: "اليوم",
todayA11y: "الانتقال إلى اليوم",
prevMonthA11y: "الشهر السابق",
nextMonthA11y: "الشهر التالي",
moreCount: "+{{count}} إضافية",
emptyDay: "لا شيء مخطط له في هذا اليوم",
dayA11y: "{{date}} — {{count}} مخطط: {{summary}}",
dayEmptyA11y: "{{date}} — لا شيء مخطط",
summaryAndMore: "{{titles}} و{{count}} إضافية",
openItemA11y: "فتح {{type}}: {{title}}",
unscheduledTitle: "غير مجدول · {{count}}",
unscheduledHint: "لا تاريخ بعد. افتح عنصرًا لتحدد له تاريخًا.",
scheduleWork: "جدولة عمل",
scheduleSheetTitle: "ما الذي تريد جدولته؟",
scheduleInspection: "جدولة تفتيش",
scheduleJob: "جدولة مهمة",
filters: {
all: "الكل",
jobs: "المهام",
inspections: "عمليات التفتيش",
requests: "الطلبات",
renewals: "المستندات",
},
prevRangeA11y: "الأسبوعان السابقان",
nextRangeA11y: "الأسبوعان التاليان",
upcoming: "القادم",
modeMonth: "شهر",
modeWeek: "أسبوع",
modeMonthA11y: "عرض شبكة الشهر",
modeWeekA11y: "عرض الأسبوع بالساعات",
prevWeekA11y: "الأسبوع السابق",
nextWeekA11y: "الأسبوع التالي",
allDay: "طوال اليوم",
weekItemA11y: "{{type}} في {{time}}: {{title}}",
},
itemKinds: {
job: "مهمة",
inspection: "فحص",
request: "طلب",
document: "مستند",
condition: "الحالة",
activity: "النشاط",
quick_action: "إجراء سريع",
},
empty: "قائمة الانتظار فارغة.",
emptyLine: "لا يوجد شيء في قائمة الانتظار لهذا النطاق.",
emptyBrowse: "فتح الفحوصات",
emptyBrowseA11y: "فتح سجل الفحوصات",
searchPlaceholder: "البحث بالأصل، المعرف، أو المسؤول",
ungroupedSite: "أخرى",
hintFullLists: "القوائم الكاملة في التفتيشات والمهام.",
context: {
followUpTitle: "متابعة",
toolsTitle: "قوائم التحقق",
reportIssue: "الإبلاغ عن مشكلة",
flagProblem: "تنبيه لمشكلة أو خطر",
requestFix: "طلب إجراء إصلاح",
escalate: "تصعيد",
reusePrevious: "استخدام سير عمل سابق",
moreFollowUps: "المزيد",
moreFollowUpsSheetTitle: "تسجيل متابعة أو سير عمل",
},
sections: {
queueTitle: "القائمة",
overdue: "متأخر · {{count}}",
dueToday: "مستحق اليوم · {{count}}",
certificateActions: "شهادات مستحقة · {{count}}",
scheduledInspections: "تفتيشات مجدولة · {{count}}",
inProgressJobs: "مهام قيد التنفيذ · {{count}}",
needsAttention: "يتطلب انتباهاً · {{count}}",
reportReviews: "مراجعات التقارير",
},
},
assetCollaboration: {
  respondBy: {
    days: "{{count}} ي",
    hours: "{{count}} س",
    minutes: "{{count}} د",
    overdue: "متأخر {{window}}",
    dueIn: "مستحق خلال {{window}}",
  },
  requestType: {
    job: "مهمة",
    inspection: "فحص",
    help: "مساعدة",
  },
  requestPriority: {
    urgent: "عاجلة",
    high: "عالية",
    medium: "متوسطة",
    low: "منخفضة",
  },
  activityLabels: {
    lifecycleRecorded: "مُسجَّل",
    lifecycleBulk: "تغيير جماعي",
    team: "الفريق",
    shareRole: {
      requester: "مقدم الطلب",
      viewer: "مشاهد",
    },
    shareStatus: {
      revoked: "مُلغى",
      declined: "مرفوض",
      active: "نشط",
      pending: "بانتظار القبول",
    },
    sharedWithContact: "تمت المشاركة مع جهة اتصال",
    sharedWith: "تمت المشاركة مع {{name}}",
    documentStatus: {
      no_expiry: "بلا تاريخ انتهاء",
      expired: "منتهي الصلاحية",
      expiring_soon: "ينتهي قريبًا",
      valid: "ساري",
    },
    connectedState: {
      planned: "مُسجَّل",
      outstanding: "يحتاج إلى متابعة",
      completed: "تم الحل",
    },
    connectedSource: "مصدر متصل",
    inspector: "المفتش",
    unassigned: "غير مُسند",
    scheduledInspection: "فحص مجدول",
    type: {
      lifecycle: "دورة الحياة",
      location: "الموقع",
      access: "الوصول",
      connected: "نظام متصل",
      document: "مستند",
      job: "مهمة",
      inspection: "فحص",
    },
  },
  breadcrumbRequests: "الطلبات",
  evidenceFromRequest: "صور من الطلب",
  conversation: {
    empty: "لا توجد رسائل بعد. أرسل واحدة أدناه — سيراها {{who}} ويرد هنا.",
    noneExchanged: "لم تُرسل رسائل في هذا الطلب.",
  },
  closedBanner: {
    declinedRequester: "أُغلق هذا الطلب دون تنفيذ.",
    declinedOp: "تم رفض هذا الطلب أو سحبه.",
    doneRequester: "تم كل شيء — لقد قبلت العمل. لا شيء آخر للقيام به.",
    doneOp: "تم العمل واعتماده. اكتمل هذا الطلب.",
    teamClosed: "أغلق الفريق هذا الطلب.",
    closedByTeam: "أغلق فريقك هذا الطلب. اضغط إعادة فتح إذا بقي شيء.",
    closedByYou: "لقد أغلقت هذا الطلب. اضغط إعادة فتح إذا بقي شيء.",
    titleNotProceeding: "مغلق · لن يُنفذ",
    titleDone: "مغلق · تم",
  },
  tracker: {
    next: "التالي:",
    active: "مفتوح منذ {{age}}",
    closedTook: "مغلق · استغرق {{age}}",
    closed: "مغلق",
    progressA11yNow: "التقدم: {{done}} من {{total}} خطوات منجزة، الآن {{stage}}",
    progressA11y: "التقدم: {{done}} من {{total}} خطوات منجزة",
  },
  row: {
    noAccountA11y: "أُبلغ عنه دون حساب",
    noAccount: "بلا حساب",
    contact: "جهة اتصال",
    unassigned: "غير معيّن",
    team: "الفريق",
    assigned: "معيّن",
    preferred: "المفضل",
    scheduled: "مجدول",
  },
  showAll_other: "عرض الكل ({{count}})",
  showAll_many: "عرض الكل ({{count}})",
  showAll_few: "عرض الكل ({{count}})",
  showAll_two: "عرض الكل",
  showAll_one: "عرض الكل",
  showAll_zero: "عرض الكل",
  showFewer: "عرض أقل",
  messages: {
    newReplies_other: "{{count}} رد جديد من الفريق",
    newReplies_many: "{{count}} ردًا جديدًا من الفريق",
    newReplies_few: "{{count}} ردود جديدة من الفريق",
    newReplies_two: "ردان جديدان من الفريق",
    newReplies_one: "رد جديد واحد من الفريق",
    newReplies_zero: "لا ردود جديدة من الفريق",
    open: "راسل الفريق",
    hide: "إخفاء الرسائل",
  },
  period: {
    pm: "مساءً",
    am: "صباحًا",
  },
  withdraw: {
    confirm: "سحب",
    keep: "الإبقاء عليه",
    body: "سيؤدي هذا إلى إلغاء الطلب وأي زيارة مخططة، وإبلاغ الفريق.",
    title: "سحب هذا الطلب؟",
    button: "سحب الطلب",
  },
  badge: {
    request: "طلب",
    job: "مهمة",
    inspection: "فحص",
  },
  showDetailsA11y: "{{title}}. إظهار التفاصيل",
  hideDetailsA11y: "{{title}}. إخفاء التفاصيل",
  collapseHide: "إخفاء",
  expandShow: "إظهار",
  emptyAssetRequester: "لم تُبلغ عن أي شيء لهذا الأصل بعد.",
  sectionPendingRequester: "مرسلة — الفريق يراجعها",
  summary: {
    declined_other: "{{count}} طلب مرفوض",
    declined_many: "{{count}} طلبًا مرفوضًا",
    declined_few: "{{count}} طلبات مرفوضة",
    declined_two: "طلبان مرفوضان",
    declined_one: "طلب واحد مرفوض",
    declined_zero: "لا شيء مرفوض",
    accepted_other: "{{count}} طلب مقبول",
    accepted_many: "{{count}} طلبًا مقبولًا",
    accepted_few: "{{count}} طلبات مقبولة",
    accepted_two: "طلبان مقبولان",
    accepted_one: "طلب واحد مقبول",
    accepted_zero: "لا شيء مقبول",
    planned_other: "{{count}} طلب مخطط",
    planned_many: "{{count}} طلبًا مخططًا",
    planned_few: "{{count}} طلبات مخططة",
    planned_two: "طلبان مخططان",
    planned_one: "طلب واحد مخطط",
    planned_zero: "لا شيء مخطط",
    inProgress_other: "{{count}} طلب قيد التنفيذ",
    inProgress_many: "{{count}} طلبًا قيد التنفيذ",
    inProgress_few: "{{count}} طلبات قيد التنفيذ",
    inProgress_two: "طلبان قيد التنفيذ",
    inProgress_one: "طلب واحد قيد التنفيذ",
    inProgress_zero: "لا شيء قيد التنفيذ",
    withTeam_other: "{{count}} طلب لدى الفريق",
    withTeam_many: "{{count}} طلبًا لدى الفريق",
    withTeam_few: "{{count}} طلبات لدى الفريق",
    withTeam_two: "طلبان لدى الفريق",
    withTeam_one: "طلب واحد لدى الفريق",
    withTeam_zero: "لا شيء لدى الفريق",
    needsReply_other: "{{count}} طلب بانتظار ردك",
    needsReply_many: "{{count}} طلبًا بانتظار ردك",
    needsReply_few: "{{count}} طلبات بانتظار ردك",
    needsReply_two: "طلبان بانتظار ردك",
    needsReply_one: "طلب واحد بانتظار ردك",
    needsReply_zero: "لا شيء بانتظار ردك",
    toLookAt_other: "{{count}} طلب للمراجعة",
    toLookAt_many: "{{count}} طلبًا للمراجعة",
    toLookAt_few: "{{count}} طلبات للمراجعة",
    toLookAt_two: "طلبان للمراجعة",
    toLookAt_one: "طلب واحد للمراجعة",
    toLookAt_zero: "لا شيء للمراجعة",
  },
  progress: {
    reports_other: "{{count}} تقرير",
    reports_many: "{{count}} تقريرًا",
    reports_few: "{{count}} تقارير",
    reports_two: "تقريران",
    reports_one: "تقرير واحد",
    reports_zero: "لا تقارير",
    inspections_other: "{{count}} فحص",
    inspections_many: "{{count}} فحصًا",
    inspections_few: "{{count}} فحوصات",
    inspections_two: "فحصان",
    inspections_one: "فحص واحد",
    inspections_zero: "لا فحوصات",
    jobs_other: "{{count}} مهمة",
    jobs_many: "{{count}} مهمة",
    jobs_few: "{{count}} مهام",
    jobs_two: "مهمتان",
    jobs_one: "مهمة واحدة",
    jobs_zero: "لا مهام",
  },
  sort: {
    updated: "المحدّثة مؤخرًا",
    oldest: "الأقدم",
    newest: "الأحدث",
  },
  displayStatus: {
    requester: {
      planned: "مخطط",
      accepted: "مقبول",
      needsReview: "بانتظار مراجعتك",
      declined: "مرفوض",
      closed: "مغلق",
      waiting: "بانتظار ردك",
      active: "قيد التنفيذ",
      triaged: "تمت الموافقة",
      new: "تم الإرسال",
    },
    operator: {
      declined: "مرفوض",
      closed: "مغلق",
      waiting: "بانتظار مقدّم الطلب",
      active: "قيد التنفيذ",
      triaged: "تمت الموافقة",
      new: "جديد",
    },
  },
  issueReportedConfirmInspection: "تم تسجيل المشكلة. اختر قائمة التحقق وموعدًا لحجز الفحص.",
  issueReportedConfirmJob: "تم تسجيل المشكلة. راجع المهمة ثم أنشئها.",
  updateFailedTitle: "لم يتم تحديث الطلب",
  visitProposed: "تم اقتراح الموعد. يُطلب من مقدّم الطلب تأكيده.",
  requester: {
    contactMissing: "تعذر ربط حسابك بهذا الأصل. اطلب ممن شاركه أن يشاركه مرة أخرى.",
    assetMissing: "تعذر العثور على هذا الأصل. افتح الرابط الذي وصلك مرة أخرى.",
    submitFailedTitle: "لم يتم إرسال بلاغك",
    calendarTitle: "فحص: {{name}}",
    reworkReason: "طلب مقدّم الطلب إعادة العمل.",
    tryAgain: "تحقق من اتصالك وحاول مرة أخرى.",
    declineShareFailed: "لم يتم الرفض",
    acceptShareFailed: "لم يتم القبول",
    withdrawFailed: "لم يتم سحب الطلب",
    sendFailed: "لم يتم الإرسال",
    confirmFailed: "لم يتم التأكيد",
    reviewFailed: "لم يتم حفظ ردك",
    rescheduleFailed: "لم يتم إرسال موعدك الجديد",
    confirmVisitFailed: "لم يتم تأكيد الزيارة",
    reportSent: "تم إرسال البلاغ. سيراجعه الفريق، وتظهر التحديثات هنا وتصلك إشعارات.",
    withdrawn: "تم سحب الطلب. تم إبلاغ الفريق.",
    preferredTimeSent: "تم الإرسال. سيراجع الفريق الوقت الذي تفضله ويرد عليك.",
    reworkRequested: "أُعيد إلى الفريق. لديهم ملاحظتك وسيعودون إليه.",
    completionAccepted: "شكرًا، لقد قبلت العمل. سيغلق الفريق الطلب.",
    rescheduleSent: "تم طلب موعد آخر. سيقترح الفريق موعدًا جديدًا.",
    visitConfirmed: "تم تأكيد الزيارة. تم إبلاغ الفريق.",
  },
  journey: {
    naReviewReport: "راجع التقرير واقبل العمل",
    naWaitingReviewOp: "بانتظار مراجعة مقدّم الطلب",
    naTeamCloses: "الفريق يؤكد العمل ويغلقه",
    naVerify: "اعتمد العمل المكتمل",
    naWorkUnderway: "العمل جارٍ",
    naWillSchedule: "سيجدول الفريق العمل",
    naVisitAsPlanned: "سيزور الفريق كما هو مخطط",
    naConfirmVisit: "أكّد أن أحدًا سيكون موجودًا للزيارة",
    naCarryOut: "نفّذ العمل",
    naScheduleJob: "جدول المهمة وابدأها",
    naHelpOp: "رُدّ على مقدّم الطلب أو أنشئ مهمة",
    naStartInspection: "ابدأ الفحص",
    naTeamArranging: "الفريق يرتّب العمل",
    naPlanWork: "خطط للعمل",
    naCreateJob: "أنشئ المهمة",
    naScheduleInspection: "جدول الفحص أو ابدأه",
    naTeamReviewing: "الفريق يراجع طلبك",
    naTriage: "وافق أو ارفض أو اطرح سؤالًا",
    naWaitingOnRequester: "بانتظار مقدّم الطلب",
    naReplyToTeam: "الرد على الفريق",
    detailTeamNote: "ملاحظة الفريق: {{notes}}",
    detailReason: "السبب: {{notes}}",
    slNewRequestOp: "طلب جديد.",
    slAllDone: "تم كل شيء.",
    slCompletedOp: "مكتمل.",
    slReadyForReview: "جاهز لمراجعتك.",
    slWaitingReviewOp: "بانتظار مراجعة مقدّم الطلب.",
    slAccepted: "لقد قبلت العمل — الفريق يؤكد ويغلق.",
    slAcceptedOp: "قبله مقدّم الطلب — اعتمد وأغلق.",
    slWorkUnderway: "العمل جارٍ.",
    slWorkUnderwayOp: "العمل جارٍ.",
    slJobCreated: "تم إنشاء مهمة.",
    slJobCreatedOp: "تم إنشاء المهمة — لم تُجدول بعد.",
    slVisitPlanned: "الزيارة مخططة في {{when}}.",
    slJobPlannedOp: "المهمة مخططة في {{when}}.",
    slHelp: "الفريق يساعد في هذا.",
    slHelpOp: "تمت الموافقة — رُدّ أو أنشئ مهمة.",
    slInspectionUnderway: "هناك فحص جارٍ.",
    slInspectionUnderwayOp: "الفحص جارٍ.",
    slInspectionScheduled: "الفحص مجدول في {{when}}.",
    slInspectionBookedOp: "تم حجز الفحص في {{when}}.",
    slApproved: "تمت الموافقة — الفريق يرتّب العمل.",
    slApprovedOp: "تمت الموافقة — رتّب العمل.",
    slSubmitted: "تم الإرسال.",
    slNewOp: "جديد — راجع هذا الطلب.",
    slWaitingOnRequester: "بانتظار مزيد من المعلومات من مقدّم الطلب.",
    slWaitingOnYou: "يحتاج الفريق إلى مزيد من المعلومات منك.",
    slDeclined: "تم رفض هذا الطلب.",
    slDeclinedOp: "مرفوض.",
    stDone: "تم",
    stClose: "الإغلاق",
    stYourReview: "مراجعتك",
    stReport: "التقرير",
    stSignOff: "الاعتماد",
    stAnswered: "تم الرد",
    stAnswer: "الرد",
    stInProgress: "قيد التنفيذ",
    stWork: "العمل",
    stInspecting: "جارٍ الفحص",
    stInspect: "الفحص",
    stPlanned: "مخطط",
    stSchedule: "الجدولة",
    stReviewed: "تمت المراجعة",
    stTriage: "المراجعة",
    stRaised: "تم الإرسال",
    stReceived: "تم الاستلام",
  },
  requestConvert: {
    choose: "اختر ما سيحدث بعد ذلك",
    inspectMeta: "اختر قائمة التحقق وموعدًا. يُحجز الفحص ويبقى مرتبطًا بالطلب.",
    jobMeta: "تحقق ممن سينفذها وموعدها والتعليمات، ثم أنشئ المهمة.",
    inspectInstead: "الفحص بدلًا من ذلك",
    inspect: "فحص",
    jobInstead: "إنشاء مهمة بدلًا من ذلك",
    job: "إنشاء مهمة",
    subtitle: "تفاصيل الطلب معبأة لك. ما عليك سوى تأكيد من سينفذه ومتى.",
    title: "ما الخطوة التالية؟",
  },
  requestFulfilment: {
    unclear: "ليس واضحًا ما الخطأ، لذا سيوضح الفحص العمل المطلوب.",
    urgentUnclear: "الأمر عاجل لكنه غير واضح، لذا أرسل شخصًا الآن ليتحقق في الموقع.",
    readsAsCheck: "يبدو كفحص للحالة أو السلامة، لذا افحص أولًا.",
    describesFault: "يصف شيئًا يحتاج إلى إصلاح، لذا فالمهمة هي الأسرع.",
    askedForJob: "طُلب تنفيذ مهمة.",
    askedForInspection: "طُلب فحص.",
    assessFirst: "افحصه أولًا لتعرف العمل المطلوب.",
  },
tabLabel: "المتابعات",
tabTitle: "المتابعات والفرز",
tabIntro: "سجل المتابعات وراجع طلبات جهات الاتصال.",
openApprovalsQueue: "عرض كل الطلبات في العمل",
sectionCardTitle: "طلبات هذا الأصل",
sectionCardSub: "سجّل مشكلة، أو اعرض كل الطلبات في العمل.",
sectionCardSubRequester: "أبلغ عن مشكلة وتابع ما يحدث لها.",
newRequest: "طلب جديد",
composeItemTitle: "متابعة عنصر قائمة التفتيش",
composeItemDescription: "عنصر مرجعي: {{itemId}}",
activityFollowUpLabel: "عنصر مسجل",
activityAssetLabel: "الأصل",
activityAssetCreatedTitle: "تمت إضافة الأصل",
activityAssetCreatedStatus: "تم الإنشاء",
activityAssistantChangeTitle: "تم التغيير عبر المساعد",
activityAssistantUndoneTitle: "تم التراجع عن تغيير المساعد",
activityAssistantStatus: "تم التأكيد في المساعد",
activitySiteLabel: "الموقع",
missingAssetForCompose: "تعذر تحديد هذا الأصل.",
missingLinkedContactForCompose: "تعذر تسجيل هذه المشكلة باسمك. سجّل الخروج ثم الدخول وحاول مرة أخرى.",
operatorLinkedContactNoAccount: "ملفك غير مرتبط بعد بحساب مساحة العمل. جرّب تسجيل الخروج والدخول مجددًا، أو تواصل مع الدعم.",
operatorLinkedContactAutoFailed: "تعذر تسجيل هذه المشكلة باسمك. حاول بعد قليل، وإذا تكرر الأمر فسجّل الخروج ثم الدخول.",
composeSubmitErrorTitle: "تعذر الإرسال",
issueReported: "تم تسجيل المشكلة. وافق عليها، أو اضغط إنشاء العمل أو فحص لتخطيط العمل.",
composeSubmitErrorBody: "حاول مرة أخرى.",
composeOpenErrorTitle: "تعذر الفتح",
sectionPending: "جديدة",
sectionAwaitingCustomer: "بانتظار ردك",
sectionAwaitingCustomerInternal: "بانتظار مقدّم الطلب",
sectionActive: "موافق عليها أو مخططة أو قيد التنفيذ",
sectionClosed: "مغلقة",
sectionRejected: "مرفوض",
emptyAsset: "لم يُبلغ عن شيء لهذا الأصل بعد. اضغط طلب جديد لتسجيل مشكلة.",
loadingFollowUps: "جارٍ تحميل المتابعات…",
emptySection: "لا شيء في هذه المجموعة.",
actionApprove: "موافقة",
actionReject: "رفض",
actionSchedule: "جدولة",
actionConvert: "اختيار مسار العمل",
metaContactFallback: "جهة اتصال",
metaNoPriority: "بدون أولوية",
metaNoDate: "لا يوجد توقيت مفضل",
outcomeTypeJob: "عمل متتبع",
outcomeTypeInspection: "تفتيش مجدول",
},
followUpDetail: {
managerActionsTitle: "إجراءات المدير",
managerApprove: "الموافقة",
managerReject: "رفض",
managerSchedule: "جدولة",
managerConvertJob: "تحويل إلى مهمة",
managerConvertInspection: "تحويل إلى فحص",
summaryAssetHeadline: "الأصل",
summaryRequesterHeadline: "مُقدّم الطلب",
emptyLoadingTitle: "جارٍ التحميل",
emptyLoadingBody: "جارٍ سحب أحدث ملخص وسجل تدقيق.",
emptySelectTitle: "حدد عنصرًا",
emptySelectBody: "حدد عنصرًا لعرض التفاصيل والإجراءات.",
outcomeKindJob: "يُتابع كعمل",
outcomeKindInspection: "طُلب فحص",
outcomeSummary: "الملخص",
fieldStatus: "الحالة",
fieldPriority: "الأولوية",
fieldProposedDate: "التوقيت المفضل",
fieldScheduledFor: "مُجدوَل لـ",
fieldResolution: "ملاحظات الحل",
assetSummary: "الأصل",
fieldAssetName: "الأصل",
fieldAssetType: "النوع",
fieldAssetStatus: "حالة الأصل",
reporter: "أرسله",
fieldContactName: "الاسم",
fieldContactEmail: "البريد الإلكتروني",
timeline: "التقدم",
timelinePending: "قيد الانتظار",
timelineDone: "تم",
history: "سجل التدقيق",
historyEmpty: "لا توجد إدخالات تدقيق حتى الآن.",
linkedWork: "العمل المرتبط",
openLinkedJob: "فتح المهمة المرتبطة",
openLinkedInspection: "فتح الزيارة المخطط لها",
actions: "الخطوات التالية",
actionApprove: "الموافقة",
actionReject: "رفض",
actionSchedule: "جدولة",
actionConvert: "اختيار مسار العمل",
loggedContext: "مصدر هذا العنصر",
fieldSourceInspection: "فحص",
fieldSourceJob: "مهمة",
fieldSourceSchedule: "زيارة مخطط لها",
fieldSourceLocation: "ملاحظة الموقع",
fieldIntent: "كيفية تسجيله",
intentReport: "الإبلاغ عن مشكلة",
intentFlag: "تمييز مشكلة",
intentRequestFix: "طلب إصلاح",
intentEscalate: "تصعيد",
historyActionSubmitted: "سُجّل للفرز",
historyActionApproved: "تمت الموافقة",
historyActionRejected: "تم الرفض",
historyActionScheduled: "تمت الجدولة",
historyActionConvertedJob: "تم تحضير مهمة من الطلب",
historyActionConvertedInspection: "تم تحضير فحص من الطلب",
historyActionCommented: "تمت إضافة تعليق",
aiAssistDisclosureTitle: "المساعدة والمسودات",
aiAssistDisclosureSummary: "الملخصات، إعادة الصياغة، والردود المقترحة",
},
approvalsWorkspace: {
toolbarOpenAssetFollowUps: "فتح متابعات الأصل",
toolbarChooseAsset: "اختيار الأصل",
searchPlaceholder: "البحث بمعرف الأصل",
applyAssetFilter: "تطبيق عامل تصفية الأصل",
applyTeamFilter: "تطبيق عامل تصفية الفريق",
listColumnFollowUp: "المتابعة",
listColumnStatus: "الحالة",
listColumnPriority: "الأولوية",
listColumnDate: "التاريخ",
listPaneTitle: "الطلبات",
webStatusHint: "",
detailPaneTitle: "التفاصيل",
mobileTitle: "الطلبات",
mobileSubtitle: "فرز المتابعات وتحضير العمل.",
loadingQueue: "جارٍ تحميل الموافقات…",
emptyQueue: "لا توجد طلبات هنا",
emptyQueueHint: "جرّب قسم المُرسَل أو الكل، أو وسّع النطاق.",
filterInspection: "فحص",
filterJob: "مهمة",
countPending: "قيد الانتظار",
countUrgent: "عاجل",
filterAssetPlaceholder: "تصفية بمعرف الأصل",
filterTeamPlaceholder: "تصفية بمعرف الفريق",
statusFilterAll: "الكل",
statusFilterPending: "قيد الانتظار",
statusFilterApproved: "معتمد",
statusFilterScheduled: "مُجدوَل",
statusFilterConverted: "عمل مرتبط",
statusFilterRejected: "مرفوض",
refine: "تصفية",
refineA11y: "تصفية الطلبات",
refineSheetTitle: "تصفية الطلبات",
nameSearchPlaceholder: "البحث عن الطلبات بالاسم",
nameSearchA11y: "البحث عن الطلبات بالاسم",
},
requestComposer: {
  duplicateBodyMore_other: "«{{title}}» و{{count}} طلب آخر لا تزال مفتوحة. لا يزال بإمكانك إرسال طلبك.",
  duplicateBodyMore_many: "«{{title}}» و{{count}} طلبًا آخر لا تزال مفتوحة. لا يزال بإمكانك إرسال طلبك.",
  duplicateBodyMore_few: "«{{title}}» و{{count}} طلبات أخرى لا تزال مفتوحة. لا يزال بإمكانك إرسال طلبك.",
  duplicateBodyMore_two: "«{{title}}» وطلبان آخران لا تزال مفتوحة. لا يزال بإمكانك إرسال طلبك.",
  duplicateBodyMore_one: "«{{title}}» وطلب آخر لا يزالان مفتوحين. لا يزال بإمكانك إرسال طلبك.",
  duplicateBodyMore_zero: "«{{title}}» لا يزال مفتوحًا. لا يزال بإمكانك إرسال طلبك.",
  duplicateBody: "«{{title}}» لا يزال مفتوحًا على هذا الأصل. لا يزال بإمكانك إرسال طلبك.",
  duplicateSimilar: "هناك طلب مشابه مفتوح بالفعل",
  duplicateExact: "ربما تم الإبلاغ عن هذا بالفعل",
  summaryMissing: "أضف ملخصًا قصيرًا أولًا، ثم حاول مرة أخرى.",
  ai: {
    signInBody: "انتهت جلستك. سجّل الدخول مرة أخرى ثم أضف الصورة.",
    signInTitle: "سجّل الدخول لإضافة صور",
    failedBody: "حاول بعد قليل أو احتفظ بما كتبته.",
    failedTitle: "تعذر تحسين النص",
    review: "راجعه قبل استخدامه.",
    titleTitle: "ملخص محسّن",
    detailsTitle: "تفاصيل محسّنة",
  },
titles: {
default: "الإبلاغ عن مشكلة",
report: "الإبلاغ عن مشكلة",
flag: "تنبيه لمشكلة أو خطر",
requestFix: "طلب إصلاح",
escalate: "تصعيد",
followUp: "اقتراح عمل متابعة",
rework: "اقتراح إعادة عمل",
quote: "تقديم عرض سعر",
},
proposal: {
kindHeading: "ماذا تقترح؟",
kindFollowUp: "متابعة",
kindRework: "إعادة عمل",
kindQuote: "عرض سعر",
summaryPlaceholder: "مثال: استبدال صمام الضغط",
detailsLabel: "ما الذي يلزم عمله ولماذا",
detailsPlaceholder: "ما وجدته وما ستفعله وأي شيء يجب أن يعرفوه",
submit: "إرسال الاقتراح",
},
close: "إغلاق",
assetHeading: "الأصل",
assetChoose: "اختيار أصل",
assetSearchPlaceholder: "البحث باسم الأصل…",
assetTypeAll: "كل الأنواع",
assetNoMatches: "لا يوجد أصل يطابق البحث والمرشحات.",
dictate: "إملاء",
dictationListening: "جارٍ الاستماع…",
dictationProcessing: "جارٍ إدراج النص…",
dictationStopping: "جارٍ إنهاء الإملاء…",
dictationHeard: "تم سماع: {{text}}",
aiPolish: "تحسين بالذكاء الاصطناعي",
contextHeading: "السياق",
contextReporter: "المُبلِّغ: {{name}}",
contextInspection: "من فحص",
contextJob: "من مهمة",
contextSchedule: "من زيارة مخططة",
outcomeHeading: "ماذا يجب أن يفعل الفريق؟",
outcomeHelp: "فقط مساعدة — لست متأكدًا بعد",
outcomeJob: "طلب مهمة",
outcomeInspection: "طلب تفتيش",
summaryLabel: "ملخص قصير",
summaryPlaceholder: "مثال: فشل فحص الصمام",
detailsLabel: "ما رأيته",
summaryPlaceholderRequester: "مثال: صنبور المطبخ يقطر",
detailsLabelRequester: "ما المشكلة؟",
detailsPlaceholderRequester: "ما لاحظته، وأين، ومنذ متى",
detailsPlaceholder: "الملاحظات والمخاطر والقيود",
priorityLabel: "الأولوية",
priorityNone: "بدون",
priorityPickerTitle: "الأولوية",
proposedDateLabel: "التوقيت المفضل (اختياري)",
proposedDatePlaceholder: "اختر التاريخ",
submit: "إرسال",
submitRequester: "إرسال البلاغ",
submitting: "جارٍ الإرسال…",
assetChangeAccessibility: "تغيير الأصل",
assetChange: "تغيير",
analyzeEvidence: "قراءة الصور",
evidenceAddToDetails: "إضافة النص المستخرج إلى التفاصيل",
},
followUpActionModal: {
  stop: "إيقاف",
  draft: "صياغة بالذكاء الاصطناعي",
  drafting: "جارٍ الصياغة…",
  polishFailedBody: "حاول مرة أخرى بعد قليل.",
  polishFailedTitle: "تعذر تحسين الملاحظة",
  draftFailedBody: "حاول مرة أخرى أو اكتبه بنفسك.",
  draftFailedTitle: "تعذرت صياغة سؤال",
  polishReview: "راجع الملاحظة قبل استخدامها.",
  draftReview: "راجعه قبل الإرسال.",
  draftedMessageTitle: "سؤال مقترح",
  polishedNotesTitle: "ملاحظة محسّنة",
  phNotes: "ما يجب أن يعرفوه، مثل موعد الزيارة.",
  phReject: "لماذا لن يُنفذ. يرى مقدّم الطلب هذا.",
  phClose: "لماذا يُغلق؟ يُحفظ السبب في الطلب.",
  phReplied: "ردهم كما قالوه عبر البريد أو الهاتف. يُحفظ في الطلب.",
  phAsk: "ماذا تحتاج منهم؟ تصلهم عبر البريد أو التطبيق.",
  labelNotes: "ملاحظة لمقدّم الطلب (اختياري، يراها)",
  labelReject: "السبب (يراه مقدّم الطلب)",
  labelClose: "سبب الإغلاق (اختياري، يراه مقدّم الطلب)",
  labelReplied: "ما قالوه (اختياري)",
  labelAsk: "سؤالك (يراه مقدّم الطلب)",
  aiFallbackLabel: "طلب",
  loadAssigneesFailed: "تعذر تحميل الأشخاص الذين يمكنك تعيينهم. حاول مرة أخرى.",
  searchAssignees: "ابحث عن أشخاص",
  loadingAssignees: "جارٍ تحميل الأشخاص…",
  unassigned: "لا أحد بعد",
  confirmSchedule: "اقترح هذا الموعد",
  confirmClose: "إغلاق الطلب",
  confirmReplied: "حفظ ردهم",
  confirmAsk: "إرسال السؤال",
  confirmReject: "رفض الطلب",
  confirmApprove: "موافقة",
  closeTitle: "إغلاق الطلب",
  repliedTitle: "سجّل ردهم",
  askTitle: "اطرح سؤالًا على مقدّم الطلب",
approveTitle: "الموافقة على الطلب",
rejectTitle: "رفض الطلب",
scheduleTitle: "تعيين الجدول",
convertTitle: "اختيار مسار العمل",
cancel: "إلغاء",
confirm: "تأكيد",
saving: "جارٍ الحفظ…",
targetLabel: "نوع النتيجة",
targetJob: "مهمة متتبعة",
targetInspection: "تفتيش مجدول",
convertPickerTitle: "اختيار المسار",
},
inspections: {
screenTitle: "التفتيشات",
templates: "قوائم التحقق",
runner: {
noItems: "لا توجد عناصر",
noItemsInGroup: "لا توجد عناصر في هذه المجموعة",
items_one: "{{count}} عنصر",
items_other: "{{count}} عنصر",
groups_one: "{{count}} مجموعة",
groups_other: "{{count}} مجموعة",
questions_one: "{{count}} سؤال",
questions_other: "{{count}} سؤال",
questionsShort: "{{count}} سؤال",
groupOf: "المجموعة {{index}} من {{total}}",
groupOfShort: "المجموعة {{index}}/{{total}}",
itemOf: "العنصر {{index}} من {{total}}",
indexOfShort: "{{index}}/{{total}}",
inGroup: "في: {{group}}",
items_zero: "لا عناصر",
items_two: "عنصران",
items_few: "{{count}} عناصر",
items_many: "{{count}} عنصرًا",
groups_zero: "لا مجموعات",
groups_two: "مجموعتان",
groups_few: "{{count}} مجموعات",
groups_many: "{{count}} مجموعة",
questions_zero: "لا أسئلة",
questions_two: "سؤالان",
questions_few: "{{count}} أسئلة",
questions_many: "{{count}} سؤالًا",
},
bulk: {
select: "تحديد الفحوصات",
selectA11y: "تحديد فحوصات متعددة لإجراءات جماعية",
cancelSelection: "إلغاء",
selected_one: "تم تحديد عنصر واحد",
selected_other: "تم تحديد {{count}} عنصر",
selectAllVisible: "جميع المعروضة",
clearVisible: "مسح المعروضة",
selectAllA11y: "تحديد جميع الفحوصات المعروضة",
deselectAllA11y: "إلغاء تحديد جميع الفحوصات المعروضة",
deleteInspections: "حذف",
deleteConfirmTitle: "حذف الفحوصات",
deleteConfirmMessage_one: "حذف فحص واحد؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmMessage_other: "حذف {{count}} فحص؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmAction: "حذف",
keep: "الاحتفاظ",
deleteSuccess_one: "تم حذف فحص واحد",
deleteSuccess_other: "تم حذف {{count}} فحص",
partialResult: "{{succeeded}} تم · {{failed}} تم تخطيه",
allFailedTitle: "لم يتغيّر شيء",
allFailedMessage: "تعذّر حذف الفحوصات المحددة. حاول مرة أخرى.",
selected_zero: "لم يُحدد شيء",
selected_two: "تم تحديد عنصرين",
selected_few: "تم تحديد {{count}} عناصر",
selected_many: "تم تحديد {{count}} عنصرًا",
deleteConfirmMessage_zero: "لا فحوصات للحذف.",
deleteConfirmMessage_two: "حذف فحصين؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmMessage_few: "حذف {{count}} فحوصات؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmMessage_many: "حذف {{count}} فحصًا؟ لا يمكن التراجع عن هذا الإجراء.",
deleteSuccess_zero: "لم يُحذف أي فحص",
deleteSuccess_two: "تم حذف فحصين",
deleteSuccess_few: "تم حذف {{count}} فحوصات",
deleteSuccess_many: "تم حذف {{count}} فحصًا",
},
createInspection: "إنشاء تفتيش",
startInspection: "بدء تفتيش",
searchA11y: "البحث في التفتيشات",
searchPlaceholderPlanned: "البحث في التفتيشات المجدولة؟",
searchPlaceholderDefault: "البحث في التفتيشات والمراجعات؟",
export: "تصدير",
exportCsvA11y: "تصدير التفتيشات كملف CSV",
refine: "تصفية",
refineA11y: "تصفية الفحوصات وتجميعها",
refineSheetTitle: "تصفية الفحوصات",
refineSearch: "بحث",
clearFilters: "مسح المرشحات",
manageTemplates: "قوائم التحقق",
statusSectionLabel: "الحالة",
bucketTablistLabel: "حالة التفتيش: الكل، يحتاج إجراء، مخطط، أو السجل",
statusHintLine: "القائمة تطابق هذه الحالة.",
viewToggleToListA11y: "التبديل إلى عرض قائمة للتفتيشات المخططة",
viewToggleToCalendarA11y: "التبديل إلى عرض تقويم للتفتيشات المخططة",
buckets: {
all: "الكل",
needsAction: "يحتاج إجراء",
planned: "مخطط",
history: "مكتملة",
},
subtitles: {
allNone: "لا توجد فحوصات حتى الآن",
allCount_one: "{{count}} فحص",
allCount_other: "{{count}} فحص",
needsActionNone: "لا يلزم إجراء الآن",
needsActionCount_one: "{{count}} عنصر يحتاج انتباهك",
needsActionCount_other: "{{count}} عنصر يحتاج انتباهك",
plannedNone: "لا توجد تفتيشات مخططة",
plannedCount_one: "فحص قادم واحد",
plannedCount_other: "{{count}} فحص قادم",
historyNone: "لا يوجد سجل تفتيش بعد",
historyCount_one: "{{count}} عنصر مكتمل أو معتمد أو تمت مراجعته",
historyCount_other: "{{count}} عنصر مكتمل أو معتمد أو تمت مراجعته",
allCount_zero: "لا فحوصات",
allCount_two: "فحصان",
allCount_few: "{{count}} فحوصات",
allCount_many: "{{count}} فحصًا",
needsActionCount_zero: "لا عناصر تحتاج انتباهك",
needsActionCount_two: "عنصران يحتاجان انتباهك",
needsActionCount_few: "{{count}} عناصر تحتاج انتباهك",
needsActionCount_many: "{{count}} عنصرًا يحتاج انتباهك",
plannedCount_zero: "لا فحوصات قادمة",
plannedCount_two: "فحصان قادمان",
plannedCount_few: "{{count}} فحوصات قادمة",
plannedCount_many: "{{count}} فحصًا قادمًا",
historyCount_zero: "لا عناصر مكتملة أو معتمدة أو تمت مراجعتها",
historyCount_two: "عنصران مكتملان أو معتمدان أو تمت مراجعتهما",
historyCount_few: "{{count}} عناصر مكتملة أو معتمدة أو تمت مراجعتها",
historyCount_many: "{{count}} عنصرًا مكتملًا أو معتمدًا أو تمت مراجعته",
},
emptyFilteredTitle: "لا توجد عناصر مطابقة",
emptyFilteredSubtitle: "جرّب كلمات بحث أخرى أو امسح مرشحات الضبط.",
emptyPlannedTitle: "لا توجد تفتيشات في مخطط",
emptyPlannedSubtitle: "أنشئ تفتيشاً مجدولاً من أصل أو قائمة تحقق، وسيظهر هنا.",
emptyCalendarTitle: "لا توجد فحوصات مُجدولة",
emptyCalendarSubtitle: "يعرض التقويم الفحوصات ذات تاريخ مُجدوَل. بدّل إلى البطاقات أو القائمة لرؤية جميع الفحوصات هنا.",
emptyHistoryTitle: "لا توجد تفتيشات في السجل",
emptyHistorySubtitle: "تظهر التفتيشات المكتملة والمراجعات هنا بعد الانتهاء.",
emptyAllTitle: "لا توجد فحوصات حتى الآن",
emptyAllSubtitle: "تظهر الفحوصات والمراجعات والجداول هنا.",
emptyNeedsActionTitle: "لا توجد تفتيشات في يحتاج إجراء",
emptyNeedsActionSubtitle: "عندما يحتاج تفتيش إلى انتباهك، يظهر في هذه القائمة.",
followUp: {
logFromItem: "تسجيل من عنصر قائمة التحقق",
},
refineScope: "النطاق",
refineGroupBy: "تجميع حسب",
refineGroupByHint: "اختر خياراً واحداً أو أكثر لتداخل المجموعات",
refineFilters: "المرشحات",
refineInspectionStage: "مرحلة التفتيش",
refineScheduleStage: "مرحلة الجدولة",
filterChipAsset: "الأصل",
filterChipTemplate: "قائمة التحقق",
filterChipInspector: "المفتش",
groupByAsset: "الأصل",
groupByInspector: "المفتش",
groupByTemplateCategory: "فئة قائمة التحقق",
groupingUnassigned: "غير معيّن",
groupingUncategorized: "بلا تصنيف",
inspectorAll: "الكل",
inspectorMe: "أنا",
inspectionStages: {
all: "جميع مراحل التفتيش",
allShort: "كل المراحل",
draft: "مسودة",
inProgress: "قيد التنفيذ",
completed: "مكتمل",
approved: "معتمد",
cancelled: "ملغى",
},
scheduleStages: {
all: "جميع مراحل الجدولة",
allShort: "الكل",
upcoming: "قادم",
due: "مستحق",
overdue: "متأخر",
},
reviewStages: {
pending: "المراجعة قيد الانتظار",
responded: "تم الرد على المراجعة",
awaitingReply: "تمت المشاركة — في انتظار الرد",
awaitingVerification: "في انتظار التحقق",
column: {
triage: "مفتوح",
scheduled: "مُجدوَل",
in_progress: "قيد التنفيذ",
awaiting_review: "في انتظار المراجعة",
},
},
kanban: {
dueAndOverdue: "المستحق والمتأخر",
},
workflowStage: {
draft: "مسودة",
in_progress: "قيد التنفيذ",
completed: "مكتمل",
approved: "معتمد",
cancelled: "ملغى",
},
pickerAllTemplates: "كل قوائم التحقق",
pickerTitleAsset: "الأصل",
pickerTitleTemplate: "قائمة التحقق",
pickerTitleInspector: "المفتش",
reviewFallbackReport: "تقرير التفتيش",
reviewFallbackAsset: "الأصل",
reviewStatusApproved: "معتمد",
reviewStatusDeclined: "مرفوض",
reviewStatusPending: "مراجعة معلقة",
resultsPanelA11y: "نتائج التفتيش للقسم المحدد",
fabCreateA11y: "إنشاء تفتيش",
exportCsv: {
id: "المعرّف",
template: "قائمة التحقق",
asset: "الأصل",
status: "الحالة",
stage: "المرحلة",
assignee: "المعيّن",
lastActivity: "آخر نشاط",
},
operationalInsight: {
title: "رؤى سجل الفحوصات",
sourceLabel: "الفحوصات والجداول والمراجعات الحالية",
summaryLine: "{{bucketNeedsAction}} يحتاج إلى اهتمام · {{planned}} مُجدوَل · {{history}} مكتمل لهذا النطاق",
overdueSchedExplanation_zero: "{{count}} فحص مُجدوَل متأخر.",
overdueSchedExplanation_one: "فحص مُجدوَل واحد متأخر.",
overdueSchedExplanation_two: "فحصان مُجدوَلان متأخران.",
overdueSchedExplanation_few: "{{count}} فحوصات مُجدوَلة متأخرة.",
overdueSchedExplanation_many: "{{count}} فحصًا مُجدوَلًا متأخرًا.",
overdueSchedExplanation_other: "{{count}} فحص مُجدوَل متأخر.",
overdueSchedRecommended: "ابدأها أو أعد جدولتها لضمان استمرار التغطية والامتثال.",
overdueSchedCta: "إظهار الجداول المتأخرة",
pendingReviewExplanation_zero: "{{count}} تقرير مشترك في انتظار رد المراجع.",
pendingReviewExplanation_one: "تقرير مشترك واحد في انتظار رد المراجع.",
pendingReviewExplanation_two: "تقريران مشتركان في انتظار رد المراجع.",
pendingReviewExplanation_few: "{{count}} تقارير مشتركة في انتظار رد المراجع.",
pendingReviewExplanation_many: "{{count}} تقريرًا مشتركًا في انتظار رد المراجع.",
pendingReviewExplanation_other: "{{count}} تقرير مشترك في انتظار رد المراجع.",
pendingReviewRecommended: "ردّ أو ذكّر المراجعين حتى لا تتعطل الموافقات.",
pendingReviewCta: "فتح المراجعة التالية",
dueSoonExplanation_zero: "{{count}} فحص مُجدوَل يحل قريبًا.",
dueSoonExplanation_one: "فحص مُجدوَل واحد يحل قريبًا.",
dueSoonExplanation_two: "فحصان مُجدوَلان يحلان قريبًا.",
dueSoonExplanation_few: "{{count}} فحوصات مُجدوَلة تحل قريبًا.",
dueSoonExplanation_many: "{{count}} فحصًا مُجدوَلًا يحل قريبًا.",
dueSoonExplanation_other: "{{count}} فحص مُجدوَل يحل قريبًا.",
dueSoonRecommended: "أكّد من سيقوم بها وسجّل أي أعمال تحضيرية.",
dueSoonCta: "إظهار الجداول المستحقة",
inProgressExplanation_zero: "{{count}} فحص في حالة مسودة أو قيد التنفيذ.",
inProgressExplanation_one: "فحص واحد في حالة مسودة أو قيد التنفيذ.",
inProgressExplanation_two: "فحصان في حالة مسودة أو قيد التنفيذ.",
inProgressExplanation_few: "{{count}} فحوصات في حالة مسودة أو قيد التنفيذ.",
inProgressExplanation_many: "{{count}} فحصًا في حالة مسودة أو قيد التنفيذ.",
inProgressExplanation_other: "{{count}} فحص في حالة مسودة أو قيد التنفيذ.",
inProgressRecommended: "استمر في قوائم الفحص، وسجّل الأدلة، وسلّم المهمة إذا لزم الأمر.",
inProgressCta: "التركيز على قيد التنفيذ",
healthyExplanation: "لا توجد مراجعات قيد الانتظار أو جداول متأخرة في هذا العرض المُصفّى.",
healthyRecommended: "استخدم التنقية لتغيير النطاق أو التجميع أو البحث عندما تحتاج إلى قائمة أضيق.",
refineCta: "فتح التنقية",
exportCsvLabel: "تصدير الفحوصات (CSV)",
wideCollapsedLead: "وسّع لعرض الإجراءات.",
widePanelLead: "تتطابق الإجراءات مع هذا العرض.",
},
tableHeaderWorkItem: "عنصر العمل",
tableHeaderStatus: "الحالة",
tableHeaderAssigned: "المُكلَّف",
tableHeaderDueDate: "تاريخ الاستحقاق",
},
templates: {
  addIndustryPack: "إضافة حزمة قطاع",
  emptyNoneSubtitlePacks: "أضف قوائم التحقق الجاهزة لمجالك، أو أنشئ قائمتك.",
screenTitle: "قوائم التحقق",
createManually: "إنشاء يدويًا",
createManuallyA11y: "إنشاء يدويًا",
refineScope: "النطاق",
subtitleCount_one: "{{count}} قائمة تحقق",
subtitleCount_other: "{{count}} قائمة تحقق",
fromPack_zero: "{{count}} من حزمة {{pack}}",
fromPack_one: "{{count}} من حزمة {{pack}}",
fromPack_two: "{{count}} من حزمة {{pack}}",
fromPack_few: "{{count}} من حزمة {{pack}}",
fromPack_many: "{{count}} من حزمة {{pack}}",
fromPack_other: "{{count}} من حزمة {{pack}}",
inspectionsLink: "الفحوصات",
searchPlaceholder: "البحث في قوائم التحقق...",
searchPlaceholderWeb: "البحث في قوائم التحقق، الفئات، أو الأوصاف",
searchA11y: "البحث في قوائم التحقق",
refine: "تصفية",
refineSheetTitle: "تصفية قوائم التحقق",
refineGroupBy: "تجميع حسب",
refineGroupByHint: "حدد واحدًا أو أكثر لتداخل المجموعات",
refineFilters: "عوامل التصفية",
filterAssetType: "نوع الأصل",
filterCategory: "الفئة",
groupByAssetType: "نوع الأصل",
groupByCategory: "الفئة",
pickerTitleAssetType: "نوع الأصل",
pickerTitleCategory: "الفئة",
allTypes: "جميع الأنواع",
allCategories: "جميع الفئات",
statusSectionLabel: "الحالة",
bucketTablistLabel: "حالة قائمة التحقق: يحتاج إلى إجراء، مخطط له، أو السجل",
statusHintLine: "يحتاج إلى إجراء، ومخطط له، والسجل.",
refineA11y: "تصفية قوائم التحقق",
clear: "مسح",
clearA11y: "مسح البحث وعوامل التصفية",
generateWithAi: "إنشاء بالذكاء الاصطناعي",
createChooserTitle: "إنشاء قائمة تحقق",
createChooserSubtitle: "اختر كيفية إنشاء قائمة التحقق.",
newTemplate: "قائمة تحقق جديد",
createTemplate: "إنشاء قائمة تحقق",
createTemplateA11y: "إنشاء قائمة تحقق",
newTemplateA11y: "قائمة تحقق جديد",
emptyNoneTitle: "لا توجد قوائم تحقق بعد",
emptyNoneSubtitle: "أنشئ قائمة تحقق.",
emptyFilteredTitle: "لا توجد قوائم تحقق مطابقة",
emptyFilteredSub: "جرّب مصطلحات بحث مختلفة أو مسح عوامل التصفية.",
clearFilters: "مسح عوامل التصفية",
emptyBucketTitle: "لا توجد قوائم تحقق في {{bucket}}",
emptyBucketSub: "بدّل الفئة أو امسح عوامل التصفية.",
goToNeedsAction: "الانتقال إلى يحتاج إلى إجراء",
goToNeedsActionA11y: "إظهار قوائم التحقق في يحتاج إلى إجراء",
inspectorHeading: "المفتش",
compatibility: "التوافق",
versioning: "الإصدارات",
structure: "البنية",
visibility: "الظهور",
description: "الوصف",
versioningCurrentId: "معرف الإصدار الحالي: {{id}}",
versioningNotSet: "غير محدد",
lastUpdatedPrefix: "آخر تحديث",
structureLine: "{{groups}} مجموعات / {{items}} عناصر / {{conditional}} قواعد شرطية",
requiredChecks_zero: "{{count}} فحص مطلوب",
requiredChecks_one: "فحص مطلوب واحد",
requiredChecks_two: "فحصان مطلوبان",
requiredChecks_few: "{{count}} فحوصات مطلوبة",
requiredChecks_many: "{{count}} فحصًا مطلوبًا",
requiredChecks_other: "{{count}} فحص مطلوب",
visibilityAllTeams: "جميع الفرق",
visibilitySelectedTeams: "الفرق المحددة",
openTemplate: "فتح قائمة التحقق",
edit: "تعديل",
useForInspection: "بدء فحص",
detail: {
duplicate: "تكرار",
delete: "حذف",
sharedBadge: "مشترك",
notFound: "قائمة التحقق غير موجود",
restrictToSelectedTeams: "تقييد بالفرق المحددة",
shareWithAllTeams: "مشاركة مع جميع الفرق",
visibleToAllTeams: "ظاهر لجميع الفرق",
deleteConfirmTitle: "حذف قائمة التحقق",
deleteConfirmBody: "حذف “{{name}}”؟ ستحتفظ الفحوصات السابقة التي استخدمته بسجلها.",
cancel: "إلغاء",
duplicatedTitle: "تم التكرار",
duplicatedBody: "تم إنشاء نسخة من قائمة التحقق هذا.",
errorTitle: "حدث خطأ ما",
failedToDelete: "تعذّر حذف هذا قائمة التحقق. حاول مرة أخرى.",
failedToDuplicate: "تعذّر تكرار هذا قائمة التحقق. حاول مرة أخرى.",
failedToUpdate: "تعذّر تحديث هذا قائمة التحقق. حاول مرة أخرى.",
usedByTitle: "مُستخدم في",
usedByCount_one: "{{count}} فحص",
usedByCount_other: "{{count}} فحص",
usedByEmpty: "لم تستخدم أي فحوصات هذا قائمة التحقق حتى الآن.",
usedByOpenInspection: "فتح الفحص",
usedByCount_zero: "لا فحوصات",
usedByCount_two: "فحصان",
usedByCount_few: "{{count}} فحوصات",
usedByCount_many: "{{count}} فحصًا",
},
selectTemplateTitle: "حدد قائمة تحققًا",
selectTemplateSub: "اختر صفًا لمراجعة بنيته وإصداراته وإجراءات استخدامه.",
groupingUncategorized: "غير مصنف",
labelGeneral: "عام",
labelAllAssets: "جميع الأصول",
fabNewTemplateA11y: "قائمة تحقق جديد",
buckets: {
all: "الكل",
needsAction: "يحتاج إلى إجراء",
planned: "مخطط له",
history: "السجل",
},
subtitleCount_zero: "لا قوائم تحقق",
subtitleCount_two: "قائمة تحققان",
subtitleCount_few: "{{count}} قوائم تحقق",
subtitleCount_many: "{{count}} قائمة تحققًا",
},
jobs: {
followUp: {
requestFix: "طلب إصلاح",
escalate: "تصعيد",
logForTriage: "تسجيل متابعة",
logForTriageHint: "يفتح متابعات هذا الأصل مع سياق المهمة للموافقات.",
},
operationalInsight: {
summaryEmpty: "لا توجد مهام تطابق النطاق وعوامل التصفية الحالية.",
summaryCounts: "{{total}} مهمة في هذا العرض · {{overdue}} متأخرة · {{unassigned}} غير مُكلَّفة · {{unscheduled}} بلا بداية مُجدولة",
overdueExplanation_zero: "{{count}} مهمة تجاوزت موعد بدايتها المُجدول أو تاريخ استحقاقها.",
overdueExplanation_one: "مهمة واحدة تجاوزت موعد بدايتها المُجدول أو تاريخ استحقاقها.",
overdueExplanation_two: "مهمتان تجاوزتا موعد بدايتهما المُجدول أو تاريخ استحقاقهما.",
overdueExplanation_few: "{{count}} مهام تجاوزت موعد بدايتها المُجدول أو تاريخ استحقاقها.",
overdueExplanation_many: "{{count}} مهمةً تجاوزت موعد بدايتها المُجدول أو تاريخ استحقاقها.",
overdueExplanation_other: "{{count}} مهمة تجاوزت موعد بدايتها المُجدول أو تاريخ استحقاقها.",
overdueRecommended: "أكّد المسؤولية، أعد الجدولة، أو أغلق العمل المكتمل فعلًا.",
overdueCta: "إظهار المتأخر",
unassignedExplanation_zero: "{{count}} مهمة مفتوحة بلا مُكلَّف.",
unassignedExplanation_one: "مهمة مفتوحة واحدة بلا مُكلَّف.",
unassignedExplanation_two: "مهمتان مفتوحتان بلا مُكلَّف.",
unassignedExplanation_few: "{{count}} مهام مفتوحة بلا مُكلَّف.",
unassignedExplanation_many: "{{count}} مهمةً مفتوحةً بلا مُكلَّف.",
unassignedExplanation_other: "{{count}} مهمة مفتوحة بلا مُكلَّف.",
unassignedRecommended: "كلّف كل مهمة بشخص حتى يعرف المسؤولون والعملاء والمتعهدون من يقود العمل.",
unassignedCta: "إظهار غير المُكلَّف",
unscheduledExplanation_zero: "{{count}} مهمة مقبولة لا تزال تحتاج إلى بداية مُجدولة.",
unscheduledExplanation_one: "مهمة مقبولة واحدة لا تزال تحتاج إلى بداية مُجدولة.",
unscheduledExplanation_two: "مهمتان مقبولتان لا تزالان تحتاجان إلى بداية مُجدولة.",
unscheduledExplanation_few: "{{count}} مهام مقبولة لا تزال تحتاج إلى بداية مُجدولة.",
unscheduledExplanation_many: "{{count}} مهمةً مقبولةً لا تزال تحتاج إلى بداية مُجدولة.",
unscheduledExplanation_other: "{{count}} مهمة مقبولة لا تزال تحتاج إلى بداية مُجدولة.",
unscheduledRecommended: "حدد نافذة بداية قبل أن يتأخر العمل أو يتعارض مع التزامات أخرى.",
unscheduledCta: "إظهار غير المُجدوَل",
urgentExplanation_zero: "{{count}} مهمة معلَّمة بأولوية عالية.",
urgentExplanation_one: "مهمة واحدة معلَّمة بأولوية عالية.",
urgentExplanation_two: "مهمتان معلَّمتان بأولوية عالية.",
urgentExplanation_few: "{{count}} مهام معلَّمة بأولوية عالية.",
urgentExplanation_many: "{{count}} مهمةً معلَّمةً بأولوية عالية.",
urgentExplanation_other: "{{count}} مهمة معلَّمة بأولوية عالية.",
urgentRecommended: "تحقق من المعوقات، الأدلة الناقصة، والتأخيرات الظاهرة للعميل.",
urgentCta: "تصفية الأولوية العالية",
healthyExplanation: "لا توجد مهام متأخرة أو غير مُكلَّفة أو غير مُجدولة في هذا العرض المُصفّى.",
healthyRecommended: "حافظ على تحديث التواريخ والمكلَّفين والتحديثات مع تقدم العمل.",
healthyCta: "تصفية القائمة",
exportCsvLabel: "تصدير المهام المعروضة (CSV)",
wideCollapsedLead: "وسّع لعرض الإجراءات.",
widePanelLead: "تتطابق الإجراءات مع هذا العرض.",
},
screenTitle: "المهام",
createJob: "إنشاء مهمة",
createJobA11y: "إنشاء مهمة",
searchPlaceholder: "البحث في المهام...",
searchPlaceholderWeb: "البحث في المهام، الأصول، المكلَّفين...",
searchA11y: "البحث في المهام",
refine: "تصفية",
refineSheetTitle: "تصفية المهام",
refineSearch: "بحث",
refineJobsA11y: "تصفية المهام",
refineScope: "النطاق",
refineGroupBy: "تجميع حسب",
refineGroupByHint: "حدد واحدًا أو أكثر لتداخل المجموعات",
refineFilters: "عوامل التصفية",
refineStage: "المرحلة",
refineQuoteWorkflow: "سير عمل عروض الأسعار",
clearFilters: "مسح عوامل التصفية",
advancedFiltersTitle: "عوامل التصفية والترتيب المتقدمة",
advancedFiltersSummary_one: "{{count}} تنقية نشطة",
advancedFiltersSummary_other: "{{count}} تنقية نشطة",
advancedFiltersSummaryEmpty: "التجميع، عوامل التصفية، المرحلة، النطاق، الترتيب",
advancedFiltersExpand: "إظهار عوامل التصفية",
advancedFiltersCollapse: "إخفاء عوامل التصفية",
exportFilteredCsvA11y: "تصدير المهام المُصفّاة حاليًا كـ CSV",
statusSectionLabel: "الحالة",
bucketTablistLabel: "حالة المهمة: الكل، يحتاج إلى إجراء، مخطط له، أو السجل",
statusHintLine: "تطابق قائمة الانتظار هذه الفئة.",
switchToListA11y: "تبديل المهام إلى عرض القائمة",
switchToCalendarA11y: "تبديل المهام إلى عرض التقويم",
bucketsNative: {
all: "الكل",
needs_action: "يحتاج إلى إجراء",
scheduled: "مُجدوَل",
closed: "مُغلق",
},
bucketsWeb: {
all: "الكل",
needs_action: "يحتاج إلى إجراء",
scheduled: "مخطط له",
closed: "السجل",
},
sort: {
newest: "الأحدث أولًا",
oldest: "الأقدم أولًا",
name_az: "الاسم من أ إلى ي",
name_za: "الاسم من ي إلى أ",
asset_name: "اسم الأصل",
highest_cost: "الأعلى تكلفة",
lowest_cost: "الأقل تكلفة",
assignee: "المكلَّف",
},
sortBy: "ترتيب حسب",
groupBy: {
asset: "الأصل",
status: "الحالة",
},
attention: {
all: "الكل",
overdue: "متأخر",
unscheduled: "غير مُجدوَل",
},
webQueue: {
all: "جميع النشطة",
overdue: "متأخر",
awaiting_acceptance: "في انتظار القبول",
unscheduled: "غير مُجدوَل",
in_progress: "قيد التنفيذ",
due_soon: "يحل قريبًا",
other: "مُجدوَل لاحقًا",
},
quoteState: {
all: "جميع حالات عروض الأسعار",
awaiting_request: "في انتظار طلب عرض السعر",
requested: "طلب عرض السعر مرتبط",
awarded: "تم ترسية عرض السعر",
},
quoteLinked: "مرتبط",
quoteNone: "بلا",
priority: {
all: "الكل",
low: "منخفضة",
medium: "متوسطة",
high: "عالية",
critical: "حرجة",
},
deliveryAll: "الكل",
deliveryMode: {
INTERNAL: "داخلي",
DIRECT_CONTRACTOR: "متعهد مباشر",
PRIVATE_QUOTES: "عروض أسعار خاصة",
},
categoryAll: "جميع الفئات",
assigneeAll: "جميع المكلَّفين",
assigneeUnassigned: "غير مُكلَّف",
assigneeAssignedFallback: "مُكلَّف",
filterChip: {
asset: "الأصل",
category: "الفئة",
workPath: "مسار العمل",
priority: "الأولوية",
attention: "الاهتمام",
sort: "الترتيب",
assignee: "المكلَّف",
quoteState: "حالة عرض السعر",
},
pickerTitle: {
asset: "الأصل",
category: "الفئة",
workPath: "مسار العمل",
priority: "الأولوية",
sortBy: "ترتيب حسب",
attention: "الاهتمام",
assignee: "المكلَّف",
quoteState: "حالة عرض السعر",
},
stages: {
all: {
all: "الكل",
},
needs_action: {
all: "الكل",
draft: "مسودة",
open: "مفتوحة",
accepted: "مقبولة",
completed: "مكتملة",
rejected: "مرفوضة",
},
scheduled: {
all: "الكل",
scheduled: "مُجدولة",
in_progress: "قيد التنفيذ",
paused: "متوقفة مؤقتًا",
},
closed: {
all: "الكل",
verified: "موثقة",
cancelled: "ملغاة",
},
},
grouping: {
noAsset: "بلا أصل",
noSkill: "بلا مهارة",
unassigned: "غير مُكلَّف",
uncategorized: "غير مصنف",
},
analytics: {
assigneeChannel: {
unassigned: "غير مُكلَّف",
team_member: "عضو الفريق",
contractor: "متعهد",
type_unset: "المكلَّف (النوع غير محدد)",
},
privateQuotesPipeline: {
awaitingRequest: "لا يوجد طلب عرض سعر حتى الآن",
requested: "في انتظار الترسية",
awarded: "تم ترسية العرض (قيد التنفيذ)",
},
notSet: "غير محدد",
},
urgency: {
normal: "عادية",
low: "منخفضة",
medium: "متوسطة",
high: "عالية",
},
relative: {
justNow: "الآن",
minutesAgo: "منذ {{count}} د",
hoursAgo: "منذ {{count}} س",
},
sortDash: "-",
alerts: {
cancelTitle: "إلغاء المهمة",
cancelMessage: "هل أنت متأكد؟ ستُعلَّم المهمة كملغاة.",
keep: "الاحتفاظ",
cancelConfirm: "إلغاء المهمة",
deleteTitle: "حذف المهمة",
deleteMessage: "لا يمكن التراجع عن هذا الإجراء. ستُحذف المهمة نهائيًا.",
deleteConfirm: "حذف",
errorTitle: "خطأ",
failedCancel: "فشل الإلغاء",
failedDelete: "فشل الحذف",
acceptFailedTitle: "تعذّر قبول المهمة",
acceptFailedMessage: "حاول مرة أخرى.",
},
bulk: {
select: "تحديد المهام",
selectA11y: "تحديد مهام متعددة لإجراءات جماعية",
cancelSelection: "إلغاء",
selected_one: "تم تحديد عنصر واحد",
selected_other: "تم تحديد {{count}} عنصر",
selectAllVisible: "جميع المعروضة",
clearVisible: "مسح المعروضة",
selectAllA11y: "تحديد جميع المهام المعروضة",
deselectAllA11y: "إلغاء تحديد جميع المهام المعروضة",
cancelJobs: "إلغاء",
deleteJobs: "حذف",
cancelConfirmTitle: "إلغاء المهام",
cancelConfirmMessage_one: "إلغاء أمر عمل واحد؟ سيُعلَّم كملغى.",
cancelConfirmMessage_other: "إلغاء {{count}} أمر عمل؟ ستُعلَّم كملغاة.",
cancelConfirmAction: "إلغاء المهام",
deleteConfirmTitle: "حذف المهام",
deleteConfirmMessage_one: "حذف أمر عمل واحد؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmMessage_other: "حذف {{count}} أمر عمل؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmAction: "حذف",
keep: "الاحتفاظ",
noneCancellable: "لا يمكن إلغاء أي من المهام المحددة.",
cancelSuccess_one: "تم إلغاء أمر عمل واحد",
cancelSuccess_other: "تم إلغاء {{count}} أمر عمل",
deleteSuccess_one: "تم حذف أمر عمل واحد",
deleteSuccess_other: "تم حذف {{count}} أمر عمل",
partialResult: "{{succeeded}} تم · {{failed}} تم تخطيه",
allFailedTitle: "لم يتغيّر شيء",
allFailedMessage: "تعذّر تحديث المهام المحددة. حاول مرة أخرى.",
selected_zero: "لم يُحدد شيء",
selected_two: "تم تحديد عنصرين",
selected_few: "تم تحديد {{count}} عناصر",
selected_many: "تم تحديد {{count}} عنصرًا",
cancelConfirmMessage_zero: "لا أوامر عمل للإلغاء.",
cancelConfirmMessage_two: "إلغاء أمري عمل؟ سيُعلَّمان كملغيين.",
cancelConfirmMessage_few: "إلغاء {{count}} أوامر عمل؟ ستُعلَّم كملغاة.",
cancelConfirmMessage_many: "إلغاء {{count}} أمر عمل؟ ستُعلَّم كملغاة.",
deleteConfirmMessage_zero: "لا أوامر عمل للحذف.",
deleteConfirmMessage_two: "حذف أمري عمل؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmMessage_few: "حذف {{count}} أوامر عمل؟ لا يمكن التراجع عن هذا الإجراء.",
deleteConfirmMessage_many: "حذف {{count}} أمر عمل؟ لا يمكن التراجع عن هذا الإجراء.",
cancelSuccess_zero: "لم يُلغَ أي أمر عمل",
cancelSuccess_two: "تم إلغاء أمري عمل",
cancelSuccess_few: "تم إلغاء {{count}} أوامر عمل",
cancelSuccess_many: "تم إلغاء {{count}} أمر عمل",
deleteSuccess_zero: "لم يُحذف أي أمر عمل",
deleteSuccess_two: "تم حذف أمري عمل",
deleteSuccess_few: "تم حذف {{count}} أوامر عمل",
deleteSuccess_many: "تم حذف {{count}} أمر عمل",
},
emptyNoJobs: "لا توجد مهام",
emptyNoMatching: "لا توجد مهام مطابقة",
emptyFilteredHint: "جرّب مصطلحات بحث مختلفة أو مسح عوامل التصفية.",
subtitleAttentionSummary: "{{overdue}} متأخرة · {{unscheduled}} غير مُجدولة",
webSubtitleSummary: "{{total}} مهمة · {{overdue}} متأخرة · {{inProgress}} قيد التنفيذ · {{dueSoon}} تحل قريبًا",
noAssetLinked: "لا يوجد أصل مرتبط",
metaAsset: "الأصل",
metaPriority: "الأولوية",
overview: {
queue: "القائمة",
status: "الحالة",
assignee: "المكلَّف",
workPath: "مسار العمل",
schedule: "الجدولة",
nextStep: "الخطوة التالية",
started: "بدأت",
completed: "اكتملت",
duration: "المدة",
quoteState: "حالة عرض السعر",
summary: "الملخص",
inspection: "الفحص",
},
notSet: "غير محدد",
emDash: "—",
nextStepFallback: "راجع في التفاصيل الكاملة",
workflowNextStep: {
awaitingFollowOn: "في انتظار موافقة المتابعة",
draft: "راجع التفاصيل وافتح المهمة",
openAwaitingAcceptance: "قبول أو رفض المهمة",
openSchedule: "جدولة المهمة",
openAssign: "تكليف المهمة",
rejected: "راجع الرفض وأعد التكليف",
scheduled: "بدء المهمة",
inProgress: "إكمال أو إيقاف مؤقت",
inProgressRework: "إعادة إرسال الإنجاز",
paused: "استئناف أو إعادة جدولة",
completed: "توثيق أو طلب إعادة العمل",
},
verifyCompletion: {
title: "اعتماد المهمة",
message: "اعتماد هذه المهمة؟ سيتم إشعار المكلَّف.",
confirm: "اعتماد",
},
video: {
unsupportedSource: "لا يمكن تشغيل هذا الفيديو من هذا الموقع.",
loadFailed: "تعذر تحميل الفيديو.",
},
notScheduled: "غير مُجدوَل",
openInspectionA11y: "فتح الفحص {{label}}",
media: {
closeImageViewer: "إغلاق عارض الصور",
closeVideoViewer: "إغلاق مشغل الفيديو",
},
kpi: {
overdueLabel: "متأخر",
overdueSub: "يحتاج إلى إجراء فوري",
inProgressLabel: "قيد التنفيذ",
inProgressSub: "يُنفَّذ حاليًا",
dueSoonLabel: "يحل قريبًا",
dueSoonSub: "الـ 72 ساعة القادمة",
},
command: {
openCalendar: "فتح التقويم",
createJob: "إنشاء مهمة",
refine: "تصفية",
clearFilters: "مسح عوامل التصفية",
exportCsv: "تصدير CSV",
},
exportCsvHeaders: {
title: "العنوان",
status: "الحالة",
asset: "الأصل",
priority: "الأولوية",
assignee: "المكلَّف",
updated: "تاريخ التحديث",
},
inspector: {
openJob: "فتح المهمة",
addUpdate: "إضافة تحديث",
accept: "قبول",
reject: "رفض",
assign: "تكليف",
schedule: "جدولة",
start: "بدء",
pause: "إيقاف مؤقت",
resume: "استئناف",
complete: "إكمال",
approve_rework: "الموافقة على إعادة العمل",
verify: "توثيق",
rework: "إعادة العمل",
},
workQueueHeading: "قائمة العمل",
queueEmpty: "لا توجد مهام في هذه القائمة.",
emptyMatchingWebTitle: "لا توجد مهام مطابقة",
emptyMatchingWebSub: "جرّب قائمة أخرى أو مسح عوامل التصفية.",
emptyBucketTitle: "لا توجد مهام في {{bucket}}",
emptyBucketSub: "بدّل إلى يحتاج إلى إجراء، مخطط له، أو السجل، أو مسح عوامل التصفية لتوسيع النتائج.",
goToNeedsAction: "الانتقال إلى يحتاج إلى إجراء",
goToNeedsActionA11y: "إظهار مهام يحتاج إلى إجراء",
clearJobFiltersA11y: "مسح عوامل تصفية المهام",
panelHeading: "تفاصيل المهمة",
emptyScopeTitle: "لا توجد مهام في النطاق",
emptyScopeSub: "عدّل عوامل التصفية أو القائمة أو نطاق الفريق لتحميل المهام.",
sectionOverview: "نظرة عامة",
sectionActivity: "النشاط",
noActivityYet: "لا يوجد نشاط حتى الآن.",
loading: "جارٍ تحميل المهام…",
emptyNoJobsYet: "لا توجد مهام حتى الآن",
emptyRecipientSub: "ستظهر هنا المهام من الفحوصات المشتركة معك بعد أن ينشئها المفتش من الإصلاحات المعتمدة.",
emptyOwnerSub: "أنشئ مهمة مباشرة أو حوّل الإصلاحات المعتمدة من فحص مشترك.",
viewActivity: "عرض النشاط",
canonicalStatus: {
  skipped: "تم تخطيه",
draft: "مسودة",
open: "مفتوحة",
accepted: "مقبولة",
scheduled: "مُجدولة",
in_progress: "قيد التنفيذ",
paused: "متوقفة مؤقتًا",
completed: "مكتملة",
verified: "معتمدة",
rejected: "مرفوضة",
cancelled: "ملغاة",
},
fabCreateA11y: "إنشاء مهمة",
detailWorkPath: {
change: "تغيير مسار العمل",
sheetTitle: "مسار العمل",
sheetHint: "اختر كيف تُنفَّذ هذه المهمة: فريق داخلي، متعهد واحد، أو طلب عروض أسعار.",
team: "الفريق",
contractor: "المتعهد",
quotes: "عروض الأسعار",
},
advancedFiltersSummary_zero: "لا تنقيات نشطة",
advancedFiltersSummary_two: "تنقيتان نشطتان",
advancedFiltersSummary_few: "{{count}} تنقيات نشطة",
advancedFiltersSummary_many: "{{count}} تنقية نشطة",
},
inspectionDetail: {
firstRunMomentumHint: "أجب عن كل بند بـ ناجح أو فاشل أو لا ينطبق. اضغط متابعة على أي شيء يحتاج إلى مهمة.",
firstRunGotIt: "حسنًا",
firstRunReportCta: "الإبلاغ عن مشكلة",
reportIssueNow: "الإبلاغ عن مشكلة الآن",
completeInspection: "إكمال الفحص",
completeShort: "إكمال",
continueInspection: "الاستمرار في الفحص",
continueShort: "استمرار",
manage: "إدارة",
manageSheetTitle: "إجراءات الفحص",
reassign: "إعادة التكليف",
pause: "إيقاف مؤقت",
cancel: "إلغاء الفحص…",
viewReport: "عرض التقرير",
nextSteps: "الخطوات التالية",
share: "مشاركة",
createJobs: "إنشاء مهام",
sendForApproval: "إرسال للموافقة",
shareReport: "مشاركة التقرير",
planFollowUp: "تخطيط متابعة",
planFollowUpHint: "خطوات اختيارية بعد إنهاء هذا الفحص.",
saveTemplate: "حفظ قائمة التحقق",
repeatOnSchedule: "تكرار حسب الجدول",
createJobNow: "إنشاء مهمة الآن",
notifyTeam: "إشعار الفريق",
moreMenuA11y: "مزيد من إجراءات الفحص",
},
assetDetail: {
  shareChooser: {
    intakeDescription: "دون حساب أو تسجيل دخول. يصل كل بلاغ إلى العمل كطلب، جاهزًا لتخطيط فحص أو مهمة.",
    intakeTitle: "السماح لأي شخص لديه الرمز بالإبلاغ عن مشكلة",
    personDescription: "سيرون هذا الأصل وفحوصاته ومستنداته. اختر يمكن طلب العمل في الخطوة التالية إذا كان يجب أن يبلغوا عن المشكلات أيضًا.",
    personTitle: "مشاركة مع شخص أو فريق",
  },
  publicIntakeCard: {
    turnOff: "إيقاف",
    keepOn: "إبقاؤه مفعّلًا",
    turnOffBody: "ستتوقف الرموز المطبوعة والروابط المشتركة عن العمل حتى تعيد تفعيله.",
    turnOffTitle: "إيقاف الإبلاغ؟",
    copyFailedBody: "حاول مرة أخرى. يمكنك أيضًا أخذ لقطة شاشة للرمز ومشاركتها.",
    copyFailedTitle: "تعذر نسخ الرابط",
    linkCopied: "تم نسخ الرابط. الصقه حيث يجب أن يبلغ الناس عن المشكلات.",
    tryAgain: "تحقق من اتصالك وحاول مرة أخرى.",
    updateFailedTitle: "لم يتم تغيير الإبلاغ",
    turnedOff: "الإبلاغ متوقف. لم يعد الرمز والرابط يقبلان البلاغات.",
    turnedOn: "الإبلاغ مفعّل. اطبع الرمز أو انسخ الرابط أدناه وضعه حيث يراه الناس.",
    printBody: "امسح الرمز للإبلاغ عن مشكلة. لا حاجة إلى حساب أو تسجيل دخول.",
    printTitle: "الإبلاغ عن مشكلة — {{name}}",
    popupBlockedBody: "اسمح بالنوافذ المنبثقة لهذا الموقع للطباعة، أو استخدم نسخ الرابط.",
    popupBlockedTitle: "تم حظر النافذة المنبثقة",
    noWebAddress: "الإبلاغ مفعّل، لكن هذا الإصدار من التطبيق لا يستطيع إنشاء الرابط. افتح هذا الأصل في AssetWRX عبر متصفح الويب لنسخ الرابط أو طباعة الرمز.",
    copyLinkA11y: "نسخ رابط الإبلاغ عن مشكلة",
    step3: "3. يصفون المشكلة. تظهر في العمل كطلب لتراجعه.",
    qrLabel: "رمز الإبلاغ عن مشكلة",
    title: "السماح لأي شخص بالإبلاغ عن مشكلة",
  },
overviewInspectionEmpty: "لا توجد فحوصات حتى الآن. استخدم",
startInspection: "بدء الفحص",
createJob: "إنشاء مهمة",
edit: "تعديل",
contactsSectionTitle: "جهات الاتصال المرتبطة",
viewActivity: "عرض النشاط",
toolsAi: "الأدوات والذكاء الاصطناعي",
generateAdvancedReport: "Asset 360",
askAi: "اسأل الذكاء الاصطناعي",
suggestNextSteps: "اقترح الخطوات التالية",
shareThisAssetModalTitle: "مشاركة هذا الأصل",
shareThisAssetAccessOnlySubtitle: "امنح شخصًا أو فريقًا حق الوصول إلى سجل هذا الأصل وفحوصاته ومستنداته.",
shareWithPersonAccessOnlyDescription: "يرون سجل هذا الأصل وفحوصاته ومستنداته.",
linkContactModalTitle: "ربط جهة اتصال",
shareWithContactCallout: "مشاركة هذا الأصل مع {{name}}",
journey: {
title: "المسار التشغيلي",
stage: {
created: "تم الإنشاء",
inspected: "اكتملت الفحوصات",
issues: "تم تسجيل المشكلات",
requests: "تم رفع الطلبات",
jobs: "اكتملت المهام",
reports: "تم إنشاء التقارير",
},
window: {
"30d": "30 يومًا",
"90d": "90 يومًا",
"365d": "سنة",
all: "الكل",
},
windowLabel: {
"30d": "خلال آخر 30 يومًا",
"90d": "خلال آخر 90 يومًا",
"365d": "خلال آخر 12 شهرًا",
all: "عبر السجل الكامل لهذا الأصل",
},
readOnlyHint: "لديك صلاحية قراءة فقط لمسار هذا الأصل.",
a11ySummaryLabel: "ملخص المسار التشغيلي",
a11yStageHint: "{{label}}: {{count}} خلال الفترة",
a11yStageSubline: "{{label}}: {{count}} خلال الفترة، {{subline}}",
zeroInWindow: "0 خلال {{window}}",
dateUnavailable: "التاريخ غير متاح",
ago: {
minutes: "منذ {{n}} د",
hours: "منذ {{n}} س",
days: "منذ {{n}} ي",
months_zero: "هذا الشهر",
months_one: "منذ شهر",
months_two: "منذ شهرين",
months_few: "منذ {{count}} أشهر",
months_many: "منذ {{count}} شهرًا",
months_other: "منذ {{count}} شهر",
years_zero: "هذا العام",
years_one: "منذ عام",
years_two: "منذ عامين",
years_few: "منذ {{count}} أعوام",
years_many: "منذ {{count}} عامًا",
years_other: "منذ {{count}} عام",
},
in: {
minutes: "خلال {{n}} د",
hours: "خلال {{n}} س",
days: "خلال {{n}} ي",
},
sublineIssueBreach: "أكثر من {{days}} يومًا بلا طلب",
sublineAwaitingApproval_zero: "لا شيء بانتظار الموافقة",
sublineAwaitingApproval_one: "واحد بانتظار الموافقة",
sublineAwaitingApproval_two: "اثنان بانتظار الموافقة",
sublineAwaitingApproval_few: "{{count}} بانتظار الموافقة",
sublineAwaitingApproval_many: "{{count}} بانتظار الموافقة",
sublineAwaitingApproval_other: "{{count}} بانتظار الموافقة",
summary: {
noActivity: "{{window}}، لا يوجد نشاط مسجّل لهذا الأصل.",
recommendBaseline: "يُوصى بجدولة فحص أساسي.",
hadBoth: "{{window}}، شهد هذا الأصل {{inspections}} و{{jobs}}.",
hadOne: "{{window}}، شهد هذا الأصل {{what}}.",
hadNone: "{{window}}، لم يُنجَز أي عمل لهذا الأصل بعد.",
inspections_zero: "لا فحوصات",
inspections_one: "فحصًا واحدًا",
inspections_two: "فحصين",
inspections_few: "{{count}} فحوصات",
inspections_many: "{{count}} فحصًا",
inspections_other: "{{count}} فحص",
jobsCompleted_zero: "لا مهام مكتملة",
jobsCompleted_one: "مهمة واحدة مكتملة",
jobsCompleted_two: "مهمتين مكتملتين",
jobsCompleted_few: "{{count}} مهام مكتملة",
jobsCompleted_many: "{{count}} مهمةً مكتملة",
jobsCompleted_other: "{{count}} مهمة مكتملة",
healthImproved: "تحسّنت الصحة التشغيلية من {{then}}/100 إلى {{now}}/100.",
healthDeclined: "تراجعت الصحة التشغيلية من {{then}}/100 إلى {{now}}/100.",
healthCurrent: "الصحة التشغيلية الحالية {{now}}/100، استنادًا إلى الامتثال والجداول والمهام والموافقات ونتائج الفحص.",
conditionUnscored_zero: "حالة الفحص غير مُقيَّمة: لا توجد فحوصات مكتملة.",
conditionUnscored_one: "حالة الفحص غير مُقيَّمة: الفحص المكتمل الوحيد ليس له تقييم صالح من 1 إلى 5.",
conditionUnscored_two: "حالة الفحص غير مُقيَّمة: لا يحمل أيٌّ من الفحصين المكتملين تقييمًا صالحًا من 1 إلى 5.",
conditionUnscored_few: "حالة الفحص غير مُقيَّمة: لا يحمل أيٌّ من الفحوصات المكتملة ({{count}}) تقييمًا صالحًا من 1 إلى 5.",
conditionUnscored_many: "حالة الفحص غير مُقيَّمة: لا يحمل أيٌّ من الفحوصات المكتملة ({{count}}) تقييمًا صالحًا من 1 إلى 5.",
conditionUnscored_other: "حالة الفحص غير مُقيَّمة: لا يحمل أيٌّ من الفحوصات المكتملة ({{count}}) تقييمًا صالحًا من 1 إلى 5.",
conditionOneRated: "لحالة الفحص فحص مُقيَّم واحد؛ يلزم فحص آخر لإظهار الاتجاه.",
issueOverdue: "مشكلة مفتوحة واحدة تأخّر رفع طلب بشأنها.",
requestsAwaiting_zero: "لا طلبات بانتظار الموافقة.",
requestsAwaiting_one: "طلب واحد بانتظار الموافقة.",
requestsAwaiting_two: "طلبان بانتظار الموافقة.",
requestsAwaiting_few: "{{count}} طلبات بانتظار الموافقة.",
requestsAwaiting_many: "{{count}} طلبًا بانتظار الموافقة.",
requestsAwaiting_other: "{{count}} طلب بانتظار الموافقة.",
excluded_zero: "لم يُستبعد أي فحص مكتمل: {{reasons}}.",
excluded_one: "استُبعد فحص مكتمل واحد: {{reasons}}.",
excluded_two: "استُبعد فحصان مكتملان: {{reasons}}.",
excluded_few: "استُبعدت {{count}} فحوصات مكتملة: {{reasons}}.",
excluded_many: "استُبعد {{count}} فحصًا مكتملًا: {{reasons}}.",
excluded_other: "استُبعد {{count}} فحص مكتمل: {{reasons}}.",
excludedMissing: "{{n}} بلا تاريخ إكمال",
excludedInvalid: "{{n}} بتاريخ إكمال غير صالح",
excludedFuture: "{{n}} بتاريخ في المستقبل",
},
},
},
quickComplete: {
moreOptions: "معالج الإكمال المتقدم",
moreOptionsA11y: "فتح معالج الإكمال المتقدم",
eyebrow: "إنجاز سريع",
needsMore: {
  invoice: "يحتاج هذا العمل أيضًا إلى تكاليفه وفاتورته. المتابعة تضيفها ثم تكمله.",
  meter: "يحتاج هذا العمل أيضًا إلى قراءة العداد. المتابعة تطلبها ثم تكمل العمل.",
  checks: "هناك أمر يجب حله قبل إكمال هذا العمل. المتابعة توضح ما هو.",
},
onePageTitle: "إكمال العمل",
continue: "متابعة",
submit: "إكمال المهمة",
step1: {
title: "ملاحظة سريعة",
noteLabel: "ماذا فعلت؟",
notePlaceholder: "سطر واحد — أُصلح، استُبدل، فُحص، نُظّف.",
noteA11y: "ملاحظة الإنجاز السريع",
dictateStart: "إملاء",
dictateStop: "إيقاف الإملاء الصوتي",
chipsLabel: "أو اضغط على وسم سريع",
},
step2: {
title: "إضافة دليل",
summary: "التقط صورة أو أرفق مستندًا. اختياري، لكنه موصى به.",
unavailable: "الأدلة المضمّنة غير متاحة هنا.",
},
step3: {
title: "إرسال",
summary: "أكّد وأنجز.",
note: "الملاحظة",
noNote: "لم تُضف ملاحظة",
tags: "العلامات",
evidence: "الدليل",
outcome: "النتيجة",
},
},
changeRequest: {
comeBack: {
  title: "أحتاج إلى العودة",
  hint: "زيارة أخرى في يوم آخر. يبقى العمل مفتوحًا ويُكمل مرة واحدة في النهاية.",
},
open: "لا يمكن الإكمال كما هو مُجدوَل",
openA11y: "الإبلاغ بعدم إمكانية إكمال هذا كما هو مُجدوَل",
eyebrow: "تم طلب تغيير",
step1: {
title: "ما الذي أوقفك؟",
summary: "اختر السبب الأقرب. يحدد ذلك من يجب إبلاغه.",
},
step2: {
  datePlaceholder: "اختر يومًا",
title: "ما الذي تحتاجه؟",
summary: "مديرك يقرر. لن يتغيّر شيء حتى يفعل.",
summaryImmediate: "يُطبَّق التخطي فورًا على هذا المخطط. تذهب بقية التفاصيل إلى مديرك.",
dateLabel: "نقله إلى",
assigneeLabel: "اقترح شخصًا",
assigneeHint: "هذا اقتراح فقط — قد يختار مديرك شخصًا آخر.",
},
step3: {
title: "هل هناك شيء آخر؟",
noteLabel: "إضافة تفاصيل",
notePlaceholder: "ما رأيته، ومن تحدثت إليه، وما الذي قد يزيل العائق.",
evidencePrompt: "الصورة تجعل الموافقة على هذا أسهل بكثير.",
submit: "إرسال الطلب",
submitImmediate: "تخطي هذه",
submitting: "جارٍ الإرسال…",
},
reason: {
no_access: "لا يوجد وصول",
asset_unavailable: "الأصل غير متاح",
asset_in_use: "الأصل قيد الاستخدام",
unsafe: "غير آمن للمتابعة",
parts_unavailable: "القطع غير متوفرة",
time_insufficient: "لا يوجد وقت كافٍ",
meter_inaccessible: "تعذّر الوصول إلى العداد",
specialist_required: "يتطلب مختصًا",
wrong_assignee: "يجب أن يكون شخصًا آخر",
done_elsewhere: "تم تنفيذه في مكان آخر",
not_required: "غير مطلوب",
bigger_than_described: "أكبر مما هو موصوف",
other: "شيء آخر",
},
action: {
reschedule: "نقله",
rescheduleBlurb: "نفس العمل، نفس الشخص، تاريخ لاحق.",
rescope: "تحتاج أكثر مما وُصف",
rescopeBlurb: "العمل نفسه، الشخص نفسه، لكنه أكبر مما وُصف. اذكر الوقت الذي يحتاجه فعلًا.",
rescopeLength: "كم يحتاج فعلًا؟ (بالدقائق)",
reassign: "شخص آخر",
reassignBlurb: "نفس العمل، لا يزال مستحقًا، شخص مختلف.",
skip: "تخطي هذه",
skipBlurb: "لن تُنجز هذه الزيارة. الزيارة التالية لا تزال مستحقة.",
},
status: {
  waitingOnApprover: "بانتظار قرار معتمد الأصل. سيصلك إشعار.",
pending: "تم طلب تغيير",
waitingOn: "بانتظار قرار {{name}}. سيصلك إشعار.",
approved: "تمت الموافقة على التغيير",
rejected: "لم تتم الموافقة على التغيير",
stillDue: "هذا العمل لا يزال مستحقًا",
},
review: {
  closeStale: "إغلاق الطلب",
  changedSinceDecide: "تغيّر هذا العمل بعد إرسال الطلب، لذا لم يعد بالإمكان اعتماده. أغلقه مع ملاحظة، ويمكنهم الطلب مرة أخرى إن احتاجوا.",
title: "مراجعة الطلب",
requestedBy: "طلبه {{name}}",
asked: "طُلب",
reason: "السبب",
evidence: "الدليل",
current: "حاليًا",
proposed: "المقترح",
changedSince: "تغيّر هذا العمل منذ رفع الطلب.",
approve: "الموافقة",
reject: "رفض",
editAndApprove: "تغيير والموافقة",
rejectNeedsNote: "اذكر السبب قبل الرفض",
changeDate: "الموافقة على تاريخ آخر",
changeAssignee: "الموافقة على شخص آخر",
note: "إضافة ملاحظة",
complianceWarning: "يحمل هذا الأصل واجب امتثال.",
},
},
completeWizard: {
needs: {
  title: "قوائم التحقق والأدلة",
  summary: "أكمل قائمة التحقق وأضف الصور. تُفحص الصور مقابل العمل نيابةً عنك.",
},
eyebrow: "إكمال المهمة",
addCosts: "إضافة التكاليف والفاتورة",
submit: "إرسال الإنجاز",
step1: {
title: "الملاحظات",
noteLabel: "ماذا فعلت؟",
notePlaceholder: "ملخص قصير — ما أصلحته، استبدلته، أو فحصته.",
noteA11y: "ملاحظة الإنجاز",
chipsLabel: "علامات سريعة",
dictate: "إملاء صوتي",
dictateStart: "إملاء صوتي",
dictateStop: "إيقاف الإملاء الصوتي",
improve: "تحسين بالذكاء الاصطناعي",
improving: "جارٍ التحسين…",
},
step2: {
title: "الدليل",
summary: "أضف دليلًا على العمل. صور، مستندات، أو فاتورة إذا لزم الأمر.",
addPhoto: "إضافة صورة",
addDocument: "إضافة مستند",
addInvoice: "إضافة فاتورة",
count_one: "عنصر واحد مرفق",
count_other: "{{count}} عنصر مرفق",
empty: "لا توجد أدلة مرفقة حتى الآن.",
count_zero: "لا عناصر مرفقة",
count_two: "عنصران مرفقان",
count_few: "{{count}} عناصر مرفقة",
count_many: "{{count}} عنصرًا مرفقًا",
analyze: "قراءة الصور",
addToNote: "إضافة النص المستخرج إلى الملاحظة",
},
step3: {
title: "التكاليف والفاتورة",
summary: "سجّل تكلفة أمر العمل هذا. أضف فاتورة أو إيصالًا إن وُجد.",
summaryInvoice: "سجّل تكلفة أمر العمل هذا وأرفق فاتورة. هذا العميل يشترطها.",
empty: "لا يتوفر محرر تكاليف هنا. استخدم عرض الإدارة لتسجيل التكاليف.",
},
step4: {
title: "النتيجة",
summary: "كيف انتهت هذه المهمة؟",
followUpHint: "سنقترح إنشاء مهمة متابعة بعد الإرسال.",
},
step5: {
title: "مراجعة وإرسال",
summary: "أكّد ما سيتم إرساله.",
note: "الملاحظة",
noNote: "لم تُضف ملاحظة",
tags: "العلامات",
evidence: "الدليل",
outcome: "النتيجة",
cost: "التكلفة",
noCost: "لم تُسجَّل",
invoice: "الفاتورة",
invoiceNone: "بلا",
evidenceNone: "بلا",
blockersTitle: "أصلح قبل الإرسال:",
invoiceAttached: "{{n}} مرفقة",
invoiceRequiredMissing: "مطلوبة — لم تُرفق أي فاتورة",
invoiceRequiredBlocker: "هذا العميل يشترط فاتورة. أرفق واحدة في التكاليف والفاتورة، أو أنشئها هناك.",
},
chips: {
fixed: "تم الإصلاح",
replaced: "تم الاستبدال",
inspected: "تم الفحص",
cleaned: "تم التنظيف",
needsFollowUp: "يحتاج إلى متابعة",
unableToComplete: "تعذّر الإكمال",
},
outcomes: {
completed: "مكتمل",
partial: "مكتمل جزئيًا",
followUp: "يحتاج إلى متابعة",
unable: "تعذّر الإكمال",
},
step0: {
title: "الفحص اللاحق",
done: "اكتملت كل الفحوصات. تابع لإغلاق أمر العمل.",
summary: "أجب عن كل خطوة من الفحص البعدي. لا يمكن إرسال أمر العمل قبل إتمامه.",
},
},
jobMode: {
switcher: {
enterFocus: "وضع التركيز",
exitFocus: "المهمة كاملة",
a11yEnterFocus: "التركيز على تنفيذ العمل — إخفاء تفاصيل الإدارة",
a11yExitFocus: "عرض مساحة عمل المهمة كاملة",
},
report: {
open: "فتح تقرير الإكمال",
title: "تقرير الإنجاز",
fallbackTitle: "مهمة",
missingJob: "لم يُعثر على أمر العمل.",
followOn: "أعمال المتابعة",
shareTitle: "مشاركة تقرير الإنجاز",
shareAction: "مشاركة",
shareReviewLink: "مشاركة رابط المراجعة",
shareSheetTitle: "مشاركة التقرير",
summaryEyebrow: "ملخص الإغلاق",
notesEyebrow: "ملاحظات الإنجاز",
noNotes: "—",
checksEyebrow: "الفحوصات القبلية والبعدية",
evidenceEyebrow: "الأدلة والمرفقات",
recentExports: "عمليات التصدير الأخيرة",
optionsTitle: "خيارات التقرير",
fields: {
job: "مهمة",
jobType: "نوع أمر العمل",
parentJob: "أمر العمل الأصلي",
asset: "الأصل",
location: "الموقع",
assignedTo: "مُسند إلى",
status: "الحالة",
submitted: "مُرسَل",
verified: "موثقة",
completed: "مكتمل",
actualCost: "التكلفة الفعلية",
},
},
},
maintenance: {
  steps: {
    keep: "الإبقاء على الخطوات",
    close: "إغلاق",
    failed: "تعذّر حفظ الخطوات",
    unlinked: "تم فك ربط الخطوات. أصبحت كل خطوة خطة مستقلة من جديد.",
    unlinkConfirm: "فك الربط",
    unlinkMessage: "تصبح كل خطوة خطة مستقلة من جديد وتحتفظ بجدولها. لا يُحذف أي شيء.",
    unlinkTitle: "فك ربط هذه الخطوات؟",
    unlink: "فك ربط الخطوات",
    saved: "تم حفظ الخطوات.",
    save: "حفظ الخطوات",
    inOrderOff: "تأتي كل خطوة حسب جدولها الخاص.",
    inOrderOn: "لا يُنشأ عمل الخطوة إلا عندما لا يكون للخطوة السابقة عمل مفتوح.",
    inOrderTitle: "تنفيذ الخطوات بالترتيب",
    moveDownA11y: "نقل {{name}} إلى الأسفل",
    moveUpA11y: "نقل {{name}} إلى الأعلى",
    removeA11y: "إزالة {{name}} من الخطوات",
    addA11y: "إضافة {{name}} كخطوة",
    add: "إضافة",
    inOtherSet: "حاليًا خطوة في {{name}}",
    otherLabel: "خطط أخرى على هذا الأصل",
    needTwo: "أضف خطتين على الأقل من القائمة أدناه.",
    stepsLabel: "الخطوات بالترتيب",
    namePlaceholder: "مثال: صيانة المولد",
    nameLabel: "الاسم",
    intro: "الخطوات خطط تنتمي إلى بعضها، مثل صيانة كل 500 ساعة و1000 ساعة و2000 ساعة.",
    titleEdit: "تعديل الخطوات",
    titleNew: "ربط الخطط كخطوات",
    addStep: "إضافة خطوة",
    editSteps: "تعديل الخطوات",
    linkSteps: "ربط الخطط كخطوات",
  },
  list: {
    status: {
      cancelled: "ملغاة",
      ended: "منتهية",
      paused: "متوقفة مؤقتًا",
      active: "نشطة",
    },
    openJobA11y: "فتح المهمة الحالية لـ {{name}}",
    editA11y: "تعديل {{name}}",
    untitled: "خطة بلا عنوان",
    groupA11y: "{{asset}}: {{n}} خطط. يفتح الأصل.",
    emptyBody: "أضف خطة لعمل يتكرر — صيانة شهرية أو اختبار سنوي. في كل مرة يحين موعده، تظهر المهمة في العمل.",
    tryAgain: "حاول مرة أخرى",
    loadFailed: "تعذّر تحميل خطط الصيانة. تحقق من اتصالك وحاول مرة أخرى.",
    activeMany: "{{live}} خطط قيد التشغيل",
    activeOne: "خطة واحدة قيد التشغيل",
    noneActive: "لا توجد خطة قيد التشغيل. استأنف خطة أو أضف خطة جديدة.",
    dueInDays: "الموعد التالي بعد {{days}} أيام",
    dueTomorrow: "الموعد التالي غدًا",
    dueToday: "الموعد التالي اليوم",
    overdueDays: "متأخر {{days}} أيام",
    overdueOneDay: "متأخر يومًا واحدًا",
    doneCount: "أُنشئ {{done}}",
    doneOfMax: "أُنشئ {{done}} من {{max}}",
  },
  cadence: {
    fromLastDone: "{{cadence}}، تُحسب من وقت إنجاز المرة السابقة",
    oneOff: "لمرة واحدة",
    either: "{{first}} أو {{second}}، أيهما أقرب",
    everyAmount: "كل {{amount}}",
    everyNYears_zero: "كل {{count}} سنة",
    everyNYears_one: "كل سنة",
    everyNYears_two: "كل سنتين",
    everyNYears_few: "كل {{count}} سنوات",
    everyNYears_many: "كل {{count}} سنة",
    everyNYears_other: "كل {{count}} سنة",
    everyYear: "كل سنة",
    everyNMonths_zero: "كل {{count}} شهر",
    everyNMonths_one: "كل شهر",
    everyNMonths_two: "كل شهرين",
    everyNMonths_few: "كل {{count}} أشهر",
    everyNMonths_many: "كل {{count}} شهرًا",
    everyNMonths_other: "كل {{count}} شهر",
    everyMonth: "كل شهر",
    everyNWeeks_zero: "كل {{count}} أسبوع",
    everyNWeeks_one: "كل أسبوع",
    everyNWeeks_two: "كل أسبوعين",
    everyNWeeks_few: "كل {{count}} أسابيع",
    everyNWeeks_many: "كل {{count}} أسبوعًا",
    everyNWeeks_other: "كل {{count}} أسبوع",
    everyWeek: "كل أسبوع",
    everyNDays_zero: "كل {{count}} يوم",
    everyNDays_one: "كل يوم",
    everyNDays_two: "كل يومين",
    everyNDays_few: "كل {{count}} أيام",
    everyNDays_many: "كل {{count}} يومًا",
    everyNDays_other: "كل {{count}} يوم",
    everyDay: "كل يوم",
    everyNHours_zero: "كل {{count}} ساعة",
    everyNHours_one: "كل ساعة",
    everyNHours_two: "كل ساعتين",
    everyNHours_few: "كل {{count}} ساعات",
    everyNHours_many: "كل {{count}} ساعة",
    everyNHours_other: "كل {{count}} ساعة",
    everyHour: "كل ساعة",
  },
title: "الصيانة",
recordReading: "تسجيل قراءة",
addPlan: "إضافة خطة",
startNow: "البدء الآن",
exceptions: {
lead: "معظم حالات التخطي سببها \"{{reason}}\" — بنسبة {{share}}% منها.",
counts: "{{skipped}} تم تخطيه · {{missed}} فائت",
emptyDimension: "لم يُسجَّل شيء بعد على هذا — جرّب تصنيفًا آخر.",
noSite: "بلا موقع",
unassigned: "غير مُكلَّف",
by: {
reason: "السبب",
asset: "الأصل",
site: "الموقع",
assignee: "المكلَّف",
programme: "الخطة",
team: "الفريق",
},
},
card: {
  ok: "حسنًا",
  actionFailedBody: "لم يتغير شيء. تحقق من اتصالك وحاول مرة أخرى.",
  allPlans: "كل الخطط",
heading: "خطط الصيانة",
attention_one: "خطة واحدة تحتاج إلى اهتمام",
attention_other: "{{count}} خطة تحتاج إلى اهتمام",
allOnTrack: "جميع المخططات في المسار الصحيح",
pausedCount_zero: "لا مخططات متوقفة مؤقتًا",
pausedCount_one: "{{count}} مخطط متوقف مؤقتًا",
pausedCount_two: "مخططان متوقفان مؤقتًا",
pausedCount_few: "{{count}} مخططات متوقفة مؤقتًا",
pausedCount_many: "{{count}} مخططًا متوقفًا مؤقتًا",
pausedCount_other: "{{count}} مخطط متوقف مؤقتًا",
nextUp: "التالي: {{what}}",
showAll: "إظهار جميع المخططات ({{count}})",
showFewer: "إظهار أقل",
expandHint: "يعرض ما هو قادم وإجراءات المخطط",
status: {
job_overdue: "مهمة مفتوحة · متأخرة",
overdue: "متأخر",
job_due: "مهمة مفتوحة · مستحقة الآن",
due: "مستحق الآن",
no_reading: "يحتاج إلى قراءة",
due_soon: "يحل قريبًا",
due_soon_days_one: "يحل غدًا",
due_soon_days_other: "يحل بعد {{count}} يوم",
due_soon_amount: "يحل في {{amount}}",
job: "مهمة مفتوحة",
waits: "ينتظر {{stage}}",
waits_generic: "ينتظر الخطوة السابقة",
afterStep: "بعد الخطوة {{n}}",
skipped: "تم تخطيه هذه المرة",
upcoming_date: "التالي {{when}}",
upcoming_time: "التالي في {{time}}",
upcoming_meter: "التالي عند {{amount}}",
upcoming_none: "يعمل عند البدء",
upcoming_condition: "مراقبة الحالة",
paused: "متوقف مؤقتًا",
due_soon_days_zero: "يحل اليوم",
due_soon_days_two: "يحل بعد يومين",
due_soon_days_few: "يحل بعد {{count}} أيام",
due_soon_days_many: "يحل بعد {{count}} يومًا",
},
cadence: {
manual: "عندما يبدأه أحد",
fixedDate: "مرة واحدة، في {{when}}",
fixedDates_zero: "لا توجد تواريخ محددة",
fixedDates_one: "في تاريخ محدد واحد",
fixedDates_two: "في تاريخين محددين",
fixedDates_few: "في {{count}} تواريخ محددة",
fixedDates_many: "في {{count}} تاريخًا محددًا",
fixedDates_other: "في {{count}} تاريخ محدد",
condition: "عندما تنخفض حالته إلى {{score}} أو أقل",
renewal: "عندما يحل تجديد مستنده",
byMeter: {
operating_hours: "حسب ساعات تشغيل الآلة",
mileage: "حسب المسافة المقطوعة",
cycles: "حسب الدورات",
custom_numeric: "حسب قراءة العداد",
electricity: "حسب عداد الكهرباء",
gas: "حسب عداد الغاز",
water: "حسب عداد المياه",
heat: "حسب عداد الحرارة",
oil: "حسب عداد الزيت",
},
},
comingUp: "القادم",
lastDone: "آخر تنفيذ",
notDoneYet: "لم يُنفَّذ حتى الآن",
perDay: "{{count}} يوميًا بعد ذلك",
jobOpen: "مهمة مفتوحة",
either: "{{amount}} أو {{when}}، أيهما أولًا",
nothingNext: "لا يوجد شيء مُجدوَل. يعمل عندما يبدأه أحد.",
nothingNextCondition: "يُنشأ العمل عندما تنخفض درجة الحالة إلى هذا الحد.",
pausedNext: "لا يُرفع شيء أثناء إيقاف المخطط مؤقتًا.",
steps_sequential_zero: "{{count}} خطوة، تُنفَّذ بالترتيب",
steps_sequential_one: "خطوة واحدة، تُنفَّذ بالترتيب",
steps_sequential_two: "خطوتان، تُنفَّذ بالترتيب",
steps_sequential_few: "{{count}} خطوات، تُنفَّذ بالترتيب",
steps_sequential_many: "{{count}} خطوةً، تُنفَّذ بالترتيب",
steps_sequential_other: "{{count}} خطوة، تُنفَّذ بالترتيب",
steps_independent_zero: "لا خطط في هذه المجموعة",
steps_independent_one: "خطة واحدة في هذه المجموعة",
steps_independent_two: "خطتان في هذه المجموعة",
steps_independent_few: "{{count}} خطط في هذه المجموعة",
steps_independent_many: "{{count}} خطة في هذه المجموعة",
steps_independent_other: "{{count}} خطة في هذه المجموعة",
step: "الخطوة {{n}}",
openJob: "فتح المهمة",
startNow: "البدء الآن",
edit: "تعديل",
bringForward: "تقديم الموعد",
endStep: "إنهاء الخطوة",
pause: "إيقاف مؤقت",
resume: "استئناف",
end: "إنهاء المخطط",
endTitle: "إنهاء هذا المخطط؟",
endMessage: "لن يُنشأ عمل جديد. يبقى العمل المرفوع مسبقًا في العمل، ويبقى سجله على الأصل.",
keep: "الاحتفاظ بالمخطط",
actionFailed: "تعذّر تغيير المخطط",
attention_zero: "لا خطط تحتاج إلى اهتمام",
attention_two: "خطتان تحتاجان إلى اهتمام",
attention_few: "{{count}} خطط تحتاج إلى اهتمام",
attention_many: "{{count}} خطة تحتاج إلى اهتمام",
},
startFailedTitle: "تعذّر بدؤه",
noReading: "لا توجد قراءة عداد حتى الآن.",
noPlans: "لا يوجد مخطط صيانة حتى الآن.",
plansHeading: "الخطط · {{n}}",
plansHeadingNone: "الخطط",
meters: {
heading: "العدادات · {{n}}",
since: "{{amount}} منذ {{when}}",
record: "تسجيل قراءة",
},
emptyReadingTitle: "لم تُسجَّل قراءة",
emptyReadingBody: "تحتاج المخططات التي تُحسب بالاستخدام إلى قراءة تُقاس منها.",
emptyPlansTitle: "لا توجد خطط بعد",
emptyPlansBody: "اضغط «إضافة خطة» لعمل يتكرر — صيانة أو اختبار أو فحص. يظهر كل منها في العمل عندما يحين موعده.",
kind: {
mileage: "المسافة المقطوعة",
operating_hours: "الساعات",
cycles: "الدورات",
electricity: "الكهرباء",
gas: "الغاز",
water: "المياه",
heat: "الحرارة",
oil: "زيت التدفئة",
custom_numeric: "أخرى",
},
unit: {
mi: "ميل",
km: "كم",
h: "س",
cycles: "دورة",
},
source: {
manual: "مُدخَل يدويًا",
local_ml: "من صورة",
imported: "مستورد",
api: "API",
iot: "مستشعر",
},
sync: {
pending: "حُفظ على هذا الجهاز — سيتزامن عند الاتصال بالإنترنت.",
failed: "تعذّر الحفظ — تم تسجيل قراءة أعلى أولًا.",
},
rowTitle: {
due_soon_meter: "{{title}} يحل في {{amount}}",
due_meter: "{{title}} مستحق الآن",
overdue_meter: "{{title}} متأخر بمقدار {{amount}}",
due_soon_calendar: "{{title}} يحل قريبًا",
due_calendar: "{{title}} يحل اليوم",
overdue_calendar: "{{title}} متأخر",
},
sheet: {
  typeReading: "اكتب القراءة. تُحفظ الصورة كدليل، ويمكن لتطبيق الهاتف قراءة الرقم منها.",
  kind: "العداد",
  noMeterId: "بلا رقم عداد",
  newMeter: "عداد جديد",
  meterId: "رقم العداد (اختياري)",
  meterIdPlaceholder: "الرقم التسلسلي أو رقم الإمداد",
  unit: "الوحدة",
title: "تسجيل قراءة عداد",
close: "إغلاق",
value: "القراءة",
when: "وقت القراءة",
whenInvalid: "اختر تاريخًا ووقتًا صحيحين.",
currentIs: "الحالي: {{amount}} · {{when}}",
reading: "جارٍ قراءة الصورة على هذا الجهاز…",
detected: "تم رصد قراءة العداد: {{amount}}",
trust: {
confirm: "تأكيد · تُقرأ على هذا الجهاز، دون استخدام رصيد الذكاء الاصطناعي",
check: "تحقق من هذا · تُقرأ على هذا الجهاز، دون استخدام رصيد الذكاء الاصطناعي",
},
use: "استخدام",
ignore: "تجاهل",
nothingDetected: "لم يتم رصد قراءة في الصورة — أدخلها يدويًا. تُحفظ الصورة كدليل.",
lower: "هذه القراءة أقل من الحالية {{amount}}.",
outOfOrder: "تم تسجيل قراءة بقيمة {{amount}} بعد هذا التاريخ. تحقق من وقت أخذ هذه القراءة.",
lowerAsk: "تسجيلها كتصحيح؟ تبقى القراءة السابقة في السجل ولكنها تتوقف عن الحساب.",
lowerHint: "تحقق من الرقم، أو اطلب من المدير تسجيل تصحيح.",
correctionNote: "لماذا القراءة السابقة خاطئة؟",
correctionNoteRequired: "اذكر سبب خطأ القراءة السابقة.",
unitMismatch: "يقيس هذا العداد بوحدة {{unit}}.",
save: "حفظ القراءة",
saveCorrection: "حفظ كتصحيح",
saving: "جارٍ الحفظ…",
failed: "تعذّر حفظ القراءة.",
savedOfflineTitle: "تم الحفظ على هذا الجهاز",
savedOffline: "سيتم التزامن عند إعادة الاتصال بالإنترنت.",
recent: "القراءات الأخيرة",
correctionTag: "تصحيح",
},
},
contractor: {
title: "أعمالي",
view: {
new: "جديد",
upcoming: "للتنفيذ",
in_progress: "قيد التنفيذ",
awaiting_review: "في الانتظار",
complete: "منجز",
},
empty: {
new: "لا توجد طلبات جديدة حالياً",
upcoming: "لا يوجد شيء مجدول",
in_progress: "لا يوجد عمل جارٍ",
awaiting_review: "لا يوجد شيء لدى العميل",
complete: "لم يكتمل شيء بعد",
},
emptyHint: {
new: "ستظهر هنا الدعوات وطلبات التسعير.",
upcoming: "ستظهر هنا الأعمال التي قبلتها.",
in_progress: "ابدأ عملاً من قائمة القادم عند وصولك.",
awaiting_review: "ما ترسله ينتظر هنا حتى تتم الموافقة عليه.",
complete: "ستظهر هنا الأعمال التي وافق عليها العميل.",
},
quoteFallbackTitle: "طلب تسعير",
clientOther: "أخرى",
next: {
quote: "أرسل سعراً أو اعتذر",
waitingClient: "بانتظار العميل",
},
notLinked: {
title: "لم يتم تسجيلك كمقاول بعد",
body: "اطلب من عميلك إضافتك بالبريد الإلكتروني الذي سجّلت به، وستظهر أعماله هنا.",
bodyWithEmail: "اطلب من عميلك إضافتك كمقاول باستخدام {{email}}. ستظهر أعماله وطلبات عروض الأسعار هنا.",
checkAgain: "تحقّق مرة أخرى",
checking: "جارٍ التحقق…",
},
loadFailed: {
title: "لم يتم تحميل أعمالك",
body: "تحقّق من اتصالك، ثم اضغط إعادة المحاولة.",
retry: "إعادة المحاولة",
},
},
planning: {
  lockedHint: "وزّع الزيارات على الأشخاص والأوقات، واطّلع على وقت التنقل، واحصل على خطة مقترحة لليوم.",
  leave: {
    message_other: "لديك {{count}} تغيير في الخطة لم يُحفظ بعد. تجاهلها، أو تابع التخطيط واضغط تطبيق.",
    message_many: "لديك {{count}} تغييرًا في الخطة لم يُحفظ بعد. تجاهلها، أو تابع التخطيط واضغط تطبيق.",
    message_few: "لديك {{count}} تغييرات في الخطة لم تُحفظ بعد. تجاهلها، أو تابع التخطيط واضغط تطبيق.",
    message_two: "لديك تغييران في الخطة لم يُحفظا بعد. تجاهلهما، أو تابع التخطيط واضغط تطبيق.",
    message_one: "لديك تغيير واحد في الخطة لم يُحفظ بعد. تجاهله، أو تابع التخطيط واضغط تطبيق.",
    message_zero: "لا توجد تغييرات غير محفوظة في الخطة.",
    discard: "تجاهل التغييرات",
    keep: "متابعة التخطيط",
    title: "المغادرة دون حفظ الخطة؟",
  },
range: {
day: "يوم",
threeDay: "3 أيام",
week: "أسبوع",
month: "شهر",
agenda: "أسبوعان",
a11y: "نطاق التقويم",
},
nav: {
previousA11y: "أبكر",
nextA11y: "لاحقًا",
today: "اليوم",
todayA11y: "الانتقال إلى اليوم",
},
lane: {
unassigned: "غير معيّن",
you: "أنت",
unnamed: "شخص بلا اسم",
notWorking: "لا يعمل",
timeOff: "في إجازة",
more: "+{{count}} أخرى",
moreA11y: "عرض {{count}} أخرى عند {{time}}",
showLess: "عرض أقل",
load: "{{percent}}٪ مخطَّط · {{work}}",
capacityA11y: "{{name}}: تم تخطيط {{percent}}٪ من اليوم",
},
summary: {
jobs_zero: "لا زيارات",
jobs_one: "زيارة واحدة",
jobs_two: "زيارتان",
jobs_few: "{{count}} زيارات",
jobs_many: "{{count}} زيارةً",
jobs_other: "{{count}} زيارة",
work: "{{duration}} عمل",
travel: "{{duration}} تنقّل",
travelEstimated: "نحو {{duration}} تنقّل",
travelUnknown_zero: "لا رحلات بلا موقع",
travelUnknown_one: "رحلة واحدة بلا موقع",
travelUnknown_two: "رحلتان بلا موقع",
travelUnknown_few: "{{count}} رحلات بلا موقع",
travelUnknown_many: "{{count}} رحلة بلا موقع",
travelUnknown_other: "{{count}} رحلة بلا موقع",
free: "{{duration}} متاحة",
overtime: "{{duration}} وقت إضافي",
},
readiness: {
ready: "جاهزة {{count}}",
parts: "تنقصها قطع {{count}}",
capacity: "لا أحد متاح أو مؤهل {{count}}",
other: "بالانتظار {{count}}",
defer: "يمكن تأجيلها {{count}}",
},
unplanned: {
nobody: "له موعد، لكن لم يُكلَّف به أحد",
title: "غير مخطَّط · {{count}}",
empty: "كل ما في العرض مخطَّط.",
filterDue: "المستحقة",
filterAll: "الكل",
filterA11y: "أي الأعمال غير المخطَّطة تُعرض",
due: "يستحق {{date}}",
overdue: "متأخر",
},
reason: {
parts_unavailable: "القطعة غير متوفرة",
technician_unavailable: "لا أحد متاح",
skill_missing: "المهارة غير متوفرة",
dependency: "بانتظار عمل آخر",
no_capacity: "لا طاقة استيعابية",
location_missing: "لا موقع",
appointment_conflict: "يتعذّر الالتزام بالموعد",
outside_hours: "خارج ساعات العمل",
awaiting_approval: "بانتظار الموافقة",
declined: "مرفوض",
crew_unavailable: "لا يوجد عدد كافٍ من الأشخاص المتفرغين في الوقت نفسه",
},
signal: {
overlap: "حجز مزدوج",
insufficient_travel: "وقت التنقّل غير كافٍ",
skill_missing: "المهارة ناقصة",
parts_unavailable: "القطعة غير متوفرة",
outside_appointment: "خارج الموعد",
outside_hours: "خارج ساعات العمل",
technician_unavailable: "في إجازة",
dependency_unmet: "بانتظار عمل آخر",
after_due: "بعد تاريخ الاستحقاق",
urgent: "أولوية عالية",
parts_ready: "القطع جاهزة",
parts_unknown: "القطع غير مؤكدة",
appointment: "نافذة الموعد",
awaiting_acceptance: "بانتظار القبول",
confirmed: "مؤكد",
locked: "وقت مثبّت",
duration_default: "مدة تقديرية",
duration_learned: "المدة المعتادة",
multi_day: "يمتد على عدة أيام",
crew_visit: "ضمن الفريق",
via_pickup: "استلام قطعة في الطريق",
},
state: {
pending: "مقترح",
in_progress: "قيد التنفيذ",
done: "تم",
},
travel: {
block: "{{duration}} تنقّل · {{distance}}",
estimated: "نحو {{duration}} تنقّل · {{distance}}",
a11y: "التنقّل: {{duration}}",
estimateNote: "وقت التنقل تقديري من المسافة المستقيمة بسرعة القيادة داخل المدينة ودون حركة المرور. اضغط على رحلة للتحقق منها في الخرائط.",
roadNote: "وقت التنقل هو الوقت المعتاد على الطريق من دون حركة مرور مباشرة. اضغط على رحلة للتحقق منها في الخرائط.",
short: "{{duration}} تنقّل",
shortEstimated: "نحو {{duration}} تنقّل",
},
week: {
legend: {
work: "عمل",
travel: "تنقّل",
free: "متاح",
overtime: "خارج ساعات العمل",
},
openDayA11y: "تخطيط {{day}}",
cellA11y: "{{name}}، {{day}}: {{percent}}٪ مخطَّط، {{work}} عمل، {{travel}} تنقّل",
cellOffA11y: "{{name}}، {{day}}: لا يعمل",
percent: "{{percent}}٪",
free: "متاح",
hoursUnknown: "ساعات العمل غير معروفة",
unplannedDue: "غير مخطَّط، مستحق",
forecast: "مع العمل المتوقع",
forecastOver: "يزيد بمقدار {{duration}}",
forecastFits: "يتسع",
},
panel: {
assignedTo: "مُسند إلى",
nobody: "لا أحد بعد. اختر من ينفّذ هذا.",
partArrives: "إذا وصلت القطعة في",
planFromThen: "التخطيط من ذلك الحين",
makeRoom: "إفساح المجال",
makeRoomHint: "هذا يقع فوق زيارة أخرى. اعرض على تلك الزيارة مكانًا جديدًا.",
day: "اليوم",
start: "البدء",
length: "المدة",
ends: "ينتهي {{time}}",
notPlanned: "غير مخطط",
moreNotes_zero: "لا ملاحظات أخرى",
moreNotes_one: "ملاحظة أخرى",
moreNotes_two: "ملاحظتان أخريان",
moreNotes_few: "{{count}} ملاحظات أخرى",
moreNotes_many: "{{count}} ملاحظة أخرى",
moreNotes_other: "{{count}} ملاحظة أخرى",
fewerNotes: "ملاحظات أقل",
staged: "لم يُحفظ بعد",
fixed: "بدأ هذا العمل أو تم تأكيده، لذا يبقى في مكانه.",
awaitingApproval: "بانتظار الموافقة. لا يمكن تخطيطه بعد.",
previousDayA11y: "اليوم السابق",
nextDayA11y: "اليوم التالي",
earlierA11y: "البدء قبل 15 دقيقة",
laterA11y: "البدء بعد 15 دقيقة",
shorterA11y: "أقصر بـ 15 دقيقة",
longerA11y: "أطول بـ 15 دقيقة",
remove: "إزالة من الخطة",
pin: "تثبيت هذا الوقت",
unpin: "إلغاء تثبيت الوقت",
undo: "تراجع عن التغيير",
open: "فتح",
closeA11y: "إغلاق لوحة الخطة",
},
apply: {
changes_zero: "لا تغييرات غير محفوظة",
changes_one: "تغيير واحد غير محفوظ",
changes_two: "تغييران غير محفوظين",
changes_few: "{{count}} تغييرات غير محفوظة",
changes_many: "{{count}} تغييرًا غير محفوظ",
changes_other: "{{count}} تغيير غير محفوظ",
notifies: "عند التطبيق يُبلَّغ {{names}}",
discard: "تجاهل",
apply: "تطبيق",
breaks: "يخالف قاعدة: {{rules}}",
reasonLabel: "سبب المتابعة",
reload: "إعادة التحميل",
done: "تم حفظ الخطة",
conflict: "غيّر شخص آخر {{days}} أثناء تخطيطك. أعد التحميل لرؤيته. تغييراتك محفوظة.",
failed_zero: "تعذّر حفظ التغييرات: {{message}}",
failed_one: "تعذّر حفظ تغيير واحد: {{message}}",
failed_two: "تعذّر حفظ تغييرين. الأول: {{message}}",
failed_few: "تعذّر حفظ {{count}} تغييرات. الأول: {{message}}",
failed_many: "تعذّر حفظ {{count}} تغييرًا. الأول: {{message}}",
failed_other: "تعذّر حفظ {{count}} تغيير. الأول: {{message}}",
error: "تعذّر حفظ الخطة. {{message}}",
partial: "تم تطبيق {{applied}} من {{requested}} تغييرات",
none_zero: "تعذّر تطبيق أي من التغييرات الـ{{count}}",
none_one: "تعذّر تطبيق التغيير",
none_two: "تعذّر تطبيق أيٍّ من التغييرين",
none_few: "تعذّر تطبيق أي من التغييرات الـ{{count}}",
none_many: "تعذّر تطبيق أي من التغييرات الـ{{count}}",
none_other: "تعذّر تطبيق أي من التغييرات الـ{{count}}",
unsettled: "كُتبت التغييرات لكن تعذّر تأكيد النتيجة. أعد التحميل للتحقق من الخطة.",
reviewIssues_zero: "لا مشكلات للمراجعة",
reviewIssues_one: "مراجعة مشكلة واحدة",
reviewIssues_two: "مراجعة مشكلتين",
reviewIssues_few: "مراجعة {{count}} مشكلات",
reviewIssues_many: "مراجعة {{count}} مشكلة",
reviewIssues_other: "مراجعة {{count}} مشكلة",
issues: {
title: "تغييرات لم تُطبَّق",
appliedLine_zero: "لم يُطبَّق أي تغيير",
appliedLine_one: "تم تطبيق تغيير واحد",
appliedLine_two: "تم تطبيق تغييرين",
appliedLine_few: "تم تطبيق {{count}} تغييرات",
appliedLine_many: "تم تطبيق {{count}} تغييرًا",
appliedLine_other: "تم تطبيق {{count}} تغيير",
retry: "إعادة محاولة ما فشل",
keep: "الاحتفاظ بما طُبِّق",
discardRest: "تجاهل الباقي",
open: "فتح",
closeA11y: "إغلاق مراجعة التغييرات التي لم تُطبَّق",
code: {
refused: "غير مسموح",
not_persisted: "لم يُحفظ",
unverified: "تعذر التحقق من الحفظ",
missing: "لم يعد موجودًا",
},
},
recover: "لم يكتمل تحديث سابق للخطة.",
recoverAction: "مراجعة",
recovered: {
applied: "كان التحديث السابق قد طُبِّق بالكامل.",
failed: "لم يُطبَّق أي شيء من التحديث السابق.",
},
stale: "غيّر شخص ما {{days}} بعد تغييراتك. راجع اللوحة، ثم احتفظ بتغييراتك أو تجاهلها.",
staleAction: "الاحتفاظ بتغييراتي",
overrideNote: "{{rule}}، تم تجاوزه: {{reason}}",
},
optimise: {
action: "اقتراح خطة",
title: "الخطة المقترحة",
whatIfA11y: "ماذا لو غاب {{name}}؟",
whyShow: "لماذا هذه الخطة",
whyHide: "إخفاء الأسباب",
scenarioOff: "ماذا لو كان {{name}} في إجازة",
scenarioArrival: "ماذا لو وصلت القطعة في {{date}}",
scenarioNote: "معاينة فقط. لا يتغير شيء حتى تضغط استخدام هذه الخطة.",
working: "جارٍ إعداد الخطة… {{seconds}} ث",
stop: "إيقاف",
useScenario: "استخدام هذه الخطة",
closeA11y: "إغلاق الخطة المقترحة",
removeA11y: "ترك {{title}} كما هو",
why: {
placed: "وُضع هنا بسبب: {{list}}.",
held: "ما زال غير مخطط: {{list}}.",
reason: "{{count}} × {{reason}}",
blocker: "{{count}} × {{reason}}",
join: " · ",
},
whyReason: {
required_skill: "المهارة المطلوبة",
parts_ready: "القطع جاهزة",
due_today: "مستحق في ذلك اليوم",
urgent: "أولوية عالية",
near_previous: "قريب من المحطة السابقة",
same_site: "في الموقع بالفعل",
keeps_assignee: "يبقى مع الشخص نفسه",
saves_travel: "يوفّر التنقل",
after_overrun: "بعد التأخير",
from_position: "من موقعه الحالي",
overtime: "بعد نهاية اليوم",
with_crew: "مع الفريق",
via_pickup: "عبر استلام",
swapped: "تم تبديله بين الأشخاص",
fits_capacity: "يتسع في اليوم",
},
extraPerson: "ماذا لو كان هناك شخص إضافي؟",
extraPersonTakes_zero: "شخص إضافي لن يأخذ أي زيارة.",
extraPersonTakes_one: "شخص إضافي سيأخذ زيارة واحدة إضافية.",
extraPersonTakes_two: "شخص إضافي سيأخذ زيارتين إضافيتين.",
extraPersonTakes_few: "شخص إضافي سيأخذ {{count}} زيارات إضافية.",
extraPersonTakes_many: "شخص إضافي سيأخذ {{count}} زيارة إضافية.",
extraPersonTakes_other: "شخص إضافي سيأخذ {{count}} زيارة إضافية.",
extraPersonNone: "شخص إضافي لن يغيّر الخطة.",
none: "لا شيء للتحسين: الخطة مناسبة بالفعل.",
planned: "المخطط {{before}} ← {{after}}",
travel: "التنقل {{before}} ← {{after}}",
stillUnplanned_zero: "لا شيء غير مخطط",
stillUnplanned_one: "واحد ما زال غير مخطط",
stillUnplanned_two: "اثنان ما زالا غير مخططين",
stillUnplanned_few: "{{count}} ما زالت غير مخططة",
stillUnplanned_many: "{{count}} ما زالت غير مخططة",
stillUnplanned_other: "{{count}} ما زالت غير مخططة",
confidence: {
high: "ثقة عالية",
medium: "ثقة متوسطة",
low: "ثقة منخفضة",
},
note: {
parts_unknown_zero: "كل القطع مؤكدة",
parts_unknown_one: "القطع غير مؤكدة لزيارة واحدة",
parts_unknown_two: "القطع غير مؤكدة لزيارتين",
parts_unknown_few: "القطع غير مؤكدة لـ {{count}} زيارات",
parts_unknown_many: "القطع غير مؤكدة لـ {{count}} زيارة",
parts_unknown_other: "القطع غير مؤكدة لـ {{count}} زيارة",
location_missing_zero: "كل الزيارات لها موقع",
location_missing_one: "زيارة واحدة بلا موقع",
location_missing_two: "زيارتان بلا موقع",
location_missing_few: "{{count}} زيارات بلا موقع",
location_missing_many: "{{count}} زيارةً بلا موقع",
location_missing_other: "{{count}} زيارة بلا موقع",
duration_default_zero: "لا مدد تقديرية",
duration_default_one: "زيارة واحدة بمدة تقديرية",
duration_default_two: "زيارتان بمدة تقديرية",
duration_default_few: "{{count}} زيارات بمدة تقديرية",
duration_default_many: "{{count}} زيارةً بمدة تقديرية",
duration_default_other: "{{count}} زيارة بمدة تقديرية",
travel_estimated_zero: "لا تنقل تقديري",
travel_estimated_one: "التنقل تقديري لرحلة واحدة",
travel_estimated_two: "التنقل تقديري لرحلتين",
travel_estimated_few: "التنقل تقديري لـ {{count}} رحلات",
travel_estimated_many: "التنقل تقديري لـ {{count}} رحلة",
travel_estimated_other: "التنقل تقديري لـ {{count}} رحلة",
},
reason: {
required_skill: "يملك المهارة المطلوبة",
parts_ready: "القطع جاهزة",
due_today: "مستحق في ذلك اليوم",
urgent: "أولوية عالية",
near_previous: "على بُعد {{duration}} من المحطة السابقة",
same_site: "موجود في هذا الموقع",
fits_capacity: "يناسب اليوم",
keeps_assignee: "يبقى مع الشخص نفسه",
saves_travel: "يوفّر {{duration}} من التنقل",
after_overrun: "يبدأ عندما يمكن إنهاء المهمة السابقة",
from_position: "يبدأ عندما يمكن الوصول إليه من الموقع الحالي",
overtime: "{{duration}} بعد نهاية يوم العمل",
with_crew: "مخطط مع الفريق في الوقت نفسه",
via_pickup: "يمر باستلام القطعة",
swapped: "تم تبديله مع شخص آخر، يوفّر {{duration}}",
},
},
schedulePlan: {
save: "حفظ الخطة",
failed: "تعذّر الحفظ. {{message}}",
},
myDay: {
  boardHint: "يمكنك رؤية يوم الفريق كله هنا. لنقل العمل بين الأشخاص على لوحة اليوم، افتح العمل على جهاز لوحي أو كمبيوتر.",
  title: "يومي",
saved: "محفوظ {{time}} · لا اتصال، تُعرض آخر نسخة",
savedWide: "حُفظ {{time}} · تعذّر الوصول إلى الخادم، تُعرض آخر نسخة. لا يمكن تطبيق شيء حتى ذلك الحين.",
changed: "تغيّرت خطتك في هذه الأثناء: {{moved}} نُقلت، {{added}} جديدة، {{removed}} أُزيلت.",
changedDismissA11y: "إغلاق ملاحظة التغييرات",
mine: "يومي",
everyone: "الجميع",
switchA11y: "يوم مَن يُعرض",
accept: "قبول",
decline: "رفض",
accepted: "تم القبول",
acceptFailed: "تعذّر القبول. {{message}}",
startNext: "ابدأ التالي: {{title}}",
},
insights: {
eyebrow: "تخطيط العمل",
title: "كيف تسير الخطة",
subtitle: "آخر {{days}} أيام",
none: "—",
utilisation: "عمل لا قيادة",
utilisationCaption: "من الوقت المخطط",
utilisationInfo: "العمل كنسبة من العمل مع التنقل عبر كل الأيام المخططة في الفترة. التنقل ليس وقتًا منتجًا أبدًا.",
adherence: "بدأت كما خُطط",
adherenceCaption_zero: "من أصل {{count}} زيارة مخططة",
adherenceCaption_one: "من زيارة مخططة واحدة",
adherenceCaption_two: "من زيارتين مخططتين",
adherenceCaption_few: "من {{count}} زيارات مخططة",
adherenceCaption_many: "من {{count}} زيارة مخططة",
adherenceCaption_other: "من {{count}} زيارة مخططة",
adherenceInfo: "الزيارات المخططة التي بدأت خلال {{minutes}} دقيقة من موعدها المخطط.",
actual: "المدة الفعلية مقابل المخططة",
actualCaption_zero: "وسيط {{count}} زيارة",
actualCaption_one: "وسيط زيارة واحدة",
actualCaption_two: "وسيط زيارتين",
actualCaption_few: "وسيط {{count}} زيارات",
actualCaption_many: "وسيط {{count}} زيارة",
actualCaption_other: "وسيط {{count}} زيارة",
actualInfo: "كم استغرقت الزيارات المنتهية فعليًا كنسبة من المدة المخططة. 100٪ كما خُطط؛ أكثر يعني أن الخطط قصيرة.",
},
directions: {
action: "الاتجاهات",
route: "المسار",
routeA11y: "فتح مسار {{name}} في الخرائط",
legA11y: "يفتح هذه الرحلة في الخرائط",
partsTitle: "يُفتح هذا المسار على أجزاء",
partsBody: "رابط الخرائط يتسع لعدد محدود من المحطات. اختر الجزء الذي تريد فتحه.",
part: "المحطات {{from}}–{{to}}",
cancel: "إلغاء",
},
map: {
show: "الخريطة",
hide: "اللوحة",
hideNarrow: "القائمة",
empty: "لا شيء مخطط في هذا اليوم له موقع.",
unplannedNearby_zero: "لا عمل غير مخطط له موقع",
unplannedNearby_one: "عمل واحد غير مخطط له موقع",
unplannedNearby_two: "عملان غير مخططين لهما موقع",
unplannedNearby_few: "{{count}} أعمال غير مخططة لها موقع",
unplannedNearby_many: "{{count}} عملًا غير مخطط له موقع",
unplannedNearby_other: "{{count}} عمل غير مخطط له موقع",
stopA11y: "المحطة {{number}}: {{title}}",
noLocation_zero: "لا شيء بلا موقع",
noLocation_one: "واحدة بلا موقع",
noLocation_two: "اثنتان بلا موقع",
noLocation_few: "{{count}} بلا موقع",
noLocation_many: "{{count}} بلا موقع",
noLocation_other: "{{count}} بلا موقع",
legend: "الخطوط المتقطعة تصل المحطات بالترتيب. ليست هي الطريق.",
},
home: {
title: "خطة اليوم",
count_zero: "لا زيارات",
count_one: "زيارة واحدة",
count_two: "زيارتان",
count_few: "{{count}} زيارات",
count_many: "{{count}} زيارةً",
count_other: "{{count}} زيارة",
withNext_zero: "لا زيارات · التالية {{time}} {{title}}",
withNext_one: "زيارة واحدة · التالية {{time}} {{title}}",
withNext_two: "زيارتان · التالية {{time}} {{title}}",
withNext_few: "{{count}} زيارات · التالية {{time}} {{title}}",
withNext_many: "{{count}} زيارةً · التالية {{time}} {{title}}",
withNext_other: "{{count}} زيارة · التالية {{time}} {{title}}",
},
settings: {
title: "إعدادات التخطيط",
closeA11y: "إغلاق إعدادات التخطيط",
week: "أسبوع العمل",
starts: "بداية اليوم",
ends: "نهاية اليوم",
break: "استراحة",
noBreak: "لا شيء",
defaults: "عندما لا يُحدَّد شيء",
jobLength: "مدة المهمة",
inspectionLength: "مدة الفحص",
citySpeed: "القيادة داخل المدينة",
citySpeedHint: "تُستخدم لتقدير وقت التنقل عندما لا يُعرف وقت الطريق. الرحلات الأطول تُفترض أسرع.",
save: "حفظ",
failed: "تعذّر الحفظ. {{message}}",
person: "لـ {{name}}",
personHours: "ساعات عملهم",
ownHours: "خاصة بهم",
sameHours: "مثل مساحة العمل",
personDepot: "مكان بدء يومه وانتهائه",
savePerson: "حفظ لهذا الشخص",
overtime: "يمكن أن تتجاوز الخطط المقترحة اليوم بمقدار",
noOvertime: "أبدًا",
overtimeHint: "تتجنب الخطط المقترحة ذلك قدر الإمكان. يُميَّز أي تغيير يتجاوز اليوم ويحتاج إلى سبب قبل تطبيقه.",
depot: "مكان بدء اليوم وانتهائه",
noDepot: "غير محدد",
depotHint: "موقع. تُحتسب أول وآخر رحلة في اليوم من هنا.",
usePositions: "استخدام مواقع الأشخاص",
usePositionsHint: "يختار كل شخص ما إذا كان سيشارك موقعه، وفقط أثناء فتح التطبيق. لا يراه إلا المالكون والمسؤولون لاكتشاف التأخير. يُحتفظ بآخر موقع فقط لمدة ساعتين.",
clearDepot: "مسح",
lessA11y: "أقل: {{label}}",
moreA11y: "أكثر: {{label}}",
timeOff: "الإجازات في {{day}}",
removeOffA11y: "إزالة إجازة {{name}}",
off: {
allDay: "طوال اليوم",
morning: "الصباح",
afternoon: "بعد الظهر",
},
},
parts: {
title: "القطع المطلوبة",
empty: "لا قطع مدرجة. أضف ما يجب إحضاره.",
addLabel: "قطعة أو مادة",
add: "إضافة قطعة",
removeA11y: "إزالة {{part}}",
failed: "تعذّر حفظ القطعة. {{message}}",
availability: {
unknown: "غير مؤكدة",
available: "متوفرة",
reserved: "محجوزة",
unavailable: "غير متوفرة",
},
heldAt: "محفوظة في {{site}}",
notHeld: "أين هي محفوظة؟",
clearHeld: "مسح",
},
jobPlanning: {
title: "التخطيط",
people: "عدد الأشخاص في الوقت نفسه",
fewerA11y: "أشخاص أقل",
moreA11y: "أشخاص أكثر",
appointment: "يجب أن يتم بين",
on: "في",
from: "من",
to: "إلى",
saveAppointment: "حفظ الفترة الزمنية",
clearAppointment: "مسح الفترة الزمنية",
window: "{{on}}، {{from}}–{{to}}",
noWindow: "في أي وقت",
waitsOn: "ينتظر",
waitsOnNone: "لا شيء",
removeDepA11y: "لم يعد ينتظر {{title}}",
addDepA11y: "انتظار {{title}}",
failed: "تعذّر الحفظ. {{message}}",
},
refine: {
planningTitle: "التخطيط",
partsTitle: "القطع",
planning: {
planned: "مخطط",
unplanned: "غير مخطط",
blocked: "عالق",
},
parts: {
ready: "جاهزة",
unavailable: "غير متوفرة",
unknown: "غير مؤكدة",
},
},
lanes: {
a11y: "الأعمدة تعرض",
people: "حسب الشخص",
site: "حسب الموقع",
asset: "حسب الأصل",
noSite: "بلا موقع",
noAsset: "بلا أصل",
},
review: {
overrun: "{{title}} يتجاوز مدته المخططة بمقدار {{duration}}. بقية يوم {{name}} لم تعد تتسع.",
absence_zero: "{{name}} غائب.",
absence_one: "{{name}} غائب عن زيارة مخططة واحدة.",
absence_two: "{{name}} غائب عن زيارتين مخططتين.",
absence_few: "{{name}} غائب عن {{count}} زيارات مخططة.",
absence_many: "{{name}} غائب عن {{count}} زيارةً مخططة.",
absence_other: "{{name}} غائب عن {{count}} زيارة مخططة.",
urgent_zero: "لا مهام عاجلة غير مخططة.",
urgent_one: "مهمة عاجلة واحدة غير مخططة.",
urgent_two: "مهمتان عاجلتان غير مخططتين.",
urgent_few: "{{count}} مهام عاجلة غير مخططة.",
urgent_many: "{{count}} مهمة عاجلة غير مخططة.",
urgent_other: "{{count}} مهمة عاجلة غير مخططة.",
part_unavailable: "قطعة لـ {{title}} لم تعد متوفرة.",
cancelled: "أُلغي {{title}}: وقته متاح الآن.",
early_finish: "أنهى {{name}} {{title}} مبكرًا: هناك وقت للمزيد.",
running_late: "سيتأخر {{name}} نحو {{duration}} عن {{title}} انطلاقًا من موقعه الحالي.",
more: "+{{count}} أخرى",
action: "مراجعة الخطة",
dismissA11y: "تنحية جانبًا",
nothing: "لا شيء يمكن نقله لحل هذا. يحتاج إلى قرار يدوي.",
},
position: {
  stop: "إيقاف المشاركة",
  share: "مشاركة الموقع",
sharingShort: "تتم مشاركة موقعك",
stopA11y: "إيقاف مشاركة موقعك",
offer: "شارك موقعك أثناء العمل حتى يمكن تعديل يومك إذا تأخرت.",
explainTitle: "مشاركة موقعك؟",
explain: "أثناء فتح هذا التطبيق ووجود عمل لك اليوم، يُرسل موقعك كل بضع دقائق. لا يراه إلا مالكو مساحة العمل ومسؤولوها، لاكتشاف تأخرك عن زيارتك التالية. يُحتفظ بآخر موقع فقط، ويُحذف بعد ساعتين، ويمكنك الإيقاف في أي وقت.",
explainConfirm: "المشاركة أثناء فتح التطبيق",
explainCancel: "ليس الآن",
denied: "الموقع متوقف لهذا التطبيق. اسمح به في إعدادات الجهاز لمشاركة موقعك.",
failed: "تعذر تغيير المشاركة. {{message}}",
fromYou: "نحو {{duration}} منك إلى {{title}}",
seen: "شوهد قبل {{duration}}",
seenNow: "شوهد الآن",
},
slot: {
createA11y: "إنشاء عمل في {{time}}",
clear: "لا تعارض مع يومهم",
},
rail: {
allDay: "طوال اليوم",
forecast: "توقّع",
forecastA11y: "توقّع، لم يُحجز بعد: {{title}}",
},
agenda: {
empty: "لا شيء مخطَّط لهذا اليوم. الأسهم تنتقل إلى أيام أخرى.",
},
error: {
  tryAgain: "حاول مرة أخرى بعد قليل.",
  offline: "تحقق من اتصالك وحاول مرة أخرى.",
  notAllowed: "ليس لديك إذن لتغيير هذا.",
load: "تعذّر تحميل الخطة.",
retry: "إعادة المحاولة",
},
loadingA11y: "جارٍ تحميل الخطة",
truncated: "في هذه الأيام عمل أكثر مما يحمّله التقويم. ضيّق العرض باستخدام «تصفية».",
},
scheduler: {
  contractor: {
    giveNow: "أسند إلى المقاول",
    pick: "اختر مقاولاً",
    change: "{{name}} · تغيير",
    hint: "يستلمها في «عملي» ويحتاج إلى حساب AssetWRX. تبقى الموافقة عليها لك.",
    missing: "اختر المقاول الذي ستُسند إليه هذه المعاينة.",
  },
  fitLine: {
    bestAvailable: "أفضل خيار متاح",
    goodFit: "ملاءمة جيدة",
    line: "الأنسب: {{name}} · ملاءمة {{score}}% · {{why}}",
  },
  fitReason: {
    certification: "يملك شهادة مطلوبة",
    withinRange: "ضمن مسافة معقولة",
    closeToSite: "قريب من الموقع",
    available: "متاح بحسب حالته",
    team: "ضمن الفريق المسؤول عن هذا العمل",
    capacity: "لديه وقت متاح",
    lightlyBooked: "{{n}} س محجوزة فقط",
    nothingBooked: "لا شيء محجوز",
    onTime: "ينجز عادةً في الموعد",
    verifiedHistory: "عادةً ما يُعتمد عمله المنجز",
    assetTypeExperience: "خبرة بهذا النوع من الأصول",
    priorWorkOnAsset: "عمل على هذا الأصل من قبل",
    skillsMatch: "يملك المهارات التي تحتاجها المهمة",
    categoryMany: "{{n}} مهام مكتملة في هذه الفئة",
    categoryOne: "مهمة واحدة مكتملة في هذه الفئة",
  },
  blocker: {
    not_assignable: "لا يمكن إسناد عمل إليه",
    inactive_contractor: "المقاول غير نشط",
    no_site_access: "لا يملك صلاحية دخول هذا الموقع",
    unavailable: "غير متاح في ذلك الوقت",
    missing_certification: "تنقصه شهادة مطلوبة",
    missing_mandatory_skill: "تنقصه مهارة مطلوبة",
  },
  slotReason: {
    afterDue: "بعد تاريخ الاستحقاق",
    sameSite: "نفس موقع المهمة السابقة",
    beforeDue: "قبل تاريخ الاستحقاق",
    minutes: "{{n}} د",
    hours: "{{n}} س",
    gapFree: "فترة متاحة مدتها {{duration}}",
    firstGap: "أول فترة متاحة مدتها {{duration}}",
  },
  notes: {
    revert: "استرجاع",
    discard: "تجاهل",
    accept: "قبول",
    tidyFailedTitle: "تعذّر تحسين الملاحظة",
    tidiedReview: "راجعها ثم اضغط قبول.",
    tidiedTitle: "ملاحظة محسّنة",
    tidyUp: "تحسين بالذكاء الاصطناعي",
    stop: "إيقاف",
    dictate: "إملاء",
  },
  assignee: {
    noMatch: "لا أحد في فريقك يطابق البحث.",
    search: "ابحث في فريقك",
    blocked: "غير متاح",
    contractor: "مقاول",
    technician: "فني",
    notEligibleItem: "{{name}} ({{reason}})",
    notEligible: "لا يمكنه تولّي هذا: {{list}}",
    bestMatch: "الأنسب: {{name}}",
    assignA11y: "تعيين {{name}}",
    recommended: "مُوصى به: {{name}}",
    youSuffix: "{{name}} (أنت)",
    you: "أنت",
  },
  invite: {
    description: "القائمة المرجعية: {{checklist}}",
    title: "فحص: {{asset}}",
  },
  errors: {
    photosOtherWorkspace: "صورك محفوظة لمساحة العمل التي أنشأت فيها هذه المهمة. ارجع إليها، ثم اضغط إكمال حفظ المهمة.",
    otherWorkspace: "ارجع إلى مساحة العمل التي أنشأت فيها هذه المهمة، ثم اضغط إكمال حفظ المهمة.",
    pickTime: "اختر تاريخًا ووقتًا ثم حاول مرة أخرى.",
  },
  errorTitles: {
    reschedule: "لم يتم حفظ الموعد الجديد",
    jobLater: "لم تتم جدولة المهمة",
    jobNow: "لم يتم إنشاء المهمة",
    inspectionLater: "لم تتم جدولة الفحص",
    inspectionNow: "لم يبدأ الفحص",
  },
  checklist: {
    noMatch: "لا توجد قائمة مطابقة. جرّب كلمة أخرى أو اضغط قائمة مرجعية جديدة.",
    search: "ابحث في القوائم المرجعية",
    add: "إضافة",
    done: "تم",
    change: "تغيير",
    picked: "اخترت هذه القائمة.",
    loadFailed: "لم يتم تحميل قوائمك المرجعية.",
    loading: "جارٍ تحميل القوائم المرجعية…",
  },
  slotAfterDue: "بعد تاريخ الاستحقاق",
  moreSummaryShort: "طريقة التنفيذ والتذكيرات",
  renewing: "تجديد {{title}}. يسجّل هذا الفحص أدلة التجديد.",
  renewingJob: "تجديد {{title}}. عند اكتمال أمر العمل هذا، أنشئ منه شهادة الاستبدال.",
  renewJobTitle: "تجديد {{title}}",
  fromRequest: "من الطلب: {{title}}",
  runMode: {
    list: "قائمة",
    guided_group: "حسب القسم",
    guided_item: "خطوة بخطوة",
  },
  reminder: {
    "2day": "قبل يومين",
    "1day": "قبل يوم",
    "2hr": "قبل ساعتين",
    "1hr": "قبل ساعة",
    "30min": "قبل 30 دقيقة",
    "15min": "قبل 15 دقيقة",
    at_time: "في الوقت المحدد",
  },
  cta: {
    scheduleJob: "جدولة المهمة",
    scheduleInspection: "جدولة الفحص",
    createJob: "إنشاء المهمة",
    startInspection: "بدء الفحص",
    saveTime: "حفظ الوقت الجديد",
    finishJob: "إكمال حفظ المهمة",
  },
  heading: {
    job: "مهمة · {{asset}}",
    inspection: "فحص · {{asset}}",
    rescheduleJob: "إعادة جدولة المهمة",
    rescheduleInspection: "إعادة جدولة الفحص",
  },
  done: {
    jobCreated: "تم إنشاء مهمة لـ {{asset}}.",
    jobScheduled: "تم حجز مهمة {{asset}} في {{when}}.",
    jobCreatedPhotos: "أُنشئت المهمة. حُفظت الصور على هذا الجهاز لرفعها.",
    jobRescheduled: "تم نقل مهمة {{asset}} إلى {{when}}.",
    open: "فتح",
    inspectionRepeats: "تم حجز فحص {{asset}} في {{when}}. التكرار: {{how}}.",
    inspectionScheduled: "تم حجز فحص {{asset}} في {{when}}. يظهر في العمل في ذلك اليوم.",
    inspectionRescheduled: "تم نقل فحص {{asset}} إلى {{when}}.",
  },
  hide: "إخفاء",
  moreSummary: "طريقة التنفيذ والتذكيرات والملاحظات ومن ينفذه",
  errorBody: "لم يُحفظ شيء. تحقق من اتصالك وحاول مرة أخرى.",
  errorPartialTitle: "أُنشئت المهمة، والحفظ غير مكتمل",
  repeat: {
    advance: {
      on_calendar: "في التواريخ المخطط لها",
      on_completion: "بعد إنجاز هذه المرة",
    },
    nextFrom: "متى يحين موعد المرة التالية؟",
    noLimit: "بلا حد",
    maxTimes: "التوقف بعد (مرات)",
    use: "استخدام {{how}}",
    suggested: "المقترح: {{how}}. {{why}}",
    planHint: "للتكرار حسب قراءة العداد أو في تواريخ محددة، أضف خطة صيانة على الأصل بدلًا من ذلك.",
    errorMax: "أدخل عدد المرات أو اتركه فارغًا.",
    errorEndBeforeStart: "لا يمكن أن ينتهي التكرار قبل الزيارة الأولى.",
    errorEnd: "اختر يوم انتهاء التكرار.",
  },
show: "إظهار",
},
workItemCopy: {
issues_zero: "لا مشكلات",
issues_one: "مشكلة واحدة",
issues_two: "مشكلتان",
issues_few: "{{count}} مشكلات",
issues_many: "{{count}} مشكلةً",
issues_other: "{{count}} مشكلة",
inspectionFallback: "فحص",
},
assistantCards: {
draftFindingPhoto: "صياغة نتيجة من الصورة",
suggestTriagePriority: "اقتراح أولوية للفرز",
recurringRaisesPriority: "وجود مشكلة متكررة سيرفع الأولوية.",
suggestRepair_zero: "اقتراح إصلاح لـ {{count}} عنصر فاشل",
suggestRepair_one: "اقتراح إصلاح لعنصر واحد فاشل",
suggestRepair_two: "اقتراح إصلاح لعنصرين فاشلين",
suggestRepair_few: "اقتراح إصلاح لـ {{count}} عناصر فاشلة",
suggestRepair_many: "اقتراح إصلاح لـ {{count}} عنصرًا فاشلًا",
suggestRepair_other: "اقتراح إصلاح لـ {{count}} عنصر فاشل",
checkExistingRepair: "تحقق من الإصلاح الحالي أولًا — فقد يكون مكررًا.",
draftFindingEvidence: "صياغة نتيجة من الأدلة",
suggestPriority: "اقتراح أولوية",
suggestContractor: "اقتراح المقاول الأنسب",
contractorRecurring: "مقاول واحد يتولى حل الأعمال على هذا الأصل باستمرار.",
verifyEvidence: "التحقق من أدلة الإكمال",
suggestFollowUp: "اقتراح إجراء متابعة",
verifyBeforeSignOff: "التحقق من أدلة الإكمال قبل الاعتماد",
summariseJourney: "تلخيص رحلة العمل للتقرير",
summarisePortfolio: "تلخيص رحلة المحفظة",
portfolioRisk: "مخاطر المحفظة {{band}} ({{score}}/100)",
riskBandLow: "منخفضة",
riskBandMedium: "متوسطة",
riskBandHigh: "مرتفعة",
},
evidenceLocal: {
identifierVin: "VIN {{value}}",
identifierSerial: "الرقم التسلسلي {{value}}",
identifierOther: "المعرّف {{value}}",
codes_zero: "{{count}} رمز",
codes_one: "رمز واحد",
codes_two: "رمزين",
codes_few: "{{count}} رموز",
codes_many: "{{count}} رمزًا",
codes_other: "{{count}} رمز",
readings_zero: "{{count}} قراءة",
readings_one: "قراءة واحدة",
readings_two: "قراءتين",
readings_few: "{{count}} قراءات",
readings_many: "{{count}} قراءةً",
readings_other: "{{count}} قراءة",
complianceLabel: "ملصق {{scheme}}",
dates_zero: "{{count}} تاريخ",
dates_one: "تاريخ واحد",
dates_two: "تاريخين",
dates_few: "{{count}} تواريخ",
dates_many: "{{count}} تاريخًا",
dates_other: "{{count}} تاريخ",
recognised: "تم التعرّف على {{label}}. لم يُعثر على بيانات منظَّمة على الجهاز.",
nothingFound: "لم يتم استخراج أي معلومات على الجهاز.",
found: "تم العثور على {{parts}} على الجهاز.",
separator: "، ",
mobileOnly: "يعمل التحليل على الجهاز في تطبيق الهاتف المحمول.",
failed: "تعذّر تحليل الأدلة على الجهاز.",
},
fitRisks: {
missesDueDates: "غالبًا ما يتجاوز تواريخ الاستحقاق",
repeatReopens: "إعادات فتح متكررة في الأعمال الأخيرة",
someRework: "بعض إعادة العمل في مهام سابقة",
hoursCommitted_zero: "{{count}} س محجوزة مسبقًا",
hoursCommitted_one: "{{count}} س محجوزة مسبقًا",
hoursCommitted_two: "{{count}} س محجوزة مسبقًا",
hoursCommitted_few: "{{count}} س محجوزة مسبقًا",
hoursCommitted_many: "{{count}} س محجوزة مسبقًا",
hoursCommitted_other: "{{count}} س محجوزة مسبقًا",
heavyWorkload: "عبء عمل حالي كبير",
elevatedWorkload: "عبء عمل نشط مرتفع",
overdueAssignments_zero: "لا تعيينات متأخرة",
overdueAssignments_one: "تعيين واحد متأخر",
overdueAssignments_two: "تعيينان متأخران",
overdueAssignments_few: "{{count}} تعيينات متأخرة",
overdueAssignments_many: "{{count}} تعيينًا متأخرًا",
overdueAssignments_other: "{{count}} تعيين متأخر",
},
journeySignals: {
whereAsset: "على هذا الأصل",
wherePortfolio: "عبر المحفظة",
alreadyRepairedLabel: "سبق إكمال إصلاح {{where}}.",
alreadyRepairedDetailAgo_zero: "أُغلقت آخر مهمة مكتملة {{where}} منذ {{count}} ي — تأكد من أنها ليست مكررة قبل إنشاء عمل جديد.",
alreadyRepairedDetailAgo_one: "أُغلقت آخر مهمة مكتملة {{where}} منذ يوم واحد — تأكد من أنها ليست مكررة قبل إنشاء عمل جديد.",
alreadyRepairedDetailAgo_two: "أُغلقت آخر مهمة مكتملة {{where}} منذ يومين — تأكد من أنها ليست مكررة قبل إنشاء عمل جديد.",
alreadyRepairedDetailAgo_few: "أُغلقت آخر مهمة مكتملة {{where}} منذ {{count}} ي — تأكد من أنها ليست مكررة قبل إنشاء عمل جديد.",
alreadyRepairedDetailAgo_many: "أُغلقت آخر مهمة مكتملة {{where}} منذ {{count}} ي — تأكد من أنها ليست مكررة قبل إنشاء عمل جديد.",
alreadyRepairedDetailAgo_other: "أُغلقت آخر مهمة مكتملة {{where}} منذ {{count}} ي — تأكد من أنها ليست مكررة قبل إنشاء عمل جديد.",
alreadyRepairedDetail: "توجد مهمة مكتملة بالفعل {{where}} — تأكد من أنها ليست مكررة قبل إنشاء عمل جديد.",
recurringLabel_zero: "لم تُسجَّل أي مهام أو نتائج منفصلة {{where}}.",
recurringLabel_one: "سُجّلت مهمة أو نتيجة منفصلة واحدة {{where}}.",
recurringLabel_two: "سُجّل اثنان من المهام أو النتائج المنفصلة {{where}}.",
recurringLabel_few: "سُجّل {{count}} من المهام أو النتائج المنفصلة {{where}}.",
recurringLabel_many: "سُجّل {{count}} من المهام أو النتائج المنفصلة {{where}}.",
recurringLabel_other: "سُجّل {{count}} من المهام أو النتائج المنفصلة {{where}}.",
recurringDetail_zero: "لم يصل أي عنصر عمل {{where}} إلى مهمة أو نتيجة خلال الأيام الـ{{days}} الأخيرة — قد يستدعي الأصل الذي تتكرر صيانته مراجعةً للسبب الجذري بدلًا من إصلاح منفرد آخر.",
recurringDetail_one: "وصل عنصر عمل واحد {{where}} إلى مهمة أو نتيجة خلال الأيام الـ{{days}} الأخيرة — قد يستدعي الأصل الذي تتكرر صيانته مراجعةً للسبب الجذري بدلًا من إصلاح منفرد آخر.",
recurringDetail_two: "وصل عنصرا عمل {{where}} إلى مهمة أو نتيجة خلال الأيام الـ{{days}} الأخيرة — قد يستدعي الأصل الذي تتكرر صيانته مراجعةً للسبب الجذري بدلًا من إصلاح منفرد آخر.",
recurringDetail_few: "وصلت {{count}} عناصر عمل {{where}} إلى مهمة أو نتيجة خلال الأيام الـ{{days}} الأخيرة — قد يستدعي الأصل الذي تتكرر صيانته مراجعةً للسبب الجذري بدلًا من إصلاح منفرد آخر.",
recurringDetail_many: "وصل {{count}} عنصرَ عمل {{where}} إلى مهمة أو نتيجة خلال الأيام الـ{{days}} الأخيرة — قد يستدعي الأصل الذي تتكرر صيانته مراجعةً للسبب الجذري بدلًا من إصلاح منفرد آخر.",
recurringDetail_other: "وصل {{count}} عنصر عمل {{where}} إلى مهمة أو نتيجة خلال الأيام الـ{{days}} الأخيرة — قد يستدعي الأصل الذي تتكرر صيانته مراجعةً للسبب الجذري بدلًا من إصلاح منفرد آخر.",
contractorLabel_zero: "لم يُنجز {{name}} أي مهمة {{where}}.",
contractorLabel_one: "أنجز {{name}} مهمة واحدة {{where}}.",
contractorLabel_two: "أنجز {{name}} مهمتين {{where}}.",
contractorLabel_few: "أنجز {{name}} {{count}} مهام {{where}}.",
contractorLabel_many: "أنجز {{name}} {{count}} مهمةً {{where}}.",
contractorLabel_other: "أنجز {{name}} {{count}} مهمة {{where}}.",
contractorDetail: "قد يشير تكرار استدعاء المقاول نفسه إلى سبب جذري لم يُعالَج.",
healthLabel_zero: "صحة الأصل تتدهور (بانخفاض {{count}} نقطة).",
healthLabel_one: "صحة الأصل تتدهور (بانخفاض نقطة واحدة).",
healthLabel_two: "صحة الأصل تتدهور (بانخفاض نقطتين).",
healthLabel_few: "صحة الأصل تتدهور (بانخفاض {{count}} نقاط).",
healthLabel_many: "صحة الأصل تتدهور (بانخفاض {{count}} نقطةً).",
healthLabel_other: "صحة الأصل تتدهور (بانخفاض {{count}} نقطة).",
healthDetail: "انخفضت الصحة التشغيلية من {{then}} إلى {{now}} — أعطِ هذا الأصل الأولوية قبل أن يبلغ مستوى «يتطلب إجراء».",
overdueLabel_zero: "لا متابعات مفتوحة متأخرة {{where}}.",
overdueLabel_one: "متابعة مفتوحة واحدة {{where}} متأخرة.",
overdueLabel_two: "متابعتان مفتوحتان {{where}} متأخرتان.",
overdueLabel_few: "{{count}} متابعات مفتوحة {{where}} متأخرة.",
overdueLabel_many: "{{count}} متابعةً مفتوحةً {{where}} متأخرة.",
overdueLabel_other: "{{count}} متابعة مفتوحة {{where}} متأخرة.",
overdueDetail: "تجاوزت رحلات العمل المفتوحة {{where}} اتفاقية SLA لمرحلة واحدة على الأقل — وهي معرّضة لمزيد من التأخر.",
},
suggestJobCopy: {
noInspectionData: "لم تُقدَّم بيانات فحص لاقتراح مهام.",
noSuggestions: "لا توجد اقتراحات مهام لهذا الفحص.",
suggestionsReady_zero: "لا توجد اقتراحات مهام جاهزة.",
suggestionsReady_one: "اقتراح مهمة واحد جاهز.",
suggestionsReady_two: "اقتراحان للمهام جاهزان.",
suggestionsReady_few: "{{count}} اقتراحات للمهام جاهزة.",
suggestionsReady_many: "{{count}} اقتراحًا للمهام جاهزة.",
suggestionsReady_other: "{{count}} اقتراح للمهام جاهزة.",
addRequestSummary: "أضف ملخصًا للطلب لاقتراح مهمة.",
derivedFromRequest: "اقتراح مهمة مستمد من الطلب.",
derivedWarning: "مستمد من الطلب (دون ذكاء اصطناعي). أكّد قبل إنشاء المهمة.",
enableAi: "فعّل الذكاء الاصطناعي لاقتراح مهمة متابعة.",
enableAiHint: "استخدم الذكاء الاصطناعي لإنشاء اقتراح بمهمة متابعة.",
offline: "اقتراح الذكاء الاصطناعي غير متاح دون اتصال.",
offlineWarning: "اقتراح الذكاء الاصطناعي غير متاح دون اتصال",
followUpFailed: "تعذّر اقتراح مهمة متابعة.",
notAvailable: "اقتراحات المهام غير متاحة في هذا السياق.",
suggestionFailed: "فشل الاقتراح",
jobFailed: "تعذّر اقتراح مهمة.",
},
rules: {
title: "قواعد المجموعات",
subtitle: "كرّر قائمة تحقق واحدة على أصول كثيرة",
intro: "تضع قاعدة المجموعة قائمة التحقق نفسها على كل أصل مطابق، مثل كل باب حريق في المبنى A كل شهر. وتنضم الأصول الجديدة المطابقة إليها تلقائيًا.",
howTitle: "كيف تعمل قواعد المجموعات",
howStep1: "اختر المجموعة: فئة أصل، أو أحد أنواع الأصول لديك، أو نوع مكان، أو منطقة. ويمكنك قصرها على ما يوجد داخل مكان واحد.",
howStep2: "اختر قائمة التحقق، وكم مرة، وتاريخ أول فحص.",
howStep3: "عند الحفظ يُنشأ فحص لكل أصل في المجموعة. والأصل الذي ينضم لاحقًا يحصل على فحصه الخاص، والأصل الذي يخرج من المجموعة يُلغى فحصه الذي لم يبدأ.",
howExample: "مثال: «فحص شهري لأبواب الحريق» يأخذ كل باب حريق داخل المبنى A. عند الحفظ تُنشأ 24 فحصًا مستحقة في التاريخ الأول. وتظهر في صفحة العمل كصف واحد.",
howEdits: "تعديل القاعدة يحدّث فحوصاتها التي لم تبدأ. أما الفحوصات التي بدأت أو انتهت فلا تتغير أبدًا. وإيقاف القاعدة يلغي ما لم يبدأ.",
howTour: "أرني",
howGuide: "اقرأ الدليل",
add: "إضافة قاعدة مجموعة",
newTitle: "قاعدة مجموعة جديدة",
editTitle: "تعديل قاعدة المجموعة",
nameLabel: "الاسم",
namePlaceholder: "فحص شهري لأبواب الحريق",
nameRequired: "أعطِ القاعدة اسمًا",
whatLabel: "أي أصول",
whatHint: "اختر فئة الأصل أولًا.",
anyPlace: "أي مكان",
whereLabel: "أين",
whereHint: "داخل مكان يعني كل ما فيه وعلى كل مستوى: طوابق المبنى وغرفها وما رُكّب فيها.",
anywhere: "في أي مكان",
aPlace: "مكان",
someType: "نوع أصل",
anyAsset: "أي أصل",
inZone: "في المنطقة {{zone}}",
insidePlace: "داخل {{place}}",
assignedTo: "إلى {{name}}",
zoneLabel: "المنطقة (اختياري)",
zoneHint: "الأصول الموسومة بهذه المنطقة فقط.",
checklistLabel: "قائمة التحقق",
pickChecklist: "اختر قائمة تحقق",
checklistRequired: "اختر قائمة تحقق",
searchChecklists: "البحث في قوائم التحقق",
howOftenLabel: "كم مرة",
startsOnLabel: "أول فحص في",
startsOnInvalid: "أدخل التاريخ بصيغة YYYY-MM-DD",
assigneeLabel: "إسناد إلى (اختياري)",
assigneeHint: "يُبلَّغ الشخص مرة واحدة مهما كان عدد الفحوصات التي تنشئها القاعدة.",
nobody: "لا أحد بعد",
someone: "شخص ما",
you: "{{name}} (أنت)",
searchPeople: "البحث عن أشخاص",
needsGroup: "اختر فئة أصل أو نوع أصل أو نوع مكان أو منطقة.",
sentence: "{{recurrence}} من {{date}}: كل {{what}}{{where}} يحصل على قائمة التحقق «{{checklist}}».",
sentenceNoChecklist: "{{recurrence}} من {{date}}: كل {{what}}{{where}}. اختر قائمة تحقق لإكمالها.",
sentenceNeedsGroup: "حدّد الأصول لترى القاعدة هنا.",
sentenceInside: " داخل {{place}}",
sentenceInZone: " في المنطقة {{zone}}",
sentenceAssigned: "مسندة إلى {{name}}.",
counting: "جارٍ العد…",
estimate_zero: "لا تأخذ أي أصل الآن.",
estimate_one: "تأخذ أصلًا واحدًا الآن.",
estimate_two: "تأخذ أصلين الآن.",
estimate_few: "تأخذ {{count}} أصول الآن.",
estimate_many: "تأخذ {{count}} أصلًا الآن.",
estimate_other: "تأخذ {{count}} أصل الآن.",
estimateHint: "الأصل الذي ينضم إلى المجموعة لاحقًا يحصل على فحصه الخاص، مستحقًا في يوم انضمامه.",
estimateOffline: "محسوب من الأصول على هذا الجهاز لأن الخادم غير متاح. ومع ذلك تشمل القاعدة كل أصل مطابق.",
editUpdates_zero: "لن يغيّر الحفظ أي فحص لم يبدأ.",
editUpdates_one: "سيحدّث الحفظ فحصًا واحدًا لم يبدأ.",
editUpdates_two: "سيحدّث الحفظ فحصين لم يبدآ.",
editUpdates_few: "سيحدّث الحفظ {{count}} فحوصات لم تبدأ.",
editUpdates_many: "سيحدّث الحفظ {{count}} فحصًا لم يبدأ.",
editUpdates_other: "سيحدّث الحفظ {{count}} فحص لم يبدأ.",
editLeaving_zero: "لن يُلغى أي فحص.",
editLeaving_one: "سيُلغى فحص واحد: أصله لم يعد في المجموعة.",
editLeaving_two: "سيُلغى فحصان: أصلاهما لم يعودا في المجموعة.",
editLeaving_few: "ستُلغى {{count}} فحوصات: أصولها لم تعد في المجموعة.",
editLeaving_many: "سيُلغى {{count}} فحصًا: أصولها لم تعد في المجموعة.",
editLeaving_other: "سيُلغى {{count}} فحص: أصولها لم تعد في المجموعة.",
editJoining_zero: "لن يُنشأ أي فحص جديد.",
editJoining_one: "سيُنشأ فحص جديد واحد.",
editJoining_two: "سيُنشأ فحصان جديدان.",
editJoining_few: "ستُنشأ {{count}} فحوصات جديدة.",
editJoining_many: "سيُنشأ {{count}} فحصًا جديدًا.",
editJoining_other: "سيُنشأ {{count}} فحص جديد.",
editKept: "الفحوصات التي بدأت أو انتهت لا تتغير.",
cancel: "إلغاء",
save: "حفظ القاعدة",
saved_zero: "تم الحفظ. لا فحوصات مخطط لها.",
saved_one: "تم الحفظ. فحص واحد مخطط له.",
saved_two: "تم الحفظ. فحصان مخطط لهما.",
saved_few: "تم الحفظ. {{count}} فحوصات مخطط لها.",
saved_many: "تم الحفظ. {{count}} فحصًا مخططًا له.",
saved_other: "تم الحفظ. {{count}} فحص مخطط له.",
failedTitle: "تعذّر حفظ القاعدة",
failedBody: "تحقّق من الاتصال وحاول مرة أخرى.",
active: "نشطة",
stopped: "متوقفة",
savedMoreComing_zero: "تم الحفظ. لم يُخطط أي فحص بعد؛ تُضاف البقية أو تُحدَّث خلال الدقائق القادمة.",
savedMoreComing_one: "تم الحفظ. خُطط فحص واحد حتى الآن؛ تُضاف البقية أو تُحدَّث خلال الدقائق القادمة.",
savedMoreComing_two: "تم الحفظ. خُطط فحصان حتى الآن؛ تُضاف البقية أو تُحدَّث خلال الدقائق القادمة.",
savedMoreComing_few: "تم الحفظ. خُططت {{count}} فحوصات حتى الآن؛ تُضاف البقية أو تُحدَّث خلال الدقائق القادمة.",
savedMoreComing_many: "تم الحفظ. خُطط {{count}} فحصًا حتى الآن؛ تُضاف البقية أو تُحدَّث خلال الدقائق القادمة.",
savedMoreComing_other: "تم الحفظ. خُطط {{count}} فحص حتى الآن؛ تُضاف البقية أو تُحدَّث خلال الدقائق القادمة.",
moreComing: "ما زالت الفحوصات تُضاف أو تُحدَّث. تحقق مرة أخرى بعد بضع دقائق.",
openVisits_zero: "لا فحوصات مفتوحة",
openVisits_one: "فحص مفتوح",
openVisits_two: "فحصان مفتوحان",
openVisits_few: "{{count}} فحوصات مفتوحة",
openVisits_many: "{{count}} فحصًا مفتوحًا",
openVisits_other: "{{count}} فحص مفتوح",
fromRuleLabel: "من قاعدة مجموعة",
edit: "تعديل",
stop: "إيقاف",
restart: "إعادة التشغيل",
stopConfirmTitle: "إيقاف هذه القاعدة؟",
stopConfirmBody_zero: "لا توجد فحوصات لم تبدأ. تبقى الفحوصات المنتهية.",
stopConfirmBody_one: "سيُلغى فحصها الذي لم يبدأ. تبقى الفحوصات المنتهية.",
stopConfirmBody_two: "سيُلغى فحصاها اللذان لم يبدآ. تبقى الفحوصات المنتهية.",
stopConfirmBody_few: "ستُلغى فحوصاتها الـ{{count}} التي لم تبدأ. تبقى الفحوصات المنتهية.",
stopConfirmBody_many: "سيُلغى {{count}} فحصًا لم يبدأ. تبقى الفحوصات المنتهية.",
stopConfirmBody_other: "سيُلغى {{count}} فحص لم يبدأ. تبقى الفحوصات المنتهية.",
emptyTitle: "لا توجد قواعد مجموعات بعد",
emptyBody: "يُعدّها المالك أو المسؤول. ثم تظهر فحوصاتها في صفحة العمل مثل أي فحص آخر.",
emptyBodyAdmin: "أضف قاعدتك الأولى لفحص مجموعة كاملة من الأصول بجدول واحد.",
foldedRow_zero: "{{name}} · لا أصول",
foldedRow_one: "{{name}} · أصل واحد",
foldedRow_two: "{{name}} · أصلان",
foldedRow_few: "{{name}} · {{count}} أصول",
foldedRow_many: "{{name}} · {{count}} أصلًا",
foldedRow_other: "{{name}} · {{count}} أصل",
},
rounds: {
title: "بدء جولة",
intro: "عمل واحد يمرّ على الأماكن والعناصر داخل {{place}}. لكل محطة قائمة تحقق خاصة بها.",
stopsLabel: "المحطات",
stopCount_zero: "لا محطات",
stopCount_one: "محطة واحدة",
stopCount_two: "محطتان",
stopCount_few: "{{count}} محطات",
stopCount_many: "{{count}} محطة",
stopCount_other: "{{count}} محطة",
all: "الكل",
none: "لا شيء",
loading: "جارٍ قراءة ما في الداخل…",
tooMany: "يمكن أن تضم الجولة {{max}} محطة على الأكثر. ألغِ تحديد بعضها.",
titleLabel: "اسم الجولة",
defaultTitle: "جولة {{checklist}}: {{place}}",
dateLabel: "التاريخ (اختياري)",
dateHint: "YYYY-MM-DD. اتركه فارغًا لتخطيطها لاحقًا.",
description_zero: "جولة بلا محطات في {{place}}.",
description_one: "جولة من محطة واحدة في {{place}}.",
description_two: "جولة من محطتين في {{place}}.",
description_few: "جولة من {{count}} محطات في {{place}}.",
description_many: "جولة من {{count}} محطة في {{place}}.",
description_other: "جولة من {{count}} محطة في {{place}}.",
create_zero: "بدء الجولة",
create_one: "بدء جولة بمحطة واحدة",
create_two: "بدء جولة بمحطتين",
create_few: "بدء جولة بـ{{count}} محطات",
create_many: "بدء جولة بـ{{count}} محطة",
create_other: "بدء جولة بـ{{count}} محطة",
created_zero: "بدأت الجولة",
created_one: "بدأت جولة بمحطة واحدة",
created_two: "بدأت جولة بمحطتين",
created_few: "بدأت جولة بـ{{count}} محطات",
created_many: "بدأت جولة بـ{{count}} محطة",
created_other: "بدأت جولة بـ{{count}} محطة",
failedTitle: "تعذّر بدء الجولة",
failedBody: "لم يُنشأ شيء. تحقّق من الاتصال وحاول مرة أخرى.",
emptyTitle: "لا شيء للزيارة هنا",
emptyBody: "أضف أماكن أو معدّات داخل هذا المكان أولًا، أو غيّر عوامل التصفية.",
},
};
